import { p as proxyCustomElement, H, c as createEvent, h } from './p-BJEvNVLM.js';
import { i as isNodeEnvironment, g as global$1, b as bem, n as nextTick, h as hasNamedSlot } from './p-g1JgJ7wn.js';
import { t as transformTagName, r as resolveAppearance } from './p-CkrRd9Ud.js';
import { t as tippy } from './p-365bzS87.js';
import { F as FormField } from './p-P_M9P1K3.js';
import { g as getAriaRequired, b as getAriaInvalid, d as getAriaExpanded, c as getAriaDisabled, a as getAriaDescribedBy } from './p-BLj-uRqX.js';
import { d as defineCustomElement$b } from './p-Dg3cLMCn.js';
import { d as defineCustomElement$a } from './p-B77_NHv6.js';
import { d as defineCustomElement$9 } from './p-DM62vhwv.js';
import { d as defineCustomElement$8 } from './p-CAeRxjul.js';
import { d as defineCustomElement$7 } from './p-COoxk1Ir.js';
import { d as defineCustomElement$6 } from './p-ODoCtssu.js';
import { d as defineCustomElement$5 } from './p-DOvrJck5.js';
import { d as defineCustomElement$4 } from './p-BvfBQm0c.js';
import { d as defineCustomElement$3 } from './p-HrLUFnJX.js';
import { d as defineCustomElement$2 } from './p-BMLmP8GU.js';

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var lib$1 = {exports: {}};

var _default$1 = {};

var lib = {exports: {}};

var _default = {};

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var hasRequired_default$1;

function require_default$1 () {
	if (hasRequired_default$1) return _default;
	hasRequired_default$1 = 1;
	function getDefaultWhiteList () {
	  // 白名单值说明：
	  // true: 允许该属性
	  // Function: function (val) { } 返回true表示允许该属性，其他值均表示不允许
	  // RegExp: regexp.test(val) 返回true表示允许该属性，其他值均表示不允许
	  // 除上面列出的值外均表示不允许
	  var whiteList = {};

	  whiteList['align-content'] = false; // default: auto
	  whiteList['align-items'] = false; // default: auto
	  whiteList['align-self'] = false; // default: auto
	  whiteList['alignment-adjust'] = false; // default: auto
	  whiteList['alignment-baseline'] = false; // default: baseline
	  whiteList['all'] = false; // default: depending on individual properties
	  whiteList['anchor-point'] = false; // default: none
	  whiteList['animation'] = false; // default: depending on individual properties
	  whiteList['animation-delay'] = false; // default: 0
	  whiteList['animation-direction'] = false; // default: normal
	  whiteList['animation-duration'] = false; // default: 0
	  whiteList['animation-fill-mode'] = false; // default: none
	  whiteList['animation-iteration-count'] = false; // default: 1
	  whiteList['animation-name'] = false; // default: none
	  whiteList['animation-play-state'] = false; // default: running
	  whiteList['animation-timing-function'] = false; // default: ease
	  whiteList['azimuth'] = false; // default: center
	  whiteList['backface-visibility'] = false; // default: visible
	  whiteList['background'] = true; // default: depending on individual properties
	  whiteList['background-attachment'] = true; // default: scroll
	  whiteList['background-clip'] = true; // default: border-box
	  whiteList['background-color'] = true; // default: transparent
	  whiteList['background-image'] = true; // default: none
	  whiteList['background-origin'] = true; // default: padding-box
	  whiteList['background-position'] = true; // default: 0% 0%
	  whiteList['background-repeat'] = true; // default: repeat
	  whiteList['background-size'] = true; // default: auto
	  whiteList['baseline-shift'] = false; // default: baseline
	  whiteList['binding'] = false; // default: none
	  whiteList['bleed'] = false; // default: 6pt
	  whiteList['bookmark-label'] = false; // default: content()
	  whiteList['bookmark-level'] = false; // default: none
	  whiteList['bookmark-state'] = false; // default: open
	  whiteList['border'] = true; // default: depending on individual properties
	  whiteList['border-bottom'] = true; // default: depending on individual properties
	  whiteList['border-bottom-color'] = true; // default: current color
	  whiteList['border-bottom-left-radius'] = true; // default: 0
	  whiteList['border-bottom-right-radius'] = true; // default: 0
	  whiteList['border-bottom-style'] = true; // default: none
	  whiteList['border-bottom-width'] = true; // default: medium
	  whiteList['border-collapse'] = true; // default: separate
	  whiteList['border-color'] = true; // default: depending on individual properties
	  whiteList['border-image'] = true; // default: none
	  whiteList['border-image-outset'] = true; // default: 0
	  whiteList['border-image-repeat'] = true; // default: stretch
	  whiteList['border-image-slice'] = true; // default: 100%
	  whiteList['border-image-source'] = true; // default: none
	  whiteList['border-image-width'] = true; // default: 1
	  whiteList['border-left'] = true; // default: depending on individual properties
	  whiteList['border-left-color'] = true; // default: current color
	  whiteList['border-left-style'] = true; // default: none
	  whiteList['border-left-width'] = true; // default: medium
	  whiteList['border-radius'] = true; // default: 0
	  whiteList['border-right'] = true; // default: depending on individual properties
	  whiteList['border-right-color'] = true; // default: current color
	  whiteList['border-right-style'] = true; // default: none
	  whiteList['border-right-width'] = true; // default: medium
	  whiteList['border-spacing'] = true; // default: 0
	  whiteList['border-style'] = true; // default: depending on individual properties
	  whiteList['border-top'] = true; // default: depending on individual properties
	  whiteList['border-top-color'] = true; // default: current color
	  whiteList['border-top-left-radius'] = true; // default: 0
	  whiteList['border-top-right-radius'] = true; // default: 0
	  whiteList['border-top-style'] = true; // default: none
	  whiteList['border-top-width'] = true; // default: medium
	  whiteList['border-width'] = true; // default: depending on individual properties
	  whiteList['bottom'] = false; // default: auto
	  whiteList['box-decoration-break'] = true; // default: slice
	  whiteList['box-shadow'] = true; // default: none
	  whiteList['box-sizing'] = true; // default: content-box
	  whiteList['box-snap'] = true; // default: none
	  whiteList['box-suppress'] = true; // default: show
	  whiteList['break-after'] = true; // default: auto
	  whiteList['break-before'] = true; // default: auto
	  whiteList['break-inside'] = true; // default: auto
	  whiteList['caption-side'] = false; // default: top
	  whiteList['chains'] = false; // default: none
	  whiteList['clear'] = true; // default: none
	  whiteList['clip'] = false; // default: auto
	  whiteList['clip-path'] = false; // default: none
	  whiteList['clip-rule'] = false; // default: nonzero
	  whiteList['color'] = true; // default: implementation dependent
	  whiteList['color-interpolation-filters'] = true; // default: auto
	  whiteList['column-count'] = false; // default: auto
	  whiteList['column-fill'] = false; // default: balance
	  whiteList['column-gap'] = false; // default: normal
	  whiteList['column-rule'] = false; // default: depending on individual properties
	  whiteList['column-rule-color'] = false; // default: current color
	  whiteList['column-rule-style'] = false; // default: medium
	  whiteList['column-rule-width'] = false; // default: medium
	  whiteList['column-span'] = false; // default: none
	  whiteList['column-width'] = false; // default: auto
	  whiteList['columns'] = false; // default: depending on individual properties
	  whiteList['contain'] = false; // default: none
	  whiteList['content'] = false; // default: normal
	  whiteList['counter-increment'] = false; // default: none
	  whiteList['counter-reset'] = false; // default: none
	  whiteList['counter-set'] = false; // default: none
	  whiteList['crop'] = false; // default: auto
	  whiteList['cue'] = false; // default: depending on individual properties
	  whiteList['cue-after'] = false; // default: none
	  whiteList['cue-before'] = false; // default: none
	  whiteList['cursor'] = false; // default: auto
	  whiteList['direction'] = false; // default: ltr
	  whiteList['display'] = true; // default: depending on individual properties
	  whiteList['display-inside'] = true; // default: auto
	  whiteList['display-list'] = true; // default: none
	  whiteList['display-outside'] = true; // default: inline-level
	  whiteList['dominant-baseline'] = false; // default: auto
	  whiteList['elevation'] = false; // default: level
	  whiteList['empty-cells'] = false; // default: show
	  whiteList['filter'] = false; // default: none
	  whiteList['flex'] = false; // default: depending on individual properties
	  whiteList['flex-basis'] = false; // default: auto
	  whiteList['flex-direction'] = false; // default: row
	  whiteList['flex-flow'] = false; // default: depending on individual properties
	  whiteList['flex-grow'] = false; // default: 0
	  whiteList['flex-shrink'] = false; // default: 1
	  whiteList['flex-wrap'] = false; // default: nowrap
	  whiteList['float'] = false; // default: none
	  whiteList['float-offset'] = false; // default: 0 0
	  whiteList['flood-color'] = false; // default: black
	  whiteList['flood-opacity'] = false; // default: 1
	  whiteList['flow-from'] = false; // default: none
	  whiteList['flow-into'] = false; // default: none
	  whiteList['font'] = true; // default: depending on individual properties
	  whiteList['font-family'] = true; // default: implementation dependent
	  whiteList['font-feature-settings'] = true; // default: normal
	  whiteList['font-kerning'] = true; // default: auto
	  whiteList['font-language-override'] = true; // default: normal
	  whiteList['font-size'] = true; // default: medium
	  whiteList['font-size-adjust'] = true; // default: none
	  whiteList['font-stretch'] = true; // default: normal
	  whiteList['font-style'] = true; // default: normal
	  whiteList['font-synthesis'] = true; // default: weight style
	  whiteList['font-variant'] = true; // default: normal
	  whiteList['font-variant-alternates'] = true; // default: normal
	  whiteList['font-variant-caps'] = true; // default: normal
	  whiteList['font-variant-east-asian'] = true; // default: normal
	  whiteList['font-variant-ligatures'] = true; // default: normal
	  whiteList['font-variant-numeric'] = true; // default: normal
	  whiteList['font-variant-position'] = true; // default: normal
	  whiteList['font-weight'] = true; // default: normal
	  whiteList['grid'] = false; // default: depending on individual properties
	  whiteList['grid-area'] = false; // default: depending on individual properties
	  whiteList['grid-auto-columns'] = false; // default: auto
	  whiteList['grid-auto-flow'] = false; // default: none
	  whiteList['grid-auto-rows'] = false; // default: auto
	  whiteList['grid-column'] = false; // default: depending on individual properties
	  whiteList['grid-column-end'] = false; // default: auto
	  whiteList['grid-column-start'] = false; // default: auto
	  whiteList['grid-row'] = false; // default: depending on individual properties
	  whiteList['grid-row-end'] = false; // default: auto
	  whiteList['grid-row-start'] = false; // default: auto
	  whiteList['grid-template'] = false; // default: depending on individual properties
	  whiteList['grid-template-areas'] = false; // default: none
	  whiteList['grid-template-columns'] = false; // default: none
	  whiteList['grid-template-rows'] = false; // default: none
	  whiteList['hanging-punctuation'] = false; // default: none
	  whiteList['height'] = true; // default: auto
	  whiteList['hyphens'] = false; // default: manual
	  whiteList['icon'] = false; // default: auto
	  whiteList['image-orientation'] = false; // default: auto
	  whiteList['image-resolution'] = false; // default: normal
	  whiteList['ime-mode'] = false; // default: auto
	  whiteList['initial-letters'] = false; // default: normal
	  whiteList['inline-box-align'] = false; // default: last
	  whiteList['justify-content'] = false; // default: auto
	  whiteList['justify-items'] = false; // default: auto
	  whiteList['justify-self'] = false; // default: auto
	  whiteList['left'] = false; // default: auto
	  whiteList['letter-spacing'] = true; // default: normal
	  whiteList['lighting-color'] = true; // default: white
	  whiteList['line-box-contain'] = false; // default: block inline replaced
	  whiteList['line-break'] = false; // default: auto
	  whiteList['line-grid'] = false; // default: match-parent
	  whiteList['line-height'] = false; // default: normal
	  whiteList['line-snap'] = false; // default: none
	  whiteList['line-stacking'] = false; // default: depending on individual properties
	  whiteList['line-stacking-ruby'] = false; // default: exclude-ruby
	  whiteList['line-stacking-shift'] = false; // default: consider-shifts
	  whiteList['line-stacking-strategy'] = false; // default: inline-line-height
	  whiteList['list-style'] = true; // default: depending on individual properties
	  whiteList['list-style-image'] = true; // default: none
	  whiteList['list-style-position'] = true; // default: outside
	  whiteList['list-style-type'] = true; // default: disc
	  whiteList['margin'] = true; // default: depending on individual properties
	  whiteList['margin-bottom'] = true; // default: 0
	  whiteList['margin-left'] = true; // default: 0
	  whiteList['margin-right'] = true; // default: 0
	  whiteList['margin-top'] = true; // default: 0
	  whiteList['marker-offset'] = false; // default: auto
	  whiteList['marker-side'] = false; // default: list-item
	  whiteList['marks'] = false; // default: none
	  whiteList['mask'] = false; // default: border-box
	  whiteList['mask-box'] = false; // default: see individual properties
	  whiteList['mask-box-outset'] = false; // default: 0
	  whiteList['mask-box-repeat'] = false; // default: stretch
	  whiteList['mask-box-slice'] = false; // default: 0 fill
	  whiteList['mask-box-source'] = false; // default: none
	  whiteList['mask-box-width'] = false; // default: auto
	  whiteList['mask-clip'] = false; // default: border-box
	  whiteList['mask-image'] = false; // default: none
	  whiteList['mask-origin'] = false; // default: border-box
	  whiteList['mask-position'] = false; // default: center
	  whiteList['mask-repeat'] = false; // default: no-repeat
	  whiteList['mask-size'] = false; // default: border-box
	  whiteList['mask-source-type'] = false; // default: auto
	  whiteList['mask-type'] = false; // default: luminance
	  whiteList['max-height'] = true; // default: none
	  whiteList['max-lines'] = false; // default: none
	  whiteList['max-width'] = true; // default: none
	  whiteList['min-height'] = true; // default: 0
	  whiteList['min-width'] = true; // default: 0
	  whiteList['move-to'] = false; // default: normal
	  whiteList['nav-down'] = false; // default: auto
	  whiteList['nav-index'] = false; // default: auto
	  whiteList['nav-left'] = false; // default: auto
	  whiteList['nav-right'] = false; // default: auto
	  whiteList['nav-up'] = false; // default: auto
	  whiteList['object-fit'] = false; // default: fill
	  whiteList['object-position'] = false; // default: 50% 50%
	  whiteList['opacity'] = false; // default: 1
	  whiteList['order'] = false; // default: 0
	  whiteList['orphans'] = false; // default: 2
	  whiteList['outline'] = false; // default: depending on individual properties
	  whiteList['outline-color'] = false; // default: invert
	  whiteList['outline-offset'] = false; // default: 0
	  whiteList['outline-style'] = false; // default: none
	  whiteList['outline-width'] = false; // default: medium
	  whiteList['overflow'] = false; // default: depending on individual properties
	  whiteList['overflow-wrap'] = false; // default: normal
	  whiteList['overflow-x'] = false; // default: visible
	  whiteList['overflow-y'] = false; // default: visible
	  whiteList['padding'] = true; // default: depending on individual properties
	  whiteList['padding-bottom'] = true; // default: 0
	  whiteList['padding-left'] = true; // default: 0
	  whiteList['padding-right'] = true; // default: 0
	  whiteList['padding-top'] = true; // default: 0
	  whiteList['page'] = false; // default: auto
	  whiteList['page-break-after'] = false; // default: auto
	  whiteList['page-break-before'] = false; // default: auto
	  whiteList['page-break-inside'] = false; // default: auto
	  whiteList['page-policy'] = false; // default: start
	  whiteList['pause'] = false; // default: implementation dependent
	  whiteList['pause-after'] = false; // default: implementation dependent
	  whiteList['pause-before'] = false; // default: implementation dependent
	  whiteList['perspective'] = false; // default: none
	  whiteList['perspective-origin'] = false; // default: 50% 50%
	  whiteList['pitch'] = false; // default: medium
	  whiteList['pitch-range'] = false; // default: 50
	  whiteList['play-during'] = false; // default: auto
	  whiteList['position'] = false; // default: static
	  whiteList['presentation-level'] = false; // default: 0
	  whiteList['quotes'] = false; // default: text
	  whiteList['region-fragment'] = false; // default: auto
	  whiteList['resize'] = false; // default: none
	  whiteList['rest'] = false; // default: depending on individual properties
	  whiteList['rest-after'] = false; // default: none
	  whiteList['rest-before'] = false; // default: none
	  whiteList['richness'] = false; // default: 50
	  whiteList['right'] = false; // default: auto
	  whiteList['rotation'] = false; // default: 0
	  whiteList['rotation-point'] = false; // default: 50% 50%
	  whiteList['ruby-align'] = false; // default: auto
	  whiteList['ruby-merge'] = false; // default: separate
	  whiteList['ruby-position'] = false; // default: before
	  whiteList['shape-image-threshold'] = false; // default: 0.0
	  whiteList['shape-outside'] = false; // default: none
	  whiteList['shape-margin'] = false; // default: 0
	  whiteList['size'] = false; // default: auto
	  whiteList['speak'] = false; // default: auto
	  whiteList['speak-as'] = false; // default: normal
	  whiteList['speak-header'] = false; // default: once
	  whiteList['speak-numeral'] = false; // default: continuous
	  whiteList['speak-punctuation'] = false; // default: none
	  whiteList['speech-rate'] = false; // default: medium
	  whiteList['stress'] = false; // default: 50
	  whiteList['string-set'] = false; // default: none
	  whiteList['tab-size'] = false; // default: 8
	  whiteList['table-layout'] = false; // default: auto
	  whiteList['text-align'] = true; // default: start
	  whiteList['text-align-last'] = true; // default: auto
	  whiteList['text-combine-upright'] = true; // default: none
	  whiteList['text-decoration'] = true; // default: none
	  whiteList['text-decoration-color'] = true; // default: currentColor
	  whiteList['text-decoration-line'] = true; // default: none
	  whiteList['text-decoration-skip'] = true; // default: objects
	  whiteList['text-decoration-style'] = true; // default: solid
	  whiteList['text-emphasis'] = true; // default: depending on individual properties
	  whiteList['text-emphasis-color'] = true; // default: currentColor
	  whiteList['text-emphasis-position'] = true; // default: over right
	  whiteList['text-emphasis-style'] = true; // default: none
	  whiteList['text-height'] = true; // default: auto
	  whiteList['text-indent'] = true; // default: 0
	  whiteList['text-justify'] = true; // default: auto
	  whiteList['text-orientation'] = true; // default: mixed
	  whiteList['text-overflow'] = true; // default: clip
	  whiteList['text-shadow'] = true; // default: none
	  whiteList['text-space-collapse'] = true; // default: collapse
	  whiteList['text-transform'] = true; // default: none
	  whiteList['text-underline-position'] = true; // default: auto
	  whiteList['text-wrap'] = true; // default: normal
	  whiteList['top'] = false; // default: auto
	  whiteList['transform'] = false; // default: none
	  whiteList['transform-origin'] = false; // default: 50% 50% 0
	  whiteList['transform-style'] = false; // default: flat
	  whiteList['transition'] = false; // default: depending on individual properties
	  whiteList['transition-delay'] = false; // default: 0s
	  whiteList['transition-duration'] = false; // default: 0s
	  whiteList['transition-property'] = false; // default: all
	  whiteList['transition-timing-function'] = false; // default: ease
	  whiteList['unicode-bidi'] = false; // default: normal
	  whiteList['vertical-align'] = false; // default: baseline
	  whiteList['visibility'] = false; // default: visible
	  whiteList['voice-balance'] = false; // default: center
	  whiteList['voice-duration'] = false; // default: auto
	  whiteList['voice-family'] = false; // default: implementation dependent
	  whiteList['voice-pitch'] = false; // default: medium
	  whiteList['voice-range'] = false; // default: medium
	  whiteList['voice-rate'] = false; // default: normal
	  whiteList['voice-stress'] = false; // default: normal
	  whiteList['voice-volume'] = false; // default: medium
	  whiteList['volume'] = false; // default: medium
	  whiteList['white-space'] = false; // default: normal
	  whiteList['widows'] = false; // default: 2
	  whiteList['width'] = true; // default: auto
	  whiteList['will-change'] = false; // default: auto
	  whiteList['word-break'] = true; // default: normal
	  whiteList['word-spacing'] = true; // default: normal
	  whiteList['word-wrap'] = true; // default: normal
	  whiteList['wrap-flow'] = false; // default: auto
	  whiteList['wrap-through'] = false; // default: wrap
	  whiteList['writing-mode'] = false; // default: horizontal-tb
	  whiteList['z-index'] = false; // default: auto

	  return whiteList;
	}


	/**
	 * 匹配到白名单上的一个属性时
	 *
	 * @param {String} name
	 * @param {String} value
	 * @param {Object} options
	 * @return {String}
	 */
	function onAttr (name, value, options) {
	  // do nothing
	}

	/**
	 * 匹配到不在白名单上的一个属性时
	 *
	 * @param {String} name
	 * @param {String} value
	 * @param {Object} options
	 * @return {String}
	 */
	function onIgnoreAttr (name, value, options) {
	  // do nothing
	}

	var REGEXP_URL_JAVASCRIPT = /javascript\s*\:/img;

	/**
	 * 过滤属性值
	 *
	 * @param {String} name
	 * @param {String} value
	 * @return {String}
	 */
	function safeAttrValue(name, value) {
	  if (REGEXP_URL_JAVASCRIPT.test(value)) return '';
	  return value;
	}


	_default.whiteList = getDefaultWhiteList();
	_default.getDefaultWhiteList = getDefaultWhiteList;
	_default.onAttr = onAttr;
	_default.onIgnoreAttr = onIgnoreAttr;
	_default.safeAttrValue = safeAttrValue;
	return _default;
}

var util$1;
var hasRequiredUtil$1;

function requireUtil$1 () {
	if (hasRequiredUtil$1) return util$1;
	hasRequiredUtil$1 = 1;
	util$1 = {
	  indexOf: function (arr, item) {
	    var i, j;
	    if (Array.prototype.indexOf) {
	      return arr.indexOf(item);
	    }
	    for (i = 0, j = arr.length; i < j; i++) {
	      if (arr[i] === item) {
	        return i;
	      }
	    }
	    return -1;
	  },
	  forEach: function (arr, fn, scope) {
	    var i, j;
	    if (Array.prototype.forEach) {
	      return arr.forEach(fn, scope);
	    }
	    for (i = 0, j = arr.length; i < j; i++) {
	      fn.call(scope, arr[i], i, arr);
	    }
	  },
	  trim: function (str) {
	    if (String.prototype.trim) {
	      return str.trim();
	    }
	    return str.replace(/(^\s*)|(\s*$)/g, '');
	  },
	  trimRight: function (str) {
	    if (String.prototype.trimRight) {
	      return str.trimRight();
	    }
	    return str.replace(/(\s*$)/g, '');
	  }
	};
	return util$1;
}

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var parser$1;
var hasRequiredParser$1;

function requireParser$1 () {
	if (hasRequiredParser$1) return parser$1;
	hasRequiredParser$1 = 1;
	var _ = requireUtil$1();


	/**
	 * 解析style
	 *
	 * @param {String} css
	 * @param {Function} onAttr 处理属性的函数
	 *   参数格式： function (sourcePosition, position, name, value, source)
	 * @return {String}
	 */
	function parseStyle (css, onAttr) {
	  css = _.trimRight(css);
	  if (css[css.length - 1] !== ';') css += ';';
	  var cssLength = css.length;
	  var isParenthesisOpen = false;
	  var lastPos = 0;
	  var i = 0;
	  var retCSS = '';

	  function addNewAttr () {
	    // 如果没有正常的闭合圆括号，则直接忽略当前属性
	    if (!isParenthesisOpen) {
	      var source = _.trim(css.slice(lastPos, i));
	      var j = source.indexOf(':');
	      if (j !== -1) {
	        var name = _.trim(source.slice(0, j));
	        var value = _.trim(source.slice(j + 1));
	        // 必须有属性名称
	        if (name) {
	          var ret = onAttr(lastPos, retCSS.length, name, value, source);
	          if (ret) retCSS += ret + '; ';
	        }
	      }
	    }
	    lastPos = i + 1;
	  }

	  for (; i < cssLength; i++) {
	    var c = css[i];
	    if (c === '/' && css[i + 1] === '*') {
	      // 备注开始
	      var j = css.indexOf('*/', i + 2);
	      // 如果没有正常的备注结束，则后面的部分全部跳过
	      if (j === -1) break;
	      // 直接将当前位置调到备注结尾，并且初始化状态
	      i = j + 1;
	      lastPos = i + 1;
	      isParenthesisOpen = false;
	    } else if (c === '(') {
	      isParenthesisOpen = true;
	    } else if (c === ')') {
	      isParenthesisOpen = false;
	    } else if (c === ';') {
	      if (isParenthesisOpen) ; else {
	        addNewAttr();
	      }
	    } else if (c === '\n') {
	      addNewAttr();
	    }
	  }

	  return _.trim(retCSS);
	}

	parser$1 = parseStyle;
	return parser$1;
}

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var css;
var hasRequiredCss;

function requireCss () {
	if (hasRequiredCss) return css;
	hasRequiredCss = 1;
	var DEFAULT = require_default$1();
	var parseStyle = requireParser$1();
	requireUtil$1();


	/**
	 * 返回值是否为空
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 */
	function isNull (obj) {
	  return (obj === undefined || obj === null);
	}

	/**
	 * 浅拷贝对象
	 *
	 * @param {Object} obj
	 * @return {Object}
	 */
	function shallowCopyObject (obj) {
	  var ret = {};
	  for (var i in obj) {
	    ret[i] = obj[i];
	  }
	  return ret;
	}

	/**
	 * 创建CSS过滤器
	 *
	 * @param {Object} options
	 *   - {Object} whiteList
	 *   - {Function} onAttr
	 *   - {Function} onIgnoreAttr
	 *   - {Function} safeAttrValue
	 */
	function FilterCSS (options) {
	  options = shallowCopyObject(options || {});
	  options.whiteList = options.whiteList || DEFAULT.whiteList;
	  options.onAttr = options.onAttr || DEFAULT.onAttr;
	  options.onIgnoreAttr = options.onIgnoreAttr || DEFAULT.onIgnoreAttr;
	  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
	  this.options = options;
	}

	FilterCSS.prototype.process = function (css) {
	  // 兼容各种奇葩输入
	  css = css || '';
	  css = css.toString();
	  if (!css) return '';

	  var me = this;
	  var options = me.options;
	  var whiteList = options.whiteList;
	  var onAttr = options.onAttr;
	  var onIgnoreAttr = options.onIgnoreAttr;
	  var safeAttrValue = options.safeAttrValue;

	  var retCSS = parseStyle(css, function (sourcePosition, position, name, value, source) {

	    var check = whiteList[name];
	    var isWhite = false;
	    if (check === true) isWhite = check;
	    else if (typeof check === 'function') isWhite = check(value);
	    else if (check instanceof RegExp) isWhite = check.test(value);
	    if (isWhite !== true) isWhite = false;

	    // 如果过滤后 value 为空则直接忽略
	    value = safeAttrValue(name, value);
	    if (!value) return;

	    var opts = {
	      position: position,
	      sourcePosition: sourcePosition,
	      source: source,
	      isWhite: isWhite
	    };

	    if (isWhite) {

	      var ret = onAttr(name, value, opts);
	      if (isNull(ret)) {
	        return name + ':' + value;
	      } else {
	        return ret;
	      }

	    } else {

	      var ret = onIgnoreAttr(name, value, opts);
	      if (!isNull(ret)) {
	        return ret;
	      }

	    }
	  });

	  return retCSS;
	};


	css = FilterCSS;
	return css;
}

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var hasRequiredLib$1;

function requireLib$1 () {
	if (hasRequiredLib$1) return lib.exports;
	hasRequiredLib$1 = 1;
	(function (module, exports) {
		var DEFAULT = require_default$1();
		var FilterCSS = requireCss();


		/**
		 * XSS过滤
		 *
		 * @param {String} css 要过滤的CSS代码
		 * @param {Object} options 选项：whiteList, onAttr, onIgnoreAttr
		 * @return {String}
		 */
		function filterCSS (html, options) {
		  var xss = new FilterCSS(options);
		  return xss.process(html);
		}


		// 输出
		exports = module.exports = filterCSS;
		exports.FilterCSS = FilterCSS;
		for (var i in DEFAULT) exports[i] = DEFAULT[i];

		// 在浏览器端使用
		if (typeof window !== 'undefined') {
		  window.filterCSS = module.exports;
		} 
	} (lib, lib.exports));
	return lib.exports;
}

var util;
var hasRequiredUtil;

function requireUtil () {
	if (hasRequiredUtil) return util;
	hasRequiredUtil = 1;
	util = {
	  indexOf: function (arr, item) {
	    var i, j;
	    if (Array.prototype.indexOf) {
	      return arr.indexOf(item);
	    }
	    for (i = 0, j = arr.length; i < j; i++) {
	      if (arr[i] === item) {
	        return i;
	      }
	    }
	    return -1;
	  },
	  forEach: function (arr, fn, scope) {
	    var i, j;
	    if (Array.prototype.forEach) {
	      return arr.forEach(fn, scope);
	    }
	    for (i = 0, j = arr.length; i < j; i++) {
	      fn.call(scope, arr[i], i, arr);
	    }
	  },
	  trim: function (str) {
	    if (String.prototype.trim) {
	      return str.trim();
	    }
	    return str.replace(/(^\s*)|(\s*$)/g, "");
	  },
	  spaceIndex: function (str) {
	    var reg = /\s|\n|\t/;
	    var match = reg.exec(str);
	    return match ? match.index : -1;
	  },
	};
	return util;
}

/**
 * default settings
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var hasRequired_default;

function require_default () {
	if (hasRequired_default) return _default$1;
	hasRequired_default = 1;
	var FilterCSS = requireLib$1().FilterCSS;
	var getDefaultCSSWhiteList = requireLib$1().getDefaultWhiteList;
	var _ = requireUtil();

	function getDefaultWhiteList() {
	  return {
	    a: ["target", "href", "title"],
	    abbr: ["title"],
	    address: [],
	    area: ["shape", "coords", "href", "alt"],
	    article: [],
	    aside: [],
	    audio: [
	      "autoplay",
	      "controls",
	      "crossorigin",
	      "loop",
	      "muted",
	      "preload",
	      "src",
	    ],
	    b: [],
	    bdi: ["dir"],
	    bdo: ["dir"],
	    big: [],
	    blockquote: ["cite"],
	    br: [],
	    caption: [],
	    center: [],
	    cite: [],
	    code: [],
	    col: ["align", "valign", "span", "width"],
	    colgroup: ["align", "valign", "span", "width"],
	    dd: [],
	    del: ["datetime"],
	    details: ["open"],
	    div: [],
	    dl: [],
	    dt: [],
	    em: [],
	    figcaption: [],
	    figure: [],
	    font: ["color", "size", "face"],
	    footer: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    header: [],
	    hr: [],
	    i: [],
	    img: ["src", "alt", "title", "width", "height", "loading"],
	    ins: ["datetime"],
	    kbd: [],
	    li: [],
	    mark: [],
	    nav: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    section: [],
	    small: [],
	    span: [],
	    sub: [],
	    summary: [],
	    sup: [],
	    strong: [],
	    strike: [],
	    table: ["width", "border", "align", "valign"],
	    tbody: ["align", "valign"],
	    td: ["width", "rowspan", "colspan", "align", "valign"],
	    tfoot: ["align", "valign"],
	    th: ["width", "rowspan", "colspan", "align", "valign"],
	    thead: ["align", "valign"],
	    tr: ["rowspan", "align", "valign"],
	    tt: [],
	    u: [],
	    ul: [],
	    video: [
	      "autoplay",
	      "controls",
	      "crossorigin",
	      "loop",
	      "muted",
	      "playsinline",
	      "poster",
	      "preload",
	      "src",
	      "height",
	      "width",
	    ],
	  };
	}

	var defaultCSSFilter = new FilterCSS();

	/**
	 * default onTag function
	 *
	 * @param {String} tag
	 * @param {String} html
	 * @param {Object} options
	 * @return {String}
	 */
	function onTag(tag, html, options) {
	  // do nothing
	}

	/**
	 * default onIgnoreTag function
	 *
	 * @param {String} tag
	 * @param {String} html
	 * @param {Object} options
	 * @return {String}
	 */
	function onIgnoreTag(tag, html, options) {
	  // do nothing
	}

	/**
	 * default onTagAttr function
	 *
	 * @param {String} tag
	 * @param {String} name
	 * @param {String} value
	 * @return {String}
	 */
	function onTagAttr(tag, name, value) {
	  // do nothing
	}

	/**
	 * default onIgnoreTagAttr function
	 *
	 * @param {String} tag
	 * @param {String} name
	 * @param {String} value
	 * @return {String}
	 */
	function onIgnoreTagAttr(tag, name, value) {
	  // do nothing
	}

	/**
	 * default escapeHtml function
	 *
	 * @param {String} html
	 */
	function escapeHtml(html) {
	  return html.replace(REGEXP_LT, "&lt;").replace(REGEXP_GT, "&gt;");
	}

	/**
	 * default safeAttrValue function
	 *
	 * @param {String} tag
	 * @param {String} name
	 * @param {String} value
	 * @param {Object} cssFilter
	 * @return {String}
	 */
	function safeAttrValue(tag, name, value, cssFilter) {
	  // unescape attribute value firstly
	  value = friendlyAttrValue(value);

	  if (name === "href" || name === "src") {
	    // filter `href` and `src` attribute
	    // only allow the value that starts with `http://` | `https://` | `mailto:` | `/` | `#`
	    value = _.trim(value);
	    if (value === "#") return "#";
	    if (
	      !(
	        value.substr(0, 7) === "http://" ||
	        value.substr(0, 8) === "https://" ||
	        value.substr(0, 7) === "mailto:" ||
	        value.substr(0, 4) === "tel:" ||
	        value.substr(0, 11) === "data:image/" ||
	        value.substr(0, 6) === "ftp://" ||
	        value.substr(0, 2) === "./" ||
	        value.substr(0, 3) === "../" ||
	        value[0] === "#" ||
	        value[0] === "/"
	      )
	    ) {
	      return "";
	    }
	  } else if (name === "background") {
	    // filter `background` attribute (maybe no use)
	    // `javascript:`
	    REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
	    if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
	      return "";
	    }
	  } else if (name === "style") {
	    // `expression()`
	    REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
	    if (REGEXP_DEFAULT_ON_TAG_ATTR_7.test(value)) {
	      return "";
	    }
	    // `url()`
	    REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
	    if (REGEXP_DEFAULT_ON_TAG_ATTR_8.test(value)) {
	      REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
	      if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
	        return "";
	      }
	    }
	    if (cssFilter !== false) {
	      cssFilter = cssFilter || defaultCSSFilter;
	      value = cssFilter.process(value);
	    }
	  }

	  // escape `<>"` before returns
	  value = escapeAttrValue(value);
	  return value;
	}

	// RegExp list
	var REGEXP_LT = /</g;
	var REGEXP_GT = />/g;
	var REGEXP_QUOTE = /"/g;
	var REGEXP_QUOTE_2 = /&quot;/g;
	var REGEXP_ATTR_VALUE_1 = /&#([a-zA-Z0-9]*);?/gim;
	var REGEXP_ATTR_VALUE_COLON = /&colon;?/gim;
	var REGEXP_ATTR_VALUE_NEWLINE = /&newline;?/gim;
	// var REGEXP_DEFAULT_ON_TAG_ATTR_3 = /\/\*|\*\//gm;
	var REGEXP_DEFAULT_ON_TAG_ATTR_4 =
	  /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi;
	// var REGEXP_DEFAULT_ON_TAG_ATTR_5 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:/gi;
	// var REGEXP_DEFAULT_ON_TAG_ATTR_6 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:\s*image\//gi;
	var REGEXP_DEFAULT_ON_TAG_ATTR_7 =
	  /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi;
	var REGEXP_DEFAULT_ON_TAG_ATTR_8 = /u\s*r\s*l\s*\(.*/gi;

	/**
	 * escape double quote
	 *
	 * @param {String} str
	 * @return {String} str
	 */
	function escapeQuote(str) {
	  return str.replace(REGEXP_QUOTE, "&quot;");
	}

	/**
	 * unescape double quote
	 *
	 * @param {String} str
	 * @return {String} str
	 */
	function unescapeQuote(str) {
	  return str.replace(REGEXP_QUOTE_2, '"');
	}

	/**
	 * escape html entities
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function escapeHtmlEntities(str) {
	  return str.replace(REGEXP_ATTR_VALUE_1, function replaceUnicode(str, code) {
	    return code[0] === "x" || code[0] === "X"
	      ? String.fromCharCode(parseInt(code.substr(1), 16))
	      : String.fromCharCode(parseInt(code, 10));
	  });
	}

	/**
	 * escape html5 new danger entities
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function escapeDangerHtml5Entities(str) {
	  return str
	    .replace(REGEXP_ATTR_VALUE_COLON, ":")
	    .replace(REGEXP_ATTR_VALUE_NEWLINE, " ");
	}

	/**
	 * clear nonprintable characters
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function clearNonPrintableCharacter(str) {
	  var str2 = "";
	  for (var i = 0, len = str.length; i < len; i++) {
	    str2 += str.charCodeAt(i) < 32 ? " " : str.charAt(i);
	  }
	  return _.trim(str2);
	}

	/**
	 * get friendly attribute value
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function friendlyAttrValue(str) {
	  str = unescapeQuote(str);
	  str = escapeHtmlEntities(str);
	  str = escapeDangerHtml5Entities(str);
	  str = clearNonPrintableCharacter(str);
	  return str;
	}

	/**
	 * unescape attribute value
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function escapeAttrValue(str) {
	  str = escapeQuote(str);
	  str = escapeHtml(str);
	  return str;
	}

	/**
	 * `onIgnoreTag` function for removing all the tags that are not in whitelist
	 */
	function onIgnoreTagStripAll() {
	  return "";
	}

	/**
	 * remove tag body
	 * specify a `tags` list, if the tag is not in the `tags` list then process by the specify function (optional)
	 *
	 * @param {array} tags
	 * @param {function} next
	 */
	function StripTagBody(tags, next) {
	  if (typeof next !== "function") {
	    next = function () {};
	  }

	  var isRemoveAllTag = !Array.isArray(tags);
	  function isRemoveTag(tag) {
	    if (isRemoveAllTag) return true;
	    return _.indexOf(tags, tag) !== -1;
	  }

	  var removeList = [];
	  var posStart = false;

	  return {
	    onIgnoreTag: function (tag, html, options) {
	      if (isRemoveTag(tag)) {
	        if (options.isClosing) {
	          var ret = "[/removed]";
	          var end = options.position + ret.length;
	          removeList.push([
	            posStart !== false ? posStart : options.position,
	            end,
	          ]);
	          posStart = false;
	          return ret;
	        } else {
	          if (!posStart) {
	            posStart = options.position;
	          }
	          return "[removed]";
	        }
	      } else {
	        return next(tag, html, options);
	      }
	    },
	    remove: function (html) {
	      var rethtml = "";
	      var lastPos = 0;
	      _.forEach(removeList, function (pos) {
	        rethtml += html.slice(lastPos, pos[0]);
	        lastPos = pos[1];
	      });
	      rethtml += html.slice(lastPos);
	      return rethtml;
	    },
	  };
	}

	/**
	 * remove html comments
	 *
	 * @param {String} html
	 * @return {String}
	 */
	function stripCommentTag(html) {
	  var retHtml = "";
	  var lastPos = 0;
	  while (lastPos < html.length) {
	    var i = html.indexOf("<!--", lastPos);
	    if (i === -1) {
	      retHtml += html.slice(lastPos);
	      break;
	    }
	    retHtml += html.slice(lastPos, i);
	    var j = html.indexOf("-->", i);
	    if (j === -1) {
	      break;
	    }
	    lastPos = j + 3;
	  }
	  return retHtml;
	}

	/**
	 * remove invisible characters
	 *
	 * @param {String} html
	 * @return {String}
	 */
	function stripBlankChar(html) {
	  var chars = html.split("");
	  chars = chars.filter(function (char) {
	    var c = char.charCodeAt(0);
	    if (c === 127) return false;
	    if (c <= 31) {
	      if (c === 10 || c === 13) return true;
	      return false;
	    }
	    return true;
	  });
	  return chars.join("");
	}

	_default$1.whiteList = getDefaultWhiteList();
	_default$1.getDefaultWhiteList = getDefaultWhiteList;
	_default$1.onTag = onTag;
	_default$1.onIgnoreTag = onIgnoreTag;
	_default$1.onTagAttr = onTagAttr;
	_default$1.onIgnoreTagAttr = onIgnoreTagAttr;
	_default$1.safeAttrValue = safeAttrValue;
	_default$1.escapeHtml = escapeHtml;
	_default$1.escapeQuote = escapeQuote;
	_default$1.unescapeQuote = unescapeQuote;
	_default$1.escapeHtmlEntities = escapeHtmlEntities;
	_default$1.escapeDangerHtml5Entities = escapeDangerHtml5Entities;
	_default$1.clearNonPrintableCharacter = clearNonPrintableCharacter;
	_default$1.friendlyAttrValue = friendlyAttrValue;
	_default$1.escapeAttrValue = escapeAttrValue;
	_default$1.onIgnoreTagStripAll = onIgnoreTagStripAll;
	_default$1.StripTagBody = StripTagBody;
	_default$1.stripCommentTag = stripCommentTag;
	_default$1.stripBlankChar = stripBlankChar;
	_default$1.attributeWrapSign = '"';
	_default$1.cssFilter = defaultCSSFilter;
	_default$1.getDefaultCSSWhiteList = getDefaultCSSWhiteList;
	return _default$1;
}

var parser = {};

/**
 * Simple HTML Parser
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var hasRequiredParser;

function requireParser () {
	if (hasRequiredParser) return parser;
	hasRequiredParser = 1;
	var _ = requireUtil();

	/**
	 * get tag name
	 *
	 * @param {String} html e.g. '<a hef="#">'
	 * @return {String}
	 */
	function getTagName(html) {
	  var i = _.spaceIndex(html);
	  var tagName;
	  if (i === -1) {
	    tagName = html.slice(1, -1);
	  } else {
	    tagName = html.slice(1, i + 1);
	  }
	  tagName = _.trim(tagName).toLowerCase();
	  if (tagName.slice(0, 1) === "/") tagName = tagName.slice(1);
	  if (tagName.slice(-1) === "/") tagName = tagName.slice(0, -1);
	  return tagName;
	}

	/**
	 * is close tag?
	 *
	 * @param {String} html 如：'<a hef="#">'
	 * @return {Boolean}
	 */
	function isClosing(html) {
	  return html.slice(0, 2) === "</";
	}

	/**
	 * parse input html and returns processed html
	 *
	 * @param {String} html
	 * @param {Function} onTag e.g. function (sourcePosition, position, tag, html, isClosing)
	 * @param {Function} escapeHtml
	 * @return {String}
	 */
	function parseTag(html, onTag, escapeHtml) {

	  var rethtml = "";
	  var lastPos = 0;
	  var tagStart = false;
	  var quoteStart = false;
	  var currentPos = 0;
	  var len = html.length;
	  var currentTagName = "";
	  var currentHtml = "";

	  chariterator: for (currentPos = 0; currentPos < len; currentPos++) {
	    var c = html.charAt(currentPos);
	    if (tagStart === false) {
	      if (c === "<") {
	        tagStart = currentPos;
	        continue;
	      }
	    } else {
	      if (quoteStart === false) {
	        if (c === "<") {
	          rethtml += escapeHtml(html.slice(lastPos, currentPos));
	          tagStart = currentPos;
	          lastPos = currentPos;
	          continue;
	        }
	        if (c === ">" || currentPos === len - 1) {
	          rethtml += escapeHtml(html.slice(lastPos, tagStart));
	          currentHtml = html.slice(tagStart, currentPos + 1);
	          currentTagName = getTagName(currentHtml);
	          rethtml += onTag(
	            tagStart,
	            rethtml.length,
	            currentTagName,
	            currentHtml,
	            isClosing(currentHtml)
	          );
	          lastPos = currentPos + 1;
	          tagStart = false;
	          continue;
	        }
	        if (c === '"' || c === "'") {
	          var i = 1;
	          var ic = html.charAt(currentPos - i);

	          while (ic.trim() === "" || ic === "=") {
	            if (ic === "=") {
	              quoteStart = c;
	              continue chariterator;
	            }
	            ic = html.charAt(currentPos - ++i);
	          }
	        }
	      } else {
	        if (c === quoteStart) {
	          quoteStart = false;
	          continue;
	        }
	      }
	    }
	  }
	  if (lastPos < len) {
	    rethtml += escapeHtml(html.substr(lastPos));
	  }

	  return rethtml;
	}

	var REGEXP_ILLEGAL_ATTR_NAME = /[^a-zA-Z0-9\\_:.-]/gim;

	/**
	 * parse input attributes and returns processed attributes
	 *
	 * @param {String} html e.g. `href="#" target="_blank"`
	 * @param {Function} onAttr e.g. `function (name, value)`
	 * @return {String}
	 */
	function parseAttr(html, onAttr) {

	  var lastPos = 0;
	  var lastMarkPos = 0;
	  var retAttrs = [];
	  var tmpName = false;
	  var len = html.length;

	  function addAttr(name, value) {
	    name = _.trim(name);
	    name = name.replace(REGEXP_ILLEGAL_ATTR_NAME, "").toLowerCase();
	    if (name.length < 1) return;
	    var ret = onAttr(name, value || "");
	    if (ret) retAttrs.push(ret);
	  }

	  // 逐个分析字符
	  for (var i = 0; i < len; i++) {
	    var c = html.charAt(i);
	    var v, j;
	    if (tmpName === false && c === "=") {
	      tmpName = html.slice(lastPos, i);
	      lastPos = i + 1;
	      lastMarkPos = html.charAt(lastPos) === '"' || html.charAt(lastPos) === "'" ? lastPos : findNextQuotationMark(html, i + 1);
	      continue;
	    }
	    if (tmpName !== false) {
	      if (
	        i === lastMarkPos
	      ) {
	        j = html.indexOf(c, i + 1);
	        if (j === -1) {
	          break;
	        } else {
	          v = _.trim(html.slice(lastMarkPos + 1, j));
	          addAttr(tmpName, v);
	          tmpName = false;
	          i = j;
	          lastPos = i + 1;
	          continue;
	        }
	      }
	    }
	    if (/\s|\n|\t/.test(c)) {
	      html = html.replace(/\s|\n|\t/g, " ");
	      if (tmpName === false) {
	        j = findNextEqual(html, i);
	        if (j === -1) {
	          v = _.trim(html.slice(lastPos, i));
	          addAttr(v);
	          tmpName = false;
	          lastPos = i + 1;
	          continue;
	        } else {
	          i = j - 1;
	          continue;
	        }
	      } else {
	        j = findBeforeEqual(html, i - 1);
	        if (j === -1) {
	          v = _.trim(html.slice(lastPos, i));
	          v = stripQuoteWrap(v);
	          addAttr(tmpName, v);
	          tmpName = false;
	          lastPos = i + 1;
	          continue;
	        } else {
	          continue;
	        }
	      }
	    }
	  }

	  if (lastPos < html.length) {
	    if (tmpName === false) {
	      addAttr(html.slice(lastPos));
	    } else {
	      addAttr(tmpName, stripQuoteWrap(_.trim(html.slice(lastPos))));
	    }
	  }

	  return _.trim(retAttrs.join(" "));
	}

	function findNextEqual(str, i) {
	  for (; i < str.length; i++) {
	    var c = str[i];
	    if (c === " ") continue;
	    if (c === "=") return i;
	    return -1;
	  }
	}

	function findNextQuotationMark(str, i) {
	  for (; i < str.length; i++) {
	    var c = str[i];
	    if (c === " ") continue;
	    if (c === "'" || c === '"') return i;
	    return -1;
	  }
	}

	function findBeforeEqual(str, i) {
	  for (; i > 0; i--) {
	    var c = str[i];
	    if (c === " ") continue;
	    if (c === "=") return i;
	    return -1;
	  }
	}

	function isQuoteWrapString(text) {
	  if (
	    (text[0] === '"' && text[text.length - 1] === '"') ||
	    (text[0] === "'" && text[text.length - 1] === "'")
	  ) {
	    return true;
	  } else {
	    return false;
	  }
	}

	function stripQuoteWrap(text) {
	  if (isQuoteWrapString(text)) {
	    return text.substr(1, text.length - 2);
	  } else {
	    return text;
	  }
	}

	parser.parseTag = parseTag;
	parser.parseAttr = parseAttr;
	return parser;
}

/**
 * filter xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var xss$1;
var hasRequiredXss;

function requireXss () {
	if (hasRequiredXss) return xss$1;
	hasRequiredXss = 1;
	var FilterCSS = requireLib$1().FilterCSS;
	var DEFAULT = require_default();
	var parser = requireParser();
	var parseTag = parser.parseTag;
	var parseAttr = parser.parseAttr;
	var _ = requireUtil();

	/**
	 * returns `true` if the input value is `undefined` or `null`
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 */
	function isNull(obj) {
	  return obj === undefined || obj === null;
	}

	/**
	 * get attributes for a tag
	 *
	 * @param {String} html
	 * @return {Object}
	 *   - {String} html
	 *   - {Boolean} closing
	 */
	function getAttrs(html) {
	  var i = _.spaceIndex(html);
	  if (i === -1) {
	    return {
	      html: "",
	      closing: html[html.length - 2] === "/",
	    };
	  }
	  html = _.trim(html.slice(i + 1, -1));
	  var isClosing = html[html.length - 1] === "/";
	  if (isClosing) html = _.trim(html.slice(0, -1));
	  return {
	    html: html,
	    closing: isClosing,
	  };
	}

	/**
	 * shallow copy
	 *
	 * @param {Object} obj
	 * @return {Object}
	 */
	function shallowCopyObject(obj) {
	  var ret = {};
	  for (var i in obj) {
	    ret[i] = obj[i];
	  }
	  return ret;
	}

	function keysToLowerCase(obj) {
	  var ret = {};
	  for (var i in obj) {
	    if (Array.isArray(obj[i])) {
	      ret[i.toLowerCase()] = obj[i].map(function (item) {
	        return item.toLowerCase();
	      });
	    } else {
	      ret[i.toLowerCase()] = obj[i];
	    }
	  }
	  return ret;
	}

	/**
	 * FilterXSS class
	 *
	 * @param {Object} options
	 *        whiteList (or allowList), onTag, onTagAttr, onIgnoreTag,
	 *        onIgnoreTagAttr, safeAttrValue, escapeHtml
	 *        stripIgnoreTagBody, allowCommentTag, stripBlankChar
	 *        css{whiteList, onAttr, onIgnoreAttr} `css=false` means don't use `cssfilter`
	 */
	function FilterXSS(options) {
	  options = shallowCopyObject(options || {});

	  if (options.stripIgnoreTag) {
	    if (options.onIgnoreTag) {
	      console.error(
	        'Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'
	      );
	    }
	    options.onIgnoreTag = DEFAULT.onIgnoreTagStripAll;
	  }
	  if (options.whiteList || options.allowList) {
	    options.whiteList = keysToLowerCase(options.whiteList || options.allowList);
	  } else {
	    options.whiteList = DEFAULT.whiteList;
	  }

	  this.attributeWrapSign = options.singleQuotedAttributeValue === true ? "'" : DEFAULT.attributeWrapSign;

	  options.onTag = options.onTag || DEFAULT.onTag;
	  options.onTagAttr = options.onTagAttr || DEFAULT.onTagAttr;
	  options.onIgnoreTag = options.onIgnoreTag || DEFAULT.onIgnoreTag;
	  options.onIgnoreTagAttr = options.onIgnoreTagAttr || DEFAULT.onIgnoreTagAttr;
	  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
	  options.escapeHtml = options.escapeHtml || DEFAULT.escapeHtml;
	  this.options = options;

	  if (options.css === false) {
	    this.cssFilter = false;
	  } else {
	    options.css = options.css || {};
	    this.cssFilter = new FilterCSS(options.css);
	  }
	}

	/**
	 * start process and returns result
	 *
	 * @param {String} html
	 * @return {String}
	 */
	FilterXSS.prototype.process = function (html) {
	  // compatible with the input
	  html = html || "";
	  html = html.toString();
	  if (!html) return "";

	  var me = this;
	  var options = me.options;
	  var whiteList = options.whiteList;
	  var onTag = options.onTag;
	  var onIgnoreTag = options.onIgnoreTag;
	  var onTagAttr = options.onTagAttr;
	  var onIgnoreTagAttr = options.onIgnoreTagAttr;
	  var safeAttrValue = options.safeAttrValue;
	  var escapeHtml = options.escapeHtml;
	  var attributeWrapSign = me.attributeWrapSign;
	  var cssFilter = me.cssFilter;

	  // remove invisible characters
	  if (options.stripBlankChar) {
	    html = DEFAULT.stripBlankChar(html);
	  }

	  // remove html comments
	  if (!options.allowCommentTag) {
	    html = DEFAULT.stripCommentTag(html);
	  }

	  // if enable stripIgnoreTagBody
	  var stripIgnoreTagBody = false;
	  if (options.stripIgnoreTagBody) {
	    stripIgnoreTagBody = DEFAULT.StripTagBody(
	      options.stripIgnoreTagBody,
	      onIgnoreTag
	    );
	    onIgnoreTag = stripIgnoreTagBody.onIgnoreTag;
	  }

	  var retHtml = parseTag(
	    html,
	    function (sourcePosition, position, tag, html, isClosing) {
	      var info = {
	        sourcePosition: sourcePosition,
	        position: position,
	        isClosing: isClosing,
	        isWhite: Object.prototype.hasOwnProperty.call(whiteList, tag),
	      };

	      // call `onTag()`
	      var ret = onTag(tag, html, info);
	      if (!isNull(ret)) return ret;

	      if (info.isWhite) {
	        if (info.isClosing) {
	          return "</" + tag + ">";
	        }

	        var attrs = getAttrs(html);
	        var whiteAttrList = whiteList[tag];
	        var attrsHtml = parseAttr(attrs.html, function (name, value) {
	          // call `onTagAttr()`
	          var isWhiteAttr = _.indexOf(whiteAttrList, name) !== -1;
	          var ret = onTagAttr(tag, name, value, isWhiteAttr);
	          if (!isNull(ret)) return ret;

	          if (isWhiteAttr) {
	            // call `safeAttrValue()`
	            value = safeAttrValue(tag, name, value, cssFilter);
	            if (value) {
	              return name + '=' + attributeWrapSign + value + attributeWrapSign;
	            } else {
	              return name;
	            }
	          } else {
	            // call `onIgnoreTagAttr()`
	            ret = onIgnoreTagAttr(tag, name, value, isWhiteAttr);
	            if (!isNull(ret)) return ret;
	            return;
	          }
	        });

	        // build new tag html
	        html = "<" + tag;
	        if (attrsHtml) html += " " + attrsHtml;
	        if (attrs.closing) html += " /";
	        html += ">";
	        return html;
	      } else {
	        // call `onIgnoreTag()`
	        ret = onIgnoreTag(tag, html, info);
	        if (!isNull(ret)) return ret;
	        return escapeHtml(html);
	      }
	    },
	    escapeHtml
	  );

	  // if enable stripIgnoreTagBody
	  if (stripIgnoreTagBody) {
	    retHtml = stripIgnoreTagBody.remove(retHtml);
	  }

	  return retHtml;
	};

	xss$1 = FilterXSS;
	return xss$1;
}

/**
 * xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var hasRequiredLib;

function requireLib () {
	if (hasRequiredLib) return lib$1.exports;
	hasRequiredLib = 1;
	(function (module, exports) {
		var DEFAULT = require_default();
		var parser = requireParser();
		var FilterXSS = requireXss();

		/**
		 * filter xss function
		 *
		 * @param {String} html
		 * @param {Object} options { whiteList, onTag, onTagAttr, onIgnoreTag, onIgnoreTagAttr, safeAttrValue, escapeHtml }
		 * @return {String}
		 */
		function filterXSS(html, options) {
		  var xss = new FilterXSS(options);
		  return xss.process(html);
		}

		exports = module.exports = filterXSS;
		exports.filterXSS = filterXSS;
		exports.FilterXSS = FilterXSS;

		(function () {
		  for (var i in DEFAULT) {
		    exports[i] = DEFAULT[i];
		  }
		  for (var j in parser) {
		    exports[j] = parser[j];
		  }
		})();

		// using `xss` on the browser, output `filterXSS` to the globals
		if (typeof window !== "undefined") {
		  window.filterXSS = module.exports;
		}

		// using `xss` on the WebWorker, output `filterXSS` to the globals
		function isWorkerEnv() {
		  return (
		    typeof self !== "undefined" &&
		    typeof DedicatedWorkerGlobalScope !== "undefined" &&
		    self instanceof DedicatedWorkerGlobalScope
		  );
		}
		if (isWorkerEnv()) {
		  self.filterXSS = module.exports;
		} 
	} (lib$1, lib$1.exports));
	return lib$1.exports;
}

var libExports = requireLib();
var xss = /*@__PURE__*/getDefaultExportFromCjs(libExports);

var cosmosWhitelist = {
	"cosmos-action-menu": [
	"align",
	"anchor",
	"appearance",
	"open",
	"placement",
	"trigger",
	"triggerType"
],
	"cosmos-bottom-sheet": [
	"appearance",
	"expandable",
	"visible"
],
	"cosmos-button": [
	"appearance",
	"ariaExpanded",
	"ariaHaspopup",
	"ariaLabel",
	"busy",
	"buttonAriaLabel",
	"buttonTitle",
	"decorative",
	"disabled",
	"hovered",
	"href",
	"iconPlacement",
	"kind",
	"rel",
	"shape",
	"size",
	"target",
	"type",
	"width"
],
	"cosmos-carousel": [
	"appearance",
	"mouseDragging",
	"navigation",
	"overflow",
	"skipLinkLabel",
	"skipLinkTarget",
	"slidesToScroll"
],
	"cosmos-carousel-slide": [
],
	"cosmos-chip": [
	"appearance",
	"ariaLabel",
	"shape"
],
	"cosmos-avatar": [
	"alt",
	"appearance",
	"framed",
	"loading",
	"name",
	"size",
	"sizes",
	"src",
	"srcset"
],
	"cosmos-flag": [
	"alt",
	"code",
	"loading"
],
	"cosmos-floating-bar": [
	"align",
	"appearance",
	"expandable",
	"fitContent",
	"visible"
],
	"cosmos-icon-360-video": [
	"ariaLabel"
],
	"cosmos-icon-add": [
	"ariaLabel"
],
	"cosmos-icon-airplay": [
	"ariaLabel"
],
	"cosmos-icon-align-center": [
	"ariaLabel"
],
	"cosmos-icon-align-left": [
	"ariaLabel"
],
	"cosmos-icon-align-right": [
	"ariaLabel"
],
	"cosmos-icon-amazon-branded-dark": [
	"ariaLabel"
],
	"cosmos-icon-amazon-branded-light": [
	"ariaLabel"
],
	"cosmos-icon-amazon-music-branded": [
	"ariaLabel"
],
	"cosmos-icon-amazon-music": [
	"ariaLabel"
],
	"cosmos-icon-amazon": [
	"ariaLabel"
],
	"cosmos-icon-apple-podcasts-branded": [
	"ariaLabel"
],
	"cosmos-icon-apple": [
	"ariaLabel"
],
	"cosmos-icon-ar-active": [
	"ariaLabel"
],
	"cosmos-icon-apple-podcasts": [
	"ariaLabel"
],
	"cosmos-icon-ar-label": [
	"ariaLabel"
],
	"cosmos-icon-ar-mobile": [
	"ariaLabel"
],
	"cosmos-icon-ar": [
	"ariaLabel"
],
	"cosmos-icon-archive": [
	"ariaLabel"
],
	"cosmos-icon-arrow-diagonal-down-left": [
	"ariaLabel"
],
	"cosmos-icon-arrow-diagonal-down-right": [
	"ariaLabel"
],
	"cosmos-icon-arrow-diagonal-up-left": [
	"ariaLabel"
],
	"cosmos-icon-arrow-diagonal-up-right": [
	"ariaLabel"
],
	"cosmos-icon-arrow-down": [
	"ariaLabel"
],
	"cosmos-icon-arrow-left": [
	"ariaLabel"
],
	"cosmos-icon-arrow-right": [
	"ariaLabel"
],
	"cosmos-icon-arrow-up": [
	"ariaLabel"
],
	"cosmos-icon-audio-settings": [
	"ariaLabel"
],
	"cosmos-icon-author": [
	"ariaLabel"
],
	"cosmos-icon-back-10": [
	"ariaLabel"
],
	"cosmos-icon-back-15": [
	"ariaLabel"
],
	"cosmos-icon-back-20": [
	"ariaLabel"
],
	"cosmos-icon-back": [
	"ariaLabel"
],
	"cosmos-icon-backward": [
	"ariaLabel"
],
	"cosmos-icon-bandsintown-branded": [
	"ariaLabel"
],
	"cosmos-icon-bandsintown": [
	"ariaLabel"
],
	"cosmos-icon-baseball-cap": [
	"ariaLabel"
],
	"cosmos-icon-bookmark": [
	"ariaLabel"
],
	"cosmos-icon-browse-filled": [
	"ariaLabel"
],
	"cosmos-icon-browse": [
	"ariaLabel"
],
	"cosmos-icon-bulb-filled": [
	"ariaLabel"
],
	"cosmos-icon-bulb": [
	"ariaLabel"
],
	"cosmos-icon-buy-tickets": [
	"ariaLabel"
],
	"cosmos-icon-calendar-filled": [
	"ariaLabel"
],
	"cosmos-icon-calendar": [
	"ariaLabel"
],
	"cosmos-icon-can-inverted": [
	"ariaLabel"
],
	"cosmos-icon-can": [
	"ariaLabel"
],
	"cosmos-icon-cancel": [
	"ariaLabel"
],
	"cosmos-icon-captions-filled": [
	"ariaLabel"
],
	"cosmos-icon-bookmark-filled": [
	"ariaLabel"
],
	"cosmos-icon-captions": [
	"ariaLabel"
],
	"cosmos-icon-caret-down": [
	"ariaLabel"
],
	"cosmos-icon-caret-left": [
	"ariaLabel"
],
	"cosmos-icon-caret-right": [
	"ariaLabel"
],
	"cosmos-icon-caret-up": [
	"ariaLabel"
],
	"cosmos-icon-chat-add": [
	"ariaLabel"
],
	"cosmos-icon-checkbox-checked": [
	"ariaLabel"
],
	"cosmos-icon-checkbox-unchecked": [
	"ariaLabel"
],
	"cosmos-icon-checkmark": [
	"ariaLabel"
],
	"cosmos-icon-checkout": [
	"ariaLabel"
],
	"cosmos-icon-chevron-down": [
	"ariaLabel"
],
	"cosmos-icon-chevron-left": [
	"ariaLabel"
],
	"cosmos-icon-chevron-right": [
	"ariaLabel"
],
	"cosmos-icon-chevron-up": [
	"ariaLabel"
],
	"cosmos-icon-chromecast-filled": [
	"ariaLabel"
],
	"cosmos-icon-chromecast": [
	"ariaLabel"
],
	"cosmos-icon-clear": [
	"ariaLabel"
],
	"cosmos-icon-clip": [
	"ariaLabel"
],
	"cosmos-icon-clock": [
	"ariaLabel"
],
	"cosmos-icon-close-small": [
	"ariaLabel"
],
	"cosmos-icon-close": [
	"ariaLabel"
],
	"cosmos-icon-code-block": [
	"ariaLabel"
],
	"cosmos-icon-collapse-horizontal": [
	"ariaLabel"
],
	"cosmos-icon-collapse-vertical": [
	"ariaLabel"
],
	"cosmos-icon-columns": [
	"ariaLabel"
],
	"cosmos-icon-comment": [
	"ariaLabel"
],
	"cosmos-icon-contextual": [
	"ariaLabel"
],
	"cosmos-icon-contract": [
	"ariaLabel"
],
	"cosmos-icon-copy-link": [
	"ariaLabel"
],
	"cosmos-icon-country": [
	"ariaLabel"
],
	"cosmos-icon-couple": [
	"ariaLabel"
],
	"cosmos-icon-crashed": [
	"ariaLabel"
],
	"cosmos-icon-create": [
	"ariaLabel"
],
	"cosmos-icon-crew": [
	"ariaLabel"
],
	"cosmos-icon-cloud": [
	"ariaLabel"
],
	"cosmos-icon-crop": [
	"ariaLabel"
],
	"cosmos-icon-currency": [
	"ariaLabel"
],
	"cosmos-icon-currently-watching": [
	"ariaLabel"
],
	"cosmos-icon-cut": [
	"ariaLabel"
],
	"cosmos-icon-deezer-branded": [
	"ariaLabel"
],
	"cosmos-icon-deezer": [
	"ariaLabel"
],
	"cosmos-icon-delete": [
	"ariaLabel"
],
	"cosmos-icon-delivery": [
	"ariaLabel"
],
	"cosmos-icon-desktop": [
	"ariaLabel"
],
	"cosmos-icon-devices": [
	"ariaLabel"
],
	"cosmos-icon-directions": [
	"ariaLabel"
],
	"cosmos-icon-discord-branded": [
	"ariaLabel"
],
	"cosmos-icon-360-photo": [
	"ariaLabel"
],
	"cosmos-icon-discord": [
	"ariaLabel"
],
	"cosmos-icon-discover": [
	"ariaLabel"
],
	"cosmos-icon-document-filing-2": [
	"ariaLabel"
],
	"cosmos-icon-document-filing": [
	"ariaLabel"
],
	"cosmos-icon-document-filled": [
	"ariaLabel"
],
	"cosmos-icon-download-error": [
	"ariaLabel"
],
	"cosmos-icon-download": [
	"ariaLabel"
],
	"cosmos-icon-downloading": [
	"ariaLabel"
],
	"cosmos-icon-drag-handle-horizontal": [
	"ariaLabel"
],
	"cosmos-icon-drag-handle-vertical": [
	"ariaLabel"
],
	"cosmos-icon-drink": [
	"ariaLabel"
],
	"cosmos-icon-duplicate": [
	"ariaLabel"
],
	"cosmos-icon-edit": [
	"ariaLabel"
],
	"cosmos-icon-emoji": [
	"ariaLabel"
],
	"cosmos-icon-enlarge": [
	"ariaLabel"
],
	"cosmos-icon-envelope-filled": [
	"ariaLabel"
],
	"cosmos-icon-epg": [
	"ariaLabel"
],
	"cosmos-icon-episode": [
	"ariaLabel"
],
	"cosmos-icon-error-filled": [
	"ariaLabel"
],
	"cosmos-icon-event-details": [
	"ariaLabel"
],
	"cosmos-icon-event-end": [
	"ariaLabel"
],
	"cosmos-icon-event-series": [
	"ariaLabel"
],
	"cosmos-icon-event-start": [
	"ariaLabel"
],
	"cosmos-icon-email": [
	"ariaLabel"
],
	"cosmos-icon-expand-horizontal": [
	"ariaLabel"
],
	"cosmos-icon-expand-vertical": [
	"ariaLabel"
],
	"cosmos-icon-external-link": [
	"ariaLabel"
],
	"cosmos-icon-facebook-branded": [
	"ariaLabel"
],
	"cosmos-icon-facebook": [
	"ariaLabel"
],
	"cosmos-icon-fast-checkout": [
	"ariaLabel"
],
	"cosmos-icon-fast-forward": [
	"ariaLabel"
],
	"cosmos-icon-fast-rewind": [
	"ariaLabel"
],
	"cosmos-icon-feature-film": [
	"ariaLabel"
],
	"cosmos-icon-feedback-filled": [
	"ariaLabel"
],
	"cosmos-icon-event": [
	"ariaLabel"
],
	"cosmos-icon-feedback": [
	"ariaLabel"
],
	"cosmos-icon-female": [
	"ariaLabel"
],
	"cosmos-icon-file-remove": [
	"ariaLabel"
],
	"cosmos-icon-file-upload": [
	"ariaLabel"
],
	"cosmos-icon-film-camera": [
	"ariaLabel"
],
	"cosmos-icon-file-download": [
	"ariaLabel"
],
	"cosmos-icon-films": [
	"ariaLabel"
],
	"cosmos-icon-filter-list": [
	"ariaLabel"
],
	"cosmos-icon-filter-remove": [
	"ariaLabel"
],
	"cosmos-icon-flag": [
	"ariaLabel"
],
	"cosmos-icon-filter": [
	"ariaLabel"
],
	"cosmos-icon-flipboard-branded": [
	"ariaLabel"
],
	"cosmos-icon-flipboard": [
	"ariaLabel"
],
	"cosmos-icon-folder-add": [
	"ariaLabel"
],
	"cosmos-icon-folder-open": [
	"ariaLabel"
],
	"cosmos-icon-folder-remove": [
	"ariaLabel"
],
	"cosmos-icon-folder-shared": [
	"ariaLabel"
],
	"cosmos-icon-folder-download": [
	"ariaLabel"
],
	"cosmos-icon-folder-upload": [
	"ariaLabel"
],
	"cosmos-icon-folder": [
	"ariaLabel"
],
	"cosmos-icon-format-bold": [
	"ariaLabel"
],
	"cosmos-icon-format-list-numbered": [
	"ariaLabel"
],
	"cosmos-icon-format-quote": [
	"ariaLabel"
],
	"cosmos-icon-format-size": [
	"ariaLabel"
],
	"cosmos-icon-format-underline": [
	"ariaLabel"
],
	"cosmos-icon-forward-10": [
	"ariaLabel"
],
	"cosmos-icon-forward-15": [
	"ariaLabel"
],
	"cosmos-icon-forward-20": [
	"ariaLabel"
],
	"cosmos-icon-forward": [
	"ariaLabel"
],
	"cosmos-icon-fullscreen-exit": [
	"ariaLabel"
],
	"cosmos-icon-fullscreen": [
	"ariaLabel"
],
	"cosmos-icon-funnel-remove": [
	"ariaLabel"
],
	"cosmos-icon-funnel": [
	"ariaLabel"
],
	"cosmos-icon-gallery": [
	"ariaLabel"
],
	"cosmos-icon-game": [
	"ariaLabel"
],
	"cosmos-icon-generic-content": [
	"ariaLabel"
],
	"cosmos-icon-globe-geo": [
	"ariaLabel"
],
	"cosmos-icon-google-branded": [
	"ariaLabel"
],
	"cosmos-icon-google-play-branded": [
	"ariaLabel"
],
	"cosmos-icon-google-play": [
	"ariaLabel"
],
	"cosmos-icon-google-podcasts-branded": [
	"ariaLabel"
],
	"cosmos-icon-google-podcasts": [
	"ariaLabel"
],
	"cosmos-icon-google": [
	"ariaLabel"
],
	"cosmos-icon-grid-layout": [
	"ariaLabel"
],
	"cosmos-icon-grid-live": [
	"ariaLabel"
],
	"cosmos-icon-grid": [
	"ariaLabel"
],
	"cosmos-icon-headline": [
	"ariaLabel"
],
	"cosmos-icon-headphones": [
	"ariaLabel"
],
	"cosmos-icon-highlights": [
	"ariaLabel"
],
	"cosmos-icon-heart": [
	"ariaLabel"
],
	"cosmos-icon-history": [
	"ariaLabel"
],
	"cosmos-icon-home-filled": [
	"ariaLabel"
],
	"cosmos-icon-home": [
	"ariaLabel"
],
	"cosmos-icon-hot": [
	"ariaLabel"
],
	"cosmos-icon-hourglass-empty": [
	"ariaLabel"
],
	"cosmos-icon-hourglass-full": [
	"ariaLabel"
],
	"cosmos-icon-image-gallery": [
	"ariaLabel"
],
	"cosmos-icon-image-in-picture": [
	"ariaLabel"
],
	"cosmos-icon-heart-filled": [
	"ariaLabel"
],
	"cosmos-icon-image": [
	"ariaLabel"
],
	"cosmos-icon-info-heat-analyser": [
	"ariaLabel"
],
	"cosmos-icon-info-filled": [
	"ariaLabel"
],
	"cosmos-icon-info-multicolored": [
	"ariaLabel"
],
	"cosmos-icon-info": [
	"ariaLabel"
],
	"cosmos-icon-in-progress": [
	"ariaLabel"
],
	"cosmos-icon-infographic": [
	"ariaLabel"
],
	"cosmos-icon-instagram-branded": [
	"ariaLabel"
],
	"cosmos-icon-instagram": [
	"ariaLabel"
],
	"cosmos-icon-interview": [
	"ariaLabel"
],
	"cosmos-icon-invoice": [
	"ariaLabel"
],
	"cosmos-icon-italic": [
	"ariaLabel"
],
	"cosmos-icon-keyboard": [
	"ariaLabel"
],
	"cosmos-icon-label": [
	"ariaLabel"
],
	"cosmos-icon-language": [
	"ariaLabel"
],
	"cosmos-icon-laptop": [
	"ariaLabel"
],
	"cosmos-icon-line-branded": [
	"ariaLabel"
],
	"cosmos-icon-launch": [
	"ariaLabel"
],
	"cosmos-icon-line": [
	"ariaLabel"
],
	"cosmos-icon-link": [
	"ariaLabel"
],
	"cosmos-icon-linkedin-branded": [
	"ariaLabel"
],
	"cosmos-icon-linkedin": [
	"ariaLabel"
],
	"cosmos-icon-live-broadcast": [
	"ariaLabel"
],
	"cosmos-icon-list": [
	"ariaLabel"
],
	"cosmos-icon-live": [
	"ariaLabel"
],
	"cosmos-icon-loading": [
	"ariaLabel"
],
	"cosmos-icon-lock-filled": [
	"ariaLabel"
],
	"cosmos-icon-lock-open": [
	"ariaLabel"
],
	"cosmos-icon-magic-wand": [
	"ariaLabel"
],
	"cosmos-icon-male": [
	"ariaLabel"
],
	"cosmos-icon-map": [
	"ariaLabel"
],
	"cosmos-icon-menu-notification": [
	"ariaLabel"
],
	"cosmos-icon-menu": [
	"ariaLabel"
],
	"cosmos-icon-messenger": [
	"ariaLabel"
],
	"cosmos-icon-minus": [
	"ariaLabel"
],
	"cosmos-icon-mode-dark": [
	"ariaLabel"
],
	"cosmos-icon-location": [
	"ariaLabel"
],
	"cosmos-icon-mode-light": [
	"ariaLabel"
],
	"cosmos-icon-more": [
	"ariaLabel"
],
	"cosmos-icon-mountain": [
	"ariaLabel"
],
	"cosmos-icon-mouse": [
	"ariaLabel"
],
	"cosmos-icon-multi-language": [
	"ariaLabel"
],
	"cosmos-icon-mute": [
	"ariaLabel"
],
	"cosmos-icon-my-location": [
	"ariaLabel"
],
	"cosmos-icon-news": [
	"ariaLabel"
],
	"cosmos-icon-no-data": [
	"ariaLabel"
],
	"cosmos-icon-pagination": [
	"ariaLabel"
],
	"cosmos-icon-parcel": [
	"ariaLabel"
],
	"cosmos-icon-partner-profile": [
	"ariaLabel"
],
	"cosmos-icon-paste": [
	"ariaLabel"
],
	"cosmos-icon-pause": [
	"ariaLabel"
],
	"cosmos-icon-payment": [
	"ariaLabel"
],
	"cosmos-icon-no-connection": [
	"ariaLabel"
],
	"cosmos-icon-pen": [
	"ariaLabel"
],
	"cosmos-icon-person-following": [
	"ariaLabel"
],
	"cosmos-icon-person-follow": [
	"ariaLabel"
],
	"cosmos-icon-person-profile-filled": [
	"ariaLabel"
],
	"cosmos-icon-phone": [
	"ariaLabel"
],
	"cosmos-icon-pagination-filled": [
	"ariaLabel"
],
	"cosmos-icon-photo-camera": [
	"ariaLabel"
],
	"cosmos-icon-picture-in-picture": [
	"ariaLabel"
],
	"cosmos-icon-pinterest-branded": [
	"ariaLabel"
],
	"cosmos-icon-photo-camera-reverse": [
	"ariaLabel"
],
	"cosmos-icon-pinterest": [
	"ariaLabel"
],
	"cosmos-icon-pie-outline": [
	"ariaLabel"
],
	"cosmos-icon-play": [
	"ariaLabel"
],
	"cosmos-icon-playlist-personalised": [
	"ariaLabel"
],
	"cosmos-icon-playlist": [
	"ariaLabel"
],
	"cosmos-icon-plus": [
	"ariaLabel"
],
	"cosmos-icon-presentation": [
	"ariaLabel"
],
	"cosmos-icon-podcast": [
	"ariaLabel"
],
	"cosmos-icon-preview-filled": [
	"ariaLabel"
],
	"cosmos-icon-preview-off-filled": [
	"ariaLabel"
],
	"cosmos-icon-preview-off": [
	"ariaLabel"
],
	"cosmos-icon-preview": [
	"ariaLabel"
],
	"cosmos-icon-printer": [
	"ariaLabel"
],
	"cosmos-icon-product-placement": [
	"ariaLabel"
],
	"cosmos-icon-push-pin": [
	"ariaLabel"
],
	"cosmos-icon-quality": [
	"ariaLabel"
],
	"cosmos-icon-radio-button": [
	"ariaLabel"
],
	"cosmos-icon-reddit-branded": [
	"ariaLabel"
],
	"cosmos-icon-reddit": [
	"ariaLabel"
],
	"cosmos-icon-quiz": [
	"ariaLabel"
],
	"cosmos-icon-redeem": [
	"ariaLabel"
],
	"cosmos-icon-redo": [
	"ariaLabel"
],
	"cosmos-icon-reload": [
	"ariaLabel"
],
	"cosmos-icon-related-content": [
	"ariaLabel"
],
	"cosmos-icon-reminder-false": [
	"ariaLabel"
],
	"cosmos-icon-reminder-true": [
	"ariaLabel"
],
	"cosmos-icon-remove": [
	"ariaLabel"
],
	"cosmos-icon-rendition": [
	"ariaLabel"
],
	"cosmos-icon-replay-30": [
	"ariaLabel"
],
	"cosmos-icon-replay-5": [
	"ariaLabel"
],
	"cosmos-icon-replay": [
	"ariaLabel"
],
	"cosmos-icon-results": [
	"ariaLabel"
],
	"cosmos-icon-roku-replay": [
	"ariaLabel"
],
	"cosmos-icon-report": [
	"ariaLabel"
],
	"cosmos-icon-route": [
	"ariaLabel"
],
	"cosmos-icon-ruler": [
	"ariaLabel"
],
	"cosmos-icon-rules": [
	"ariaLabel"
],
	"cosmos-icon-save-false": [
	"ariaLabel"
],
	"cosmos-icon-save": [
	"ariaLabel"
],
	"cosmos-icon-screen-rotation": [
	"ariaLabel"
],
	"cosmos-icon-search": [
	"ariaLabel"
],
	"cosmos-icon-season": [
	"ariaLabel"
],
	"cosmos-icon-section": [
	"ariaLabel"
],
	"cosmos-icon-secure": [
	"ariaLabel"
],
	"cosmos-icon-select-all": [
	"ariaLabel"
],
	"cosmos-icon-select": [
	"ariaLabel"
],
	"cosmos-icon-send": [
	"ariaLabel"
],
	"cosmos-icon-save-true": [
	"ariaLabel"
],
	"cosmos-icon-settings": [
	"ariaLabel"
],
	"cosmos-icon-share-tab": [
	"ariaLabel"
],
	"cosmos-icon-share": [
	"ariaLabel"
],
	"cosmos-icon-shop": [
	"ariaLabel"
],
	"cosmos-icon-shopping-bag": [
	"ariaLabel"
],
	"cosmos-icon-show": [
	"ariaLabel"
],
	"cosmos-icon-sidebar-off": [
	"ariaLabel"
],
	"cosmos-icon-sidebar-on": [
	"ariaLabel"
],
	"cosmos-icon-sign-in": [
	"ariaLabel"
],
	"cosmos-icon-sign-out": [
	"ariaLabel"
],
	"cosmos-icon-sign-up": [
	"ariaLabel"
],
	"cosmos-icon-skip-next-triangle": [
	"ariaLabel"
],
	"cosmos-icon-skip-next": [
	"ariaLabel"
],
	"cosmos-icon-skip-previous-triangle": [
	"ariaLabel"
],
	"cosmos-icon-skip-previous": [
	"ariaLabel"
],
	"cosmos-icon-snapchat-branded-light": [
	"ariaLabel"
],
	"cosmos-icon-snapchat": [
	"ariaLabel"
],
	"cosmos-icon-sneaker": [
	"ariaLabel"
],
	"cosmos-icon-songkick-branded": [
	"ariaLabel"
],
	"cosmos-icon-songkick": [
	"ariaLabel"
],
	"cosmos-icon-sort-a-z": [
	"ariaLabel"
],
	"cosmos-icon-sort-z-a": [
	"ariaLabel"
],
	"cosmos-icon-sort": [
	"ariaLabel"
],
	"cosmos-icon-soundcloud-branded": [
	"ariaLabel"
],
	"cosmos-icon-snapchat-branded-dark": [
	"ariaLabel"
],
	"cosmos-icon-soundcloud": [
	"ariaLabel"
],
	"cosmos-icon-spotify-branded": [
	"ariaLabel"
],
	"cosmos-icon-spotify": [
	"ariaLabel"
],
	"cosmos-icon-star-filled": [
	"ariaLabel"
],
	"cosmos-icon-star": [
	"ariaLabel"
],
	"cosmos-icon-starred-filled": [
	"ariaLabel"
],
	"cosmos-icon-starred": [
	"ariaLabel"
],
	"cosmos-icon-stop": [
	"ariaLabel"
],
	"cosmos-icon-start": [
	"ariaLabel"
],
	"cosmos-icon-strava-branded": [
	"ariaLabel"
],
	"cosmos-icon-story": [
	"ariaLabel"
],
	"cosmos-icon-strava": [
	"ariaLabel"
],
	"cosmos-icon-submit": [
	"ariaLabel"
],
	"cosmos-icon-subtitles": [
	"ariaLabel"
],
	"cosmos-icon-success": [
	"ariaLabel"
],
	"cosmos-icon-t-shirt": [
	"ariaLabel"
],
	"cosmos-icon-table": [
	"ariaLabel"
],
	"cosmos-icon-tablet": [
	"ariaLabel"
],
	"cosmos-icon-tap": [
	"ariaLabel"
],
	"cosmos-icon-team": [
	"ariaLabel"
],
	"cosmos-icon-text-format": [
	"ariaLabel"
],
	"cosmos-icon-thumbs-up": [
	"ariaLabel"
],
	"cosmos-icon-thumbs-down": [
	"ariaLabel"
],
	"cosmos-icon-tiktok-branded-dark": [
	"ariaLabel"
],
	"cosmos-icon-trailer": [
	"ariaLabel"
],
	"cosmos-icon-tiktok-branded-light": [
	"ariaLabel"
],
	"cosmos-icon-translate-alt": [
	"ariaLabel"
],
	"cosmos-icon-translate": [
	"ariaLabel"
],
	"cosmos-icon-trending": [
	"ariaLabel"
],
	"cosmos-icon-trophy": [
	"ariaLabel"
],
	"cosmos-icon-tv": [
	"ariaLabel"
],
	"cosmos-icon-tiktok": [
	"ariaLabel"
],
	"cosmos-icon-twitch-branded": [
	"ariaLabel"
],
	"cosmos-icon-twitch": [
	"ariaLabel"
],
	"cosmos-icon-undo": [
	"ariaLabel"
],
	"cosmos-icon-upload": [
	"ariaLabel"
],
	"cosmos-icon-user-filled": [
	"ariaLabel"
],
	"cosmos-icon-user-settings": [
	"ariaLabel"
],
	"cosmos-icon-user": [
	"ariaLabel"
],
	"cosmos-icon-verified": [
	"ariaLabel"
],
	"cosmos-icon-video": [
	"ariaLabel"
],
	"cosmos-icon-view-more": [
	"ariaLabel"
],
	"cosmos-icon-vimeo": [
	"ariaLabel"
],
	"cosmos-icon-vimeo-branded": [
	"ariaLabel"
],
	"cosmos-icon-vk-branded": [
	"ariaLabel"
],
	"cosmos-icon-vk": [
	"ariaLabel"
],
	"cosmos-icon-volume-low": [
	"ariaLabel"
],
	"cosmos-icon-volume-mid": [
	"ariaLabel"
],
	"cosmos-icon-volume": [
	"ariaLabel"
],
	"cosmos-icon-volume-up": [
	"ariaLabel"
],
	"cosmos-icon-vote": [
	"ariaLabel"
],
	"cosmos-icon-warehouse": [
	"ariaLabel"
],
	"cosmos-icon-vr": [
	"ariaLabel"
],
	"cosmos-icon-warning": [
	"ariaLabel"
],
	"cosmos-icon-washout": [
	"ariaLabel"
],
	"cosmos-icon-watch": [
	"ariaLabel"
],
	"cosmos-icon-weather": [
	"ariaLabel"
],
	"cosmos-icon-weibo-branded": [
	"ariaLabel"
],
	"cosmos-icon-weibo": [
	"ariaLabel"
],
	"cosmos-icon-whatsapp-branded": [
	"ariaLabel"
],
	"cosmos-icon-whatsapp": [
	"ariaLabel"
],
	"cosmos-icon-wykop-branded": [
	"ariaLabel"
],
	"cosmos-icon-x-branded-dark": [
	"ariaLabel"
],
	"cosmos-icon-x-branded-light": [
	"ariaLabel"
],
	"cosmos-icon-x": [
	"ariaLabel"
],
	"cosmos-icon-youtube-branded": [
	"ariaLabel"
],
	"cosmos-icon-wykop": [
	"ariaLabel"
],
	"cosmos-icon-youtube": [
	"ariaLabel"
],
	"cosmos-icon-zoom-out": [
	"ariaLabel"
],
	"cosmos-icon-zoom-in": [
	"ariaLabel"
],
	"cosmos-icon": [
	"ariaLabel"
],
	"cosmos-image": [
	"appearance",
	"fit",
	"image",
	"imageAlt",
	"imagePreview",
	"loading",
	"observeResize",
	"radius",
	"sizes",
	"srcset"
],
	"cosmos-link": [
	"href",
	"kind",
	"rel",
	"target"
],
	"cosmos-media-preview": [
	"active",
	"appearance",
	"image",
	"imageAlt",
	"imagePreview",
	"loading",
	"observeResize",
	"playVideo",
	"radius",
	"sizes",
	"srcset",
	"video"
],
	"cosmos-mode": [
	"mode"
],
	"cosmos-spinner": [
	"appearance"
],
	"cosmos-text": [
	"appearance",
	"clamp",
	"kind",
	"size",
	"spacing",
	"tag",
	"weight"
],
	"cosmos-textarea": [
	"appearance",
	"autofocus",
	"disabled",
	"helpText",
	"invalid",
	"label",
	"maxlength",
	"minlength",
	"name",
	"optionalLabel",
	"placeholder",
	"readonly",
	"required",
	"requiredLabel",
	"resizable",
	"rows",
	"validationMessage",
	"value"
],
	"cosmos-title": [
	"appearance",
	"clamp",
	"kind",
	"size",
	"spacing",
	"tag",
	"weight"
],
	"cosmos-tooltip": [
	"appearance",
	"content",
	"controlled",
	"follow",
	"offset",
	"placement",
	"spacing",
	"unreachable",
	"visible"
],
	"deprecated-component": [
	"deprecatedPropValue",
	"newProp",
	"obsoleteProp",
	"replacedProp",
	"updatedPropValue"
],
	"cosmos-badge": [
	"appearance",
	"href",
	"kind",
	"rel",
	"shape",
	"size",
	"target"
],
	"cosmos-default-item": [
	"appearance",
	"headline",
	"href",
	"metaTextPrimary",
	"metaTextPrimaryClamp",
	"metaTextSecondary",
	"metaTextSecondaryClamp",
	"rel",
	"size",
	"target"
],
	"cosmos-link-item": [
	"additionalInfo",
	"appearance",
	"headline",
	"href",
	"image",
	"rel",
	"size",
	"target"
],
	"cosmos-person-item": [
	"additionalInfo",
	"appearance",
	"external",
	"href",
	"metaTextPrimary",
	"metaTextSecondary",
	"name",
	"number",
	"profileImage",
	"profileImageFramed",
	"rel",
	"size",
	"target"
],
	"cosmos-product-item": [
	"additionalInfo",
	"appearance",
	"href",
	"image",
	"name",
	"rel",
	"size",
	"target",
	"text"
],
	"cosmos-story-item": [
	"additionalInfo",
	"appearance",
	"headline",
	"href",
	"image",
	"readingTime",
	"rel",
	"size",
	"target"
],
	"cosmos-video-item": [
	"additionalInfo",
	"appearance",
	"duration",
	"headline",
	"href",
	"image",
	"inProgress",
	"inProgressText",
	"live",
	"liveText",
	"rel",
	"size",
	"target"
],
	"cosmos-default-card": [
	"appearance",
	"badge",
	"cover",
	"favoritable",
	"favoriteAriaLabel",
	"favorited",
	"headline",
	"href",
	"image",
	"imageLoading",
	"imagePreview",
	"imageSizes",
	"imageSrcset",
	"layout",
	"logo",
	"logoAlt",
	"logoNarrow",
	"metaText",
	"observeMediaResize",
	"rel",
	"tag",
	"target",
	"text",
	"video"
],
	"cosmos-link-card": [
	"appearance",
	"headline",
	"href",
	"image",
	"imageLoading",
	"imagePreview",
	"imageSizes",
	"imageSrcset",
	"layout",
	"logo",
	"logoAlt",
	"logoNarrow",
	"observeMediaResize",
	"rel",
	"tag",
	"target",
	"text",
	"video"
],
	"cosmos-person-card": [
	"additionalInfo",
	"appearance",
	"cover",
	"external",
	"favoritable",
	"favoriteAriaLabel",
	"favoriteButtonLabel",
	"favorited",
	"href",
	"image",
	"imageLoading",
	"imagePreview",
	"imageSizes",
	"imageSrcset",
	"layout",
	"metaTextPrimary",
	"metaTextSecondary",
	"name",
	"number",
	"observeMediaResize",
	"profileImage",
	"rel",
	"showAvatar",
	"target",
	"video"
],
	"cosmos-product-card": [
	"appearance",
	"cta",
	"href",
	"image",
	"imageLoading",
	"imagePreview",
	"imageSizes",
	"imageSrcset",
	"layout",
	"logo",
	"logoAlt",
	"logoNarrow",
	"name",
	"observeMediaResize",
	"rel",
	"target",
	"text"
],
	"cosmos-story-card": [
	"appearance",
	"badge",
	"favoritable",
	"favoriteAriaLabel",
	"favorited",
	"headline",
	"href",
	"image",
	"imageLoading",
	"imagePreview",
	"imageSizes",
	"imageSrcset",
	"layout",
	"logo",
	"logoAlt",
	"logoNarrow",
	"observeMediaResize",
	"playVideo",
	"readingTime",
	"rel",
	"tag",
	"target",
	"text",
	"video"
],
	"cosmos-video-card": [
	"badge",
	"duration",
	"favoritable",
	"favoriteAriaLabel",
	"favorited",
	"headline",
	"href",
	"image",
	"imageLoading",
	"imagePreview",
	"imageSizes",
	"imageSrcset",
	"layout",
	"live",
	"logo",
	"logoAlt",
	"logoNarrow",
	"observeMediaResize",
	"rel",
	"tag",
	"target",
	"text",
	"video"
],
	"cosmos-action-menu-group": [
	"appearance",
	"label"
],
	"cosmos-action-menu-item": [
	"active",
	"appearance",
	"href",
	"itemId",
	"meta",
	"rel",
	"target"
],
	"cosmos-checkbox": [
	"appearance",
	"autofocus",
	"checked",
	"clamp",
	"disabled",
	"helpText",
	"hitArea",
	"invalid",
	"name",
	"optionalLabel",
	"required",
	"requiredLabel",
	"validationMessage",
	"value"
],
	"cosmos-checkbox-group": [
	"appearance",
	"disabled",
	"helpText",
	"invalid",
	"label",
	"optionalLabel",
	"requiredLabel",
	"validationMessage"
],
	"cosmos-input": [
	"appearance",
	"autocomplete",
	"autofocus",
	"clearable",
	"clearAriaLabel",
	"disabled",
	"helpText",
	"iconPlacement",
	"invalid",
	"label",
	"name",
	"optionalLabel",
	"placeholder",
	"readonly",
	"required",
	"requiredLabel",
	"type",
	"validationMessage",
	"value"
],
	"cosmos-optgroup": [
	"appearance",
	"disabled",
	"label"
],
	"cosmos-icon-volume-down": [
	"ariaLabel"
],
	"cosmos-option": [
	"appearance",
	"disabled",
	"meta",
	"selected",
	"value"
],
	"cosmos-radio-group": [
	"appearance",
	"disabled",
	"helpText",
	"invalid",
	"label",
	"optionalLabel",
	"requiredLabel",
	"validationMessage"
],
	"cosmos-radio": [
	"appearance",
	"autofocus",
	"checked",
	"clamp",
	"disabled",
	"focusable",
	"hitArea",
	"invalid",
	"name",
	"required",
	"value"
],
	"cosmos-select": [
	"appearance",
	"autofocus",
	"clearable",
	"clearAriaLabel",
	"disabled",
	"helpText",
	"invalid",
	"label",
	"multiple",
	"name",
	"optionalLabel",
	"placeholder",
	"required",
	"requiredLabel",
	"searchable",
	"searchEmptyResultsText",
	"searchPlaceholder",
	"validationMessage",
	"value"
],
	"cosmos-select-value": [
	"multiple"
],
	"cosmos-asset-item-base": [
	"appearance",
	"hasAdditionalInfoPrefix",
	"hasPrimaryPrefix",
	"hasSecondaryPrefix",
	"headline",
	"headlineClamp",
	"href",
	"metaTextAdditional",
	"metaTextAdditionalClamp",
	"metaTextPrimary",
	"metaTextPrimaryClamp",
	"metaTextSecondary",
	"metaTextSecondaryClamp",
	"rel",
	"size",
	"target"
],
	"cosmos-icon-menu-pulsating": [
	"ariaLabel"
],
	"cosmos-icon-messenger-branded": [
	"ariaLabel"
],
	"cosmos-icon-megaphone": [
	"ariaLabel"
]
};

var generalWhitelist = {
	
};

const cosmosXSSWhitelist = Object.assign(Object.assign({}, generalWhitelist), cosmosWhitelist);

/**
 * Provides DOM manipulation utilities with XSS protection for select components.
 */
const SELECT_XSS_OPTIONS = {
    whiteList: Object.assign(Object.assign({}, cosmosXSSWhitelist), libExports.whiteList),
    onTagAttr: (_tag, name, value) => {
        if (['slot', 'class', 'id'].includes(name)) {
            return `${name}="${value}"`;
        }
    },
};
const ELLIPSIS_BUFFER = 40;
/**
 * Updates accessibility and interaction attributes on option elements.
 * Only modifies attributes when values differ to minimize DOM operations.
 *
 * @param optionRef - The option element to update
 * @param attributes - Object containing attributes to set:
 *   - tabIndex: Tab navigation index (-1 to disable, 0 for focusable)
 *   - selected: Whether option is currently selected
 *   - ariaPosinset: Position in set for screen readers (1-based)
 *   - ariaSetsize: Total size of the option set
 */
function updateOptionAttributes(optionRef, attributes) {
    if (attributes.tabIndex !== undefined) {
        const currentTabIndex = optionRef.getAttribute('tabindex');
        const newTabIndex = attributes.tabIndex.toString();
        if (currentTabIndex !== newTabIndex) {
            optionRef.setAttribute('tabindex', newTabIndex);
        }
    }
    if (attributes.selected !== undefined) {
        const hasSelectedAttr = optionRef.hasAttribute('selected');
        if (attributes.selected !== hasSelectedAttr) {
            if (attributes.selected) {
                optionRef.setAttribute('selected', '');
            }
            else {
                optionRef.removeAttribute('selected');
            }
        }
    }
    if (attributes.ariaPosinset && optionRef.getAttribute('aria-posinset') !== attributes.ariaPosinset) {
        optionRef.setAttribute('aria-posinset', attributes.ariaPosinset);
    }
    if (attributes.ariaSetsize && optionRef.getAttribute('aria-setsize') !== attributes.ariaSetsize) {
        optionRef.setAttribute('aria-setsize', attributes.ariaSetsize);
    }
}
/**
 * Controls option element visibility for search filtering.
 * When hiding, also removes accessibility attributes to prevent screen reader confusion.
 *
 * @param optionRef - The option element to show/hide
 * @param isVisible - Whether the option should be visible
 * @returns True if the visibility state was changed, false if already in desired state
 */
function updateOptionVisibility(optionRef, isVisible) {
    const currentDisplay = optionRef.style.display;
    const needsUpdate = isVisible ? currentDisplay === 'none' : currentDisplay !== 'none';
    if (needsUpdate) {
        optionRef.style.display = isVisible ? '' : 'none';
        if (!isVisible) {
            optionRef.tabIndex = -1;
            optionRef.removeAttribute('aria-posinset');
            optionRef.removeAttribute('aria-setsize');
        }
    }
    return needsUpdate;
}
/**
 * Safely removes a value display element from the DOM.
 * Handles null elements gracefully without throwing errors.
 *
 * @param element - The element to remove, null-safe
 */
function clearValueSlot(element) {
    if (element) {
        element.remove();
    }
}
/**
 * Creates a cosmos-select-value element to display the selected option.
 * Includes XSS protection and preserves option metadata.
 *
 * @param option - The selected option to create display for
 * @param appearance - Theme appearance ('light' or 'dark')
 * @returns New cosmos-select-value element, or null in SSR environment
 */
function createSingleSelectValue(option, appearance) {
    if (isNodeEnvironment()) {
        return null;
    }
    const element = global$1.document.createElement(transformTagName('cosmos-select-value'));
    element.setAttribute('slot', 'value');
    element.setAttribute('appearance', appearance);
    element.innerHTML = xss(option.ref.innerHTML, SELECT_XSS_OPTIONS);
    if (option.ref.meta) {
        element.setAttribute('meta', option.ref.meta);
    }
    return element;
}
/**
 * Creates a wrapper element displaying multiple selected options as comma-separated values.
 * Each option is rendered as a cosmos-select-value within a cosmos-text wrapper.
 *
 * @param options - Array of selected options to display
 * @param appearance - Theme appearance ('light' or 'dark')
 * @returns New wrapper element containing all selected values, or null in SSR environment
 */
function createMultiSelectValue(options, appearance) {
    if (isNodeEnvironment() || options.length === 0) {
        return null;
    }
    const wrapper = global$1.document.createElement(transformTagName('cosmos-text'));
    wrapper.classList.add('cosmos-select-value__wrapping-text');
    wrapper.setAttribute('slot', 'value');
    wrapper.setAttribute('size', 'small');
    wrapper.setAttribute('clamp', '1');
    wrapper.setAttribute('appearance', appearance);
    options.forEach((option, index) => {
        const selectValue = global$1.document.createElement(transformTagName('cosmos-select-value'));
        selectValue.setAttribute('multiple', 'true');
        selectValue.innerHTML = xss(option.ref.innerHTML, SELECT_XSS_OPTIONS);
        if (option.ref.meta) {
            selectValue.setAttribute('meta', option.ref.meta);
        }
        wrapper.appendChild(selectValue);
        if (index < options.length - 1) {
            wrapper.appendChild(global$1.document.createTextNode(', '));
        }
    });
    return wrapper;
}
/**
 * Inserts a value display element into the select component's value slot.
 * Positions at the beginning of the parent to maintain proper slot ordering.
 *
 * @param parentElement - The select component container
 * @param valueElement - The value element to insert
 */
function insertValueSlot(parentElement, valueElement) {
    if (!parentElement || !valueElement) {
        return;
    }
    if (parentElement.firstChild) {
        parentElement.insertBefore(valueElement, parentElement.firstChild);
    }
    else {
        parentElement.appendChild(valueElement);
    }
}
/**
 * Calculates how many selected values overflow the visible area in multi-select mode.
 * Uses bounding rectangles to determine which values extend beyond the container width,
 * accounting for ellipsis buffer space.
 *
 * @param element - The select component root element
 * @param isMultiple - Whether multi-select mode is enabled
 * @param hasSelections - Whether there are any selected values
 * @returns Number of overflowing values (for "+N" badge display)
 */
function calculateOverflowCount(element, isMultiple, hasSelections) {
    if (!isMultiple || !hasSelections) {
        return 0;
    }
    const valueSlot = element.querySelector('[slot="value"]');
    if (!valueSlot) {
        return 0;
    }
    const selectValues = Array.from(valueSlot.querySelectorAll('[multiple]'));
    const valueSlotRect = valueSlot.getBoundingClientRect();
    const overflowIndex = selectValues.findIndex((value) => {
        const selectValueRect = value.getBoundingClientRect();
        return selectValueRect ? selectValueRect.left + ELLIPSIS_BUFFER > valueSlotRect.right : false;
    });
    return overflowIndex !== -1 ? selectValues.length - overflowIndex : 0;
}
/**
 * Queries all cosmos-option elements within the given container.
 * Uses transformed tag names to support both regular and version-scoped components.
 *
 * @param element - Container element to search within
 * @returns Array of option elements found in document order
 */
function queryOptions(element) {
    return Array.from(element.querySelectorAll(`${transformTagName('cosmos-option')}`));
}
/**
 * Queries all cosmos-optgroup elements within the given container.
 * Uses transformed tag names to support both regular and version-scoped components.
 *
 * @param element - Container element to search within
 * @returns Array of optgroup elements found in document order
 */
function queryOptgroups(element) {
    return Array.from(element.querySelectorAll(`${transformTagName('cosmos-optgroup')}`));
}
/**
 * Determines if the given element is the first autofocus element in the document.
 * Used to prevent multiple elements from auto-focusing simultaneously.
 *
 * @param element - The element to check for autofocus priority
 * @returns True if this element should receive initial focus
 */
function isFirstAutofocusElement(element) {
    return global$1.document.querySelector('[autofocus]') === element;
}
/**
 * Extracts tag names from DOM mutation records for change detection.
 * Processes both added and removed nodes to detect option/optgroup changes.
 *
 * @param mutationList - Array of mutation records from MutationObserver
 * @returns Array of lowercase tag names that were added or removed
 */
function extractMutatedTagNames(mutationList) {
    return mutationList.reduce((acc, mutation) => {
        acc.push(...Array.from(mutation.addedNodes).map((node) => { var _a; return (_a = node === null || node === void 0 ? void 0 : node.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase(); }));
        acc.push(...Array.from(mutation.removedNodes).map((node) => { var _a; return (_a = node === null || node === void 0 ? void 0 : node.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase(); }));
        return acc;
    }, []);
}

const instancePool = new WeakMap();
/**
 * Creates or retrieves a dropdown instance for the given trigger element.
 * Uses instance pooling to prevent creating duplicate dropdowns on the same trigger.
 * Configures Tippy.js with manual triggering, viewport boundary detection, and flip behavior.
 *
 * @param config - Dropdown configuration object
 * @returns DropdownInstance with tippy instance and original config
 */
function createDropdown(config) {
    const existing = instancePool.get(config.trigger);
    if (existing) {
        return existing;
    }
    const tippyConfig = {
        appendTo: 'parent',
        trigger: 'manual',
        placement: config.placement || 'bottom',
        hideOnClick: false,
        showOnCreate: false,
        offset: config.offset || [0, 8],
        aria: {
            content: null,
            expanded: false,
        },
        interactive: true,
        popperOptions: {
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top', 'bottom'],
                        boundary: 'viewport',
                    },
                },
            ],
        },
        render: () => ({
            popper: Object.assign(config.container, { align: '' }),
        }),
        onShow: config.onShow,
        onHide: config.onHide,
    };
    const tippyInstance = tippy(config.trigger, tippyConfig);
    const instance = {
        tippy: tippyInstance,
        config,
    };
    instancePool.set(config.trigger, instance);
    return instance;
}
/**
 * Shows the dropdown with positioning and animation.
 *
 * @param instance - The dropdown instance to show
 */
function showDropdown(instance) {
    instance.tippy.show();
}
/**
 * Hides the dropdown with animation.
 *
 * @param instance - The dropdown instance to hide
 */
function hideDropdown(instance) {
    instance.tippy.hide();
}
/**
 * Destroys the dropdown instance, cleans up resources, and removes from instance pool.
 * Should be called when the component is unmounted to prevent memory leaks.
 *
 * @param instance - The dropdown instance to destroy
 */
function destroyDropdown(instance) {
    instance.tippy.destroy();
    instancePool.delete(instance.config.trigger);
}

/**
 * Creates a validation instance with the given configuration.
 * The instance manages validation state and form integration lifecycle.
 *
 * @param config - Validation configuration options
 * @returns New validation instance ready for form attachment
 */
function createValidation(config) {
    return {
        config: Object.assign({}, config),
        wasSubmitted: false,
        attachedForm: null,
        formDataHandler: null,
        submitHandler: null,
        resetHandler: null,
    };
}
/**
 * Attaches the validation instance to a form element.
 * Registers event listeners for form data, submit, and reset events.
 * Automatically detaches from any previously attached form.
 *
 * @param instance - The validation instance to attach
 * @param form - The form element to attach to
 */
function attachToForm(instance, form) {
    if (instance.attachedForm) {
        detachFromForm(instance);
    }
    instance.attachedForm = form;
    instance.formDataHandler = (event) => handleFormData(instance, event);
    instance.submitHandler = (event) => handleFormSubmit(instance, event);
    instance.resetHandler = () => handleFormReset(instance);
    form.addEventListener('formdata', instance.formDataHandler, true);
    form.addEventListener('submit', instance.submitHandler, true);
    form.addEventListener('reset', instance.resetHandler, true);
}
/**
 * Detaches the validation instance from its form element.
 * Removes all event listeners and clears form references to prevent memory leaks.
 *
 * @param instance - The validation instance to detach
 */
function detachFromForm(instance) {
    if (instance.attachedForm && instance.formDataHandler && instance.submitHandler && instance.resetHandler) {
        instance.attachedForm.removeEventListener('formdata', instance.formDataHandler, true);
        instance.attachedForm.removeEventListener('submit', instance.submitHandler, true);
        instance.attachedForm.removeEventListener('reset', instance.resetHandler, true);
    }
    instance.attachedForm = null;
    instance.formDataHandler = null;
    instance.submitHandler = null;
    instance.resetHandler = null;
}
/**
 * Validates the field according to its configuration.
 * Only performs validation if the field is marked as required.
 *
 * @param instance - The validation instance to validate
 * @returns True if valid or not required, false if required but empty
 */
function validate(instance) {
    if (!instance.config.required) {
        return true;
    }
    return instance.config.hasValue();
}
/**
 * Validates the field and reports the results to the component.
 * Updates invalid state and emits invalid events for failed validation.
 *
 * @param instance - The validation instance to validate and report
 * @returns True if valid, false if validation failed
 */
function reportValidity(instance) {
    const isValid = validate(instance);
    const isInvalid = !isValid;
    if (instance.config.onInvalidChange) {
        instance.config.onInvalidChange(isInvalid);
    }
    if (isInvalid && instance.config.emitInvalidEvent) {
        instance.config.emitInvalidEvent();
    }
    return isValid;
}
/**
 * Returns the appropriate validation error message.
 * Uses custom message if provided, otherwise generates browser default message.
 * Creates a ghost select element to get native browser validation messages.
 *
 * @param instance - The validation instance to get message for
 * @returns Validation error message, empty string if valid or in SSR
 */
function getMessage(instance) {
    if (instance.config.validationMessage) {
        return instance.config.validationMessage;
    }
    if (!instance.attachedForm || !global$1.document)
        return '';
    const ghostSelect = global$1.document.createElement('select');
    ghostSelect.required = !!instance.config.required;
    ghostSelect.name = instance.config.name || 'ghost';
    ghostSelect.style.position = 'absolute';
    ghostSelect.style.visibility = 'hidden';
    instance.attachedForm.appendChild(ghostSelect);
    const message = ghostSelect.validationMessage || '';
    instance.attachedForm.removeChild(ghostSelect);
    return message;
}
/**
 * Handles the 'formdata' event by appending the field value to FormData.
 * Skips disabled fields and handles both single and array values.
 *
 * @param instance - The validation instance
 * @param event - The FormData event
 */
function handleFormData(instance, event) {
    if (!instance.config.name || instance.config.disabled) {
        return;
    }
    const value = instance.config.getValue();
    if (value === undefined) {
        return;
    }
    if (Array.isArray(value)) {
        value.forEach((v) => {
            event.formData.append(instance.config.name, v);
        });
    }
    else {
        event.formData.append(instance.config.name, value);
    }
}
/**
 * Handles the 'submit' event by validating the field.
 * Marks the form as submitted and prevents submission if validation fails.
 *
 * @param instance - The validation instance
 * @param event - The form submit event
 */
function handleFormSubmit(instance, event) {
    instance.wasSubmitted = true;
    const isValid = reportValidity(instance);
    if (!isValid) {
        event.preventDefault();
    }
}
/**
 * Handles the 'reset' event by clearing validation state.
 * Resets submission flag and invalid state, triggers onReset callback if configured.
 *
 * @param instance - The validation instance
 */
function handleFormReset(instance) {
    instance.wasSubmitted = false;
    if (instance.config.onInvalidChange) {
        instance.config.onInvalidChange(false);
    }
    if (instance.onReset) {
        instance.onReset();
    }
}
/**
 * Determines if the invalid state is externally controlled.
 * When controlled, automatic validation is disabled to prevent conflicts.
 *
 * @param instance - The validation instance to check
 * @returns True if invalid state is controlled by external prop
 */
function isInvalidStateControlled(instance) {
    return instance.config.invalid === true;
}
/**
 * Performs validation only if the form was previously submitted.
 * Prevents validation noise before user attempts to submit the form.
 * Skips validation when invalid state is externally controlled.
 *
 * @param instance - The validation instance to conditionally revalidate
 */
function revalidateIfSubmitted(instance) {
    if (!isInvalidStateControlled(instance) && instance.wasSubmitted) {
        reportValidity(instance);
    }
}
/**
 * Updates the validation configuration with new settings.
 * Triggers invalid state change if the invalid property is updated.
 *
 * @param instance - The validation instance to update
 * @param config - Partial configuration object to merge with existing config
 */
function updateConfig(instance, config) {
    instance.config = Object.assign(Object.assign({}, instance.config), config);
    if ('invalid' in config && instance.config.onInvalidChange) {
        instance.config.onInvalidChange(config.invalid || false);
    }
}

/**
 * Handles keyboard navigation logic and typeahead functionality for select components.
 */
const PAGE_SIZE = 10;
const NAVIGATION_KEYS = ['ArrowDown', 'ArrowUp', 'Escape', 'Home', 'End', 'PageUp', 'PageDown', 'Enter', 'Tab'];
/**
 * Determines if a key should be ignored when search input is focused.
 * When search is focused, only navigation keys should be processed.
 */
function shouldIgnoreKeyForSearch(key, context) {
    if (!context.isSearchable || !context.isSearchInputFocused) {
        return false;
    }
    const isNavigationKey = NAVIGATION_KEYS.includes(key);
    return !isNavigationKey;
}
/**
 * Self-contained typeahead buffer that manages character sequence timing and matching logic.
 * Handles rapid typing with smart detection of repeated characters vs. new sequences.
 * Automatically clears after timeout to start fresh sequences.
 */
class TypeaheadBuffer {
    constructor() {
        this.buffer = '';
        this.wasEmpty = true;
        this.timeout = 500;
    }
    /**
     * Adds a character to the typeahead buffer and returns the current search term.
     * Handles repeated single characters differently from multi-character sequences.
     *
     * @param char - Single character to add to the buffer
     * @returns Current typeahead search term after adding the character
     */
    add(char) {
        clearTimeout(this.timer);
        this.wasEmpty = this.buffer === '';
        if (this.buffer === char && this.buffer.length === 1) {
            this.wasEmpty = false;
        }
        else if (this.buffer !== char || this.buffer.length > 1) {
            this.buffer += char;
        }
        this.timer = setTimeout(() => this.clear(), this.timeout);
        return this.buffer;
    }
    /**
     * Clears the typeahead buffer and resets all state.
     * Cancels any pending timeout to prevent unwanted clearing.
     */
    clear() {
        this.buffer = '';
        this.wasEmpty = true;
        clearTimeout(this.timer);
    }
    /**
     * Keeps only the last character in the buffer, discarding previous characters.
     * Used when a multi-character search fails to find matches.
     */
    useLastChar() {
        this.buffer = this.buffer.slice(-1);
        this.wasEmpty = false;
    }
    /**
     * Determines if the typeahead should stay on the currently focused option.
     * Returns true when typing the first character that matches the current option.
     *
     * @param currentLabel - Label of the currently focused option
     * @returns True if should stay on current option, false if should search for next match
     */
    shouldStayOnCurrent(currentLabel) {
        if (!currentLabel || this.buffer.length !== 1) {
            return false;
        }
        if (!this.wasEmpty) {
            return false;
        }
        return currentLabel.toLowerCase().startsWith(this.buffer.toLowerCase());
    }
}
/**
 * Processes keyboard input and returns navigation actions to perform.
 * Single source of truth for all keyboard navigation logic including arrow keys,
 * typeahead, selection, and dropdown control. Handles differences between
 * single/multi-select and searchable/non-searchable modes.
 *
 * @param key - The keyboard key that was pressed
 * @param modifiers - Object containing modifier key states (alt, ctrl)
 * @param context - Current component state needed for navigation decisions
 * @returns Navigation result object or null if key should be ignored
 */
function processKeyboardInput(key, modifiers, context) {
    var _a;
    const { isOpen, isMultiple, isSearchable, activeIndex, optionCount, selectedIndex } = context;
    if (shouldIgnoreKeyForSearch(key, context)) {
        return null;
    }
    if (key === 'Escape') {
        return {
            targetIndex: activeIndex !== null && activeIndex !== void 0 ? activeIndex : 0,
            shouldCloseDropdown: true,
            shouldPreventDefault: true,
        };
    }
    if (optionCount === 0) {
        return null;
    }
    const shouldEnableTypeahead = !isSearchable || !context.isSearchInputFocused;
    const isTypeaheadKey = shouldEnableTypeahead && key.length === 1 && !modifiers.alt && !modifiers.ctrl && key !== ' ';
    if (isTypeaheadKey) {
        return {
            targetIndex: (_a = activeIndex !== null && activeIndex !== void 0 ? activeIndex : selectedIndex) !== null && _a !== void 0 ? _a : 0,
            shouldOpenDropdown: !isOpen,
            typeaheadKey: key,
            shouldPreventDefault: true,
            shouldFocusSearch: false,
        };
    }
    const shouldPreventDefault = key !== 'Tab';
    if (!isOpen) {
        switch (key) {
            case 'ArrowDown':
            case 'ArrowUp':
                return {
                    targetIndex: selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : 0,
                    shouldOpenDropdown: true,
                    shouldFocusSearch: isSearchable,
                    shouldPreventDefault,
                };
            case 'Enter':
            case ' ':
                return {
                    targetIndex: selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : 0,
                    shouldOpenDropdown: true,
                    shouldFocusSearch: isSearchable,
                    shouldPreventDefault,
                };
            case 'Home':
                return {
                    targetIndex: 0,
                    shouldOpenDropdown: true,
                    shouldFocusSearch: isSearchable,
                    shouldPreventDefault,
                };
            case 'End':
                return {
                    targetIndex: optionCount - 1,
                    shouldOpenDropdown: true,
                    shouldPreventDefault,
                };
            default:
                return null;
        }
    }
    switch (key) {
        case 'Tab':
            if (isMultiple) {
                return {
                    targetIndex: activeIndex !== null && activeIndex !== void 0 ? activeIndex : 0,
                    shouldCloseDropdown: true,
                    shouldPreventDefault,
                };
            }
            else {
                return {
                    targetIndex: activeIndex !== null && activeIndex !== void 0 ? activeIndex : 0,
                    shouldSelect: true,
                    shouldCloseDropdown: true,
                    shouldPreventDefault,
                };
            }
        case 'Enter':
        case ' ':
            return {
                targetIndex: activeIndex !== null && activeIndex !== void 0 ? activeIndex : 0,
                shouldSelect: true,
                shouldCloseDropdown: !isMultiple,
                shouldPreventDefault,
            };
        case 'ArrowDown':
            if (modifiers.alt) {
                return {
                    targetIndex: activeIndex !== null && activeIndex !== void 0 ? activeIndex : 0,
                    shouldSelect: true,
                    shouldCloseDropdown: true,
                    shouldPreventDefault,
                };
            }
            if (activeIndex === undefined && selectedIndex !== undefined) {
                return {
                    targetIndex: selectedIndex,
                    shouldPreventDefault,
                };
            }
            return {
                targetIndex: getNextIndex(activeIndex, optionCount, selectedIndex),
                shouldPreventDefault,
            };
        case 'ArrowUp':
            if (modifiers.alt) {
                return {
                    targetIndex: activeIndex !== null && activeIndex !== void 0 ? activeIndex : 0,
                    shouldCloseDropdown: true,
                    shouldPreventDefault,
                };
            }
            if (isSearchable && activeIndex === 0) {
                return {
                    targetIndex: undefined,
                    shouldFocusSearch: true,
                    shouldPreventDefault,
                };
            }
            if (activeIndex === undefined && selectedIndex !== undefined) {
                return {
                    targetIndex: selectedIndex,
                    shouldPreventDefault,
                };
            }
            return {
                targetIndex: getPreviousIndex(activeIndex, optionCount, selectedIndex),
                shouldPreventDefault,
            };
        case 'Home':
            return {
                targetIndex: 0,
                shouldPreventDefault,
            };
        case 'End':
            return {
                targetIndex: optionCount - 1,
                shouldPreventDefault,
            };
        case 'PageDown':
            return {
                targetIndex: getPageDownIndex(activeIndex, optionCount),
                shouldPreventDefault,
            };
        case 'PageUp':
            return {
                targetIndex: getPageUpIndex(activeIndex),
                shouldPreventDefault,
            };
        default:
            return null;
    }
}
function getNextIndex(current, total, selectedIndex) {
    if (current === undefined) {
        return selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : 0;
    }
    return (current + 1) % total;
}
function getPreviousIndex(current, total, selectedIndex) {
    if (current === undefined) {
        return selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : 0;
    }
    return current === 0 ? total - 1 : current - 1;
}
function getPageDownIndex(current, total) {
    const index = current !== null && current !== void 0 ? current : 0;
    return Math.min(index + PAGE_SIZE, total - 1);
}
function getPageUpIndex(current) {
    const index = current !== null && current !== void 0 ? current : 0;
    return Math.max(index - PAGE_SIZE, 0);
}
/**
 * Finds the next option whose label starts with the given search term.
 * Performs circular search starting from current index with optional cycling.
 * Falls back to last character search if multi-character search fails.
 *
 * @param labels - Array of option labels to search through
 * @param searchTerm - Text to match against option labels (case-insensitive)
 * @param currentIndex - Current option index to start search from
 * @param skipCurrent - Whether to skip the current index in search
 * @returns Index of matching option, -1 if no match found
 */
function findTypeaheadMatch(labels, searchTerm, currentIndex, skipCurrent = false) {
    if (!searchTerm || !labels.length)
        return -1;
    const term = searchTerm.toLowerCase();
    const start = skipCurrent ? currentIndex + 1 : Math.max(0, currentIndex);
    for (let i = 0; i < labels.length; i++) {
        const idx = (start + i) % labels.length;
        if (labels[idx].toLowerCase().startsWith(term)) {
            return idx;
        }
    }
    if (searchTerm.length > 1) {
        return findTypeaheadMatch(labels, searchTerm.slice(-1), currentIndex, false);
    }
    return -1;
}

/**
 * Fuse.js v7.1.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2025 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */

function isArray(value) {
  return !Array.isArray
    ? getTag(value) === '[object Array]'
    : Array.isArray(value)
}
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value
  }
  let result = value + '';
  return result == '0' && 1 / value == -Infinity ? '-0' : result
}

function toString(value) {
  return value == null ? '' : baseToString(value)
}

function isString(value) {
  return typeof value === 'string'
}

function isNumber(value) {
  return typeof value === 'number'
}

// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function isBoolean(value) {
  return (
    value === true ||
    value === false ||
    (isObjectLike(value) && getTag(value) == '[object Boolean]')
  )
}

function isObject(value) {
  return typeof value === 'object'
}

// Checks if `value` is object-like.
function isObjectLike(value) {
  return isObject(value) && value !== null
}

function isDefined(value) {
  return value !== undefined && value !== null
}

function isBlank(value) {
  return !value.trim().length
}

// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function getTag(value) {
  return value == null
    ? value === undefined
      ? '[object Undefined]'
      : '[object Null]'
    : Object.prototype.toString.call(value)
}

const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";

const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key) =>
  `Invalid value for key ${key}`;

const PATTERN_LENGTH_TOO_LARGE = (max) =>
  `Pattern length exceeds max of ${max}.`;

const MISSING_KEY_PROPERTY = (name) => `Missing ${name} property in key`;

const INVALID_KEY_WEIGHT_VALUE = (key) =>
  `Property 'weight' in key '${key}' must be a positive integer`;

const hasOwn = Object.prototype.hasOwnProperty;

class KeyStore {
  constructor(keys) {
    this._keys = [];
    this._keyMap = {};

    let totalWeight = 0;

    keys.forEach((key) => {
      let obj = createKey(key);

      this._keys.push(obj);
      this._keyMap[obj.id] = obj;

      totalWeight += obj.weight;
    });

    // Normalize weights so that their sum is equal to 1
    this._keys.forEach((key) => {
      key.weight /= totalWeight;
    });
  }
  get(keyId) {
    return this._keyMap[keyId]
  }
  keys() {
    return this._keys
  }
  toJSON() {
    return JSON.stringify(this._keys)
  }
}

function createKey(key) {
  let path = null;
  let id = null;
  let src = null;
  let weight = 1;
  let getFn = null;

  if (isString(key) || isArray(key)) {
    src = key;
    path = createKeyPath(key);
    id = createKeyId(key);
  } else {
    if (!hasOwn.call(key, 'name')) {
      throw new Error(MISSING_KEY_PROPERTY('name'))
    }

    const name = key.name;
    src = name;

    if (hasOwn.call(key, 'weight')) {
      weight = key.weight;

      if (weight <= 0) {
        throw new Error(INVALID_KEY_WEIGHT_VALUE(name))
      }
    }

    path = createKeyPath(name);
    id = createKeyId(name);
    getFn = key.getFn;
  }

  return { path, id, weight, src, getFn }
}

function createKeyPath(key) {
  return isArray(key) ? key : key.split('.')
}

function createKeyId(key) {
  return isArray(key) ? key.join('.') : key
}

function get(obj, path) {
  let list = [];
  let arr = false;

  const deepGet = (obj, path, index) => {
    if (!isDefined(obj)) {
      return
    }
    if (!path[index]) {
      // If there's no path left, we've arrived at the object we care about.
      list.push(obj);
    } else {
      let key = path[index];

      const value = obj[key];

      if (!isDefined(value)) {
        return
      }

      // If we're at the last value in the path, and if it's a string/number/bool,
      // add it to the list
      if (
        index === path.length - 1 &&
        (isString(value) || isNumber(value) || isBoolean(value))
      ) {
        list.push(toString(value));
      } else if (isArray(value)) {
        arr = true;
        // Search each item in the array.
        for (let i = 0, len = value.length; i < len; i += 1) {
          deepGet(value[i], path, index + 1);
        }
      } else if (path.length) {
        // An object. Recurse further.
        deepGet(value, path, index + 1);
      }
    }
  };

  // Backwards compatibility (since path used to be a string)
  deepGet(obj, isString(path) ? path.split('.') : path, 0);

  return arr ? list : list[0]
}

const MatchOptions = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: false,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: false,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
};

const BasicOptions = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: false,
  // When `true`, the algorithm will ignore diacritics (accents) in comparisons
  ignoreDiacritics: false,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: false,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: true,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (a, b) =>
    a.score === b.score ? (a.idx < b.idx ? -1 : 1) : a.score < b.score ? -1 : 1
};

const FuzzyOptions = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
};

const AdvancedOptions = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: false,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: get,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: false,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: false,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};

var Config = {
  ...BasicOptions,
  ...MatchOptions,
  ...FuzzyOptions,
  ...AdvancedOptions
};

const SPACE = /[^ ]+/g;

// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function norm(weight = 1, mantissa = 3) {
  const cache = new Map();
  const m = Math.pow(10, mantissa);

  return {
    get(value) {
      const numTokens = value.match(SPACE).length;

      if (cache.has(numTokens)) {
        return cache.get(numTokens)
      }

      // Default function is 1/sqrt(x), weight makes that variable
      const norm = 1 / Math.pow(numTokens, 0.5 * weight);

      // In place of `toFixed(mantissa)`, for faster computation
      const n = parseFloat(Math.round(norm * m) / m);

      cache.set(numTokens, n);

      return n
    },
    clear() {
      cache.clear();
    }
  }
}

class FuseIndex {
  constructor({
    getFn = Config.getFn,
    fieldNormWeight = Config.fieldNormWeight
  } = {}) {
    this.norm = norm(fieldNormWeight, 3);
    this.getFn = getFn;
    this.isCreated = false;

    this.setIndexRecords();
  }
  setSources(docs = []) {
    this.docs = docs;
  }
  setIndexRecords(records = []) {
    this.records = records;
  }
  setKeys(keys = []) {
    this.keys = keys;
    this._keysMap = {};
    keys.forEach((key, idx) => {
      this._keysMap[key.id] = idx;
    });
  }
  create() {
    if (this.isCreated || !this.docs.length) {
      return
    }

    this.isCreated = true;

    // List is Array<String>
    if (isString(this.docs[0])) {
      this.docs.forEach((doc, docIndex) => {
        this._addString(doc, docIndex);
      });
    } else {
      // List is Array<Object>
      this.docs.forEach((doc, docIndex) => {
        this._addObject(doc, docIndex);
      });
    }

    this.norm.clear();
  }
  // Adds a doc to the end of the index
  add(doc) {
    const idx = this.size();

    if (isString(doc)) {
      this._addString(doc, idx);
    } else {
      this._addObject(doc, idx);
    }
  }
  // Removes the doc at the specified index of the index
  removeAt(idx) {
    this.records.splice(idx, 1);

    // Change ref index of every subsquent doc
    for (let i = idx, len = this.size(); i < len; i += 1) {
      this.records[i].i -= 1;
    }
  }
  getValueForItemAtKeyId(item, keyId) {
    return item[this._keysMap[keyId]]
  }
  size() {
    return this.records.length
  }
  _addString(doc, docIndex) {
    if (!isDefined(doc) || isBlank(doc)) {
      return
    }

    let record = {
      v: doc,
      i: docIndex,
      n: this.norm.get(doc)
    };

    this.records.push(record);
  }
  _addObject(doc, docIndex) {
    let record = { i: docIndex, $: {} };

    // Iterate over every key (i.e, path), and fetch the value at that key
    this.keys.forEach((key, keyIndex) => {
      let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);

      if (!isDefined(value)) {
        return
      }

      if (isArray(value)) {
        let subRecords = [];
        const stack = [{ nestedArrIndex: -1, value }];

        while (stack.length) {
          const { nestedArrIndex, value } = stack.pop();

          if (!isDefined(value)) {
            continue
          }

          if (isString(value) && !isBlank(value)) {
            let subRecord = {
              v: value,
              i: nestedArrIndex,
              n: this.norm.get(value)
            };

            subRecords.push(subRecord);
          } else if (isArray(value)) {
            value.forEach((item, k) => {
              stack.push({
                nestedArrIndex: k,
                value: item
              });
            });
          } else ;
        }
        record.$[keyIndex] = subRecords;
      } else if (isString(value) && !isBlank(value)) {
        let subRecord = {
          v: value,
          n: this.norm.get(value)
        };

        record.$[keyIndex] = subRecord;
      }
    });

    this.records.push(record);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    }
  }
}

function createIndex(
  keys,
  docs,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys.map(createKey));
  myIndex.setSources(docs);
  myIndex.create();
  return myIndex
}

function parseIndex(
  data,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const { keys, records } = data;
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys);
  myIndex.setIndexRecords(records);
  return myIndex
}

function computeScore$1(
  pattern,
  {
    errors = 0,
    currentLocation = 0,
    expectedLocation = 0,
    distance = Config.distance,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  const accuracy = errors / pattern.length;

  if (ignoreLocation) {
    return accuracy
  }

  const proximity = Math.abs(expectedLocation - currentLocation);

  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy
  }

  return accuracy + proximity / distance
}

function convertMaskToIndices(
  matchmask = [],
  minMatchCharLength = Config.minMatchCharLength
) {
  let indices = [];
  let start = -1;
  let end = -1;
  let i = 0;

  for (let len = matchmask.length; i < len; i += 1) {
    let match = matchmask[i];
    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;
      if (end - start + 1 >= minMatchCharLength) {
        indices.push([start, end]);
      }
      start = -1;
    }
  }

  // (i-1 - start) + 1 => i - start
  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    indices.push([start, i - 1]);
  }

  return indices
}

// Machine word size
const MAX_BITS = 32;

function search$1(
  text,
  pattern,
  patternAlphabet,
  {
    location = Config.location,
    distance = Config.distance,
    threshold = Config.threshold,
    findAllMatches = Config.findAllMatches,
    minMatchCharLength = Config.minMatchCharLength,
    includeMatches = Config.includeMatches,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  if (pattern.length > MAX_BITS) {
    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS))
  }

  const patternLen = pattern.length;
  // Set starting location at beginning text and initialize the alphabet.
  const textLen = text.length;
  // Handle the case when location > text.length
  const expectedLocation = Math.max(0, Math.min(location, textLen));
  // Highest score beyond which we give up.
  let currentThreshold = threshold;
  // Is there a nearby exact match? (speedup)
  let bestLocation = expectedLocation;

  // Performance: only computer matches when the minMatchCharLength > 1
  // OR if `includeMatches` is true.
  const computeMatches = minMatchCharLength > 1 || includeMatches;
  // A mask of the matches, used for building the indices
  const matchMask = computeMatches ? Array(textLen) : [];

  let index;

  // Get all exact matches, here for speed up
  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
    let score = computeScore$1(pattern, {
      currentLocation: index,
      expectedLocation,
      distance,
      ignoreLocation
    });

    currentThreshold = Math.min(score, currentThreshold);
    bestLocation = index + patternLen;

    if (computeMatches) {
      let i = 0;
      while (i < patternLen) {
        matchMask[index + i] = 1;
        i += 1;
      }
    }
  }

  // Reset the best location
  bestLocation = -1;

  let lastBitArr = [];
  let finalScore = 1;
  let binMax = patternLen + textLen;

  const mask = 1 << (patternLen - 1);

  for (let i = 0; i < patternLen; i += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    let binMin = 0;
    let binMid = binMax;

    while (binMin < binMid) {
      const score = computeScore$1(pattern, {
        errors: i,
        currentLocation: expectedLocation + binMid,
        expectedLocation,
        distance,
        ignoreLocation
      });

      if (score <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }

      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }

    // Use the result from this iteration as the maximum for the next.
    binMax = binMid;

    let start = Math.max(1, expectedLocation - binMid + 1);
    let finish = findAllMatches
      ? textLen
      : Math.min(expectedLocation + binMid, textLen) + patternLen;

    // Initialize the bit array
    let bitArr = Array(finish + 2);

    bitArr[finish + 1] = (1 << i) - 1;

    for (let j = finish; j >= start; j -= 1) {
      let currentLocation = j - 1;
      let charMatch = patternAlphabet[text.charAt(currentLocation)];

      if (computeMatches) {
        // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
        matchMask[currentLocation] = +!!charMatch;
      }

      // First pass: exact match
      bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch;

      // Subsequent passes: fuzzy match
      if (i) {
        bitArr[j] |=
          ((lastBitArr[j + 1] | lastBitArr[j]) << 1) | 1 | lastBitArr[j + 1];
      }

      if (bitArr[j] & mask) {
        finalScore = computeScore$1(pattern, {
          errors: i,
          currentLocation,
          expectedLocation,
          distance,
          ignoreLocation
        });

        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation;

          // Already passed `loc`, downhill from here on in.
          if (bestLocation <= expectedLocation) {
            break
          }

          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }

    // No hope for a (better) match at greater error levels.
    const score = computeScore$1(pattern, {
      errors: i + 1,
      currentLocation: expectedLocation,
      expectedLocation,
      distance,
      ignoreLocation
    });

    if (score > currentThreshold) {
      break
    }

    lastBitArr = bitArr;
  }

  const result = {
    isMatch: bestLocation >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(0.001, finalScore)
  };

  if (computeMatches) {
    const indices = convertMaskToIndices(matchMask, minMatchCharLength);
    if (!indices.length) {
      result.isMatch = false;
    } else if (includeMatches) {
      result.indices = indices;
    }
  }

  return result
}

function createPatternAlphabet(pattern) {
  let mask = {};

  for (let i = 0, len = pattern.length; i < len; i += 1) {
    const char = pattern.charAt(i);
    mask[char] = (mask[char] || 0) | (1 << (len - i - 1));
  }

  return mask
}

const stripDiacritics = String.prototype.normalize
    ? ((str) => str.normalize('NFD').replace(/[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]/g, ''))
    : ((str) => str);

class BitapSearch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreDiacritics = Config.ignoreDiacritics,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    this.options = {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreDiacritics,
      ignoreLocation
    };

    pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    pattern = ignoreDiacritics ? stripDiacritics(pattern) : pattern;
    this.pattern = pattern;

    this.chunks = [];

    if (!this.pattern.length) {
      return
    }

    const addChunk = (pattern, startIndex) => {
      this.chunks.push({
        pattern,
        alphabet: createPatternAlphabet(pattern),
        startIndex
      });
    };

    const len = this.pattern.length;

    if (len > MAX_BITS) {
      let i = 0;
      const remainder = len % MAX_BITS;
      const end = len - remainder;

      while (i < end) {
        addChunk(this.pattern.substr(i, MAX_BITS), i);
        i += MAX_BITS;
      }

      if (remainder) {
        const startIndex = len - MAX_BITS;
        addChunk(this.pattern.substr(startIndex), startIndex);
      }
    } else {
      addChunk(this.pattern, 0);
    }
  }

  searchIn(text) {
    const { isCaseSensitive, ignoreDiacritics, includeMatches } = this.options;

    text = isCaseSensitive ? text : text.toLowerCase();
    text = ignoreDiacritics ? stripDiacritics(text) : text;

    // Exact match
    if (this.pattern === text) {
      let result = {
        isMatch: true,
        score: 0
      };

      if (includeMatches) {
        result.indices = [[0, text.length - 1]];
      }

      return result
    }

    // Otherwise, use Bitap algorithm
    const {
      location,
      distance,
      threshold,
      findAllMatches,
      minMatchCharLength,
      ignoreLocation
    } = this.options;

    let allIndices = [];
    let totalScore = 0;
    let hasMatches = false;

    this.chunks.forEach(({ pattern, alphabet, startIndex }) => {
      const { isMatch, score, indices } = search$1(text, pattern, alphabet, {
        location: location + startIndex,
        distance,
        threshold,
        findAllMatches,
        minMatchCharLength,
        includeMatches,
        ignoreLocation
      });

      if (isMatch) {
        hasMatches = true;
      }

      totalScore += score;

      if (isMatch && indices) {
        allIndices = [...allIndices, ...indices];
      }
    });

    let result = {
      isMatch: hasMatches,
      score: hasMatches ? totalScore / this.chunks.length : 1
    };

    if (hasMatches && includeMatches) {
      result.indices = allIndices;
    }

    return result
  }
}

class BaseMatch {
  constructor(pattern) {
    this.pattern = pattern;
  }
  static isMultiMatch(pattern) {
    return getMatch(pattern, this.multiRegex)
  }
  static isSingleMatch(pattern) {
    return getMatch(pattern, this.singleRegex)
  }
  search(/*text*/) {}
}

function getMatch(pattern, exp) {
  const matches = pattern.match(exp);
  return matches ? matches[1] : null
}

// Token: 'file

class ExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'exact'
  }
  static get multiRegex() {
    return /^="(.*)"$/
  }
  static get singleRegex() {
    return /^=(.*)$/
  }
  search(text) {
    const isMatch = text === this.pattern;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !fire

class InverseExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"$/
  }
  static get singleRegex() {
    return /^!(.*)$/
  }
  search(text) {
    const index = text.indexOf(this.pattern);
    const isMatch = index === -1;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: ^file

class PrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'prefix-exact'
  }
  static get multiRegex() {
    return /^\^"(.*)"$/
  }
  static get singleRegex() {
    return /^\^(.*)$/
  }
  search(text) {
    const isMatch = text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !^fire

class InversePrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-prefix-exact'
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/
  }
  static get singleRegex() {
    return /^!\^(.*)$/
  }
  search(text) {
    const isMatch = !text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: .file$

class SuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'suffix-exact'
  }
  static get multiRegex() {
    return /^"(.*)"\$$/
  }
  static get singleRegex() {
    return /^(.*)\$$/
  }
  search(text) {
    const isMatch = text.endsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [text.length - this.pattern.length, text.length - 1]
    }
  }
}

// Token: !.file$

class InverseSuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-suffix-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/
  }
  static get singleRegex() {
    return /^!(.*)\$$/
  }
  search(text) {
    const isMatch = !text.endsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

class FuzzyMatch extends BaseMatch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreDiacritics = Config.ignoreDiacritics,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    super(pattern);
    this._bitapSearch = new BitapSearch(pattern, {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreDiacritics,
      ignoreLocation
    });
  }
  static get type() {
    return 'fuzzy'
  }
  static get multiRegex() {
    return /^"(.*)"$/
  }
  static get singleRegex() {
    return /^(.*)$/
  }
  search(text) {
    return this._bitapSearch.searchIn(text)
  }
}

// Token: 'file

class IncludeMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'include'
  }
  static get multiRegex() {
    return /^'"(.*)"$/
  }
  static get singleRegex() {
    return /^'(.*)$/
  }
  search(text) {
    let location = 0;
    let index;

    const indices = [];
    const patternLen = this.pattern.length;

    // Get all exact matches
    while ((index = text.indexOf(this.pattern, location)) > -1) {
      location = index + patternLen;
      indices.push([index, location - 1]);
    }

    const isMatch = !!indices.length;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices
    }
  }
}

// ❗Order is important. DO NOT CHANGE.
const searchers = [
  ExactMatch,
  IncludeMatch,
  PrefixExactMatch,
  InversePrefixExactMatch,
  InverseSuffixExactMatch,
  SuffixExactMatch,
  InverseExactMatch,
  FuzzyMatch
];

const searchersLen = searchers.length;

// Regex to split by spaces, but keep anything in quotes together
const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const OR_TOKEN = '|';

// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function parseQuery(pattern, options = {}) {
  return pattern.split(OR_TOKEN).map((item) => {
    let query = item
      .trim()
      .split(SPACE_RE)
      .filter((item) => item && !!item.trim());

    let results = [];
    for (let i = 0, len = query.length; i < len; i += 1) {
      const queryItem = query[i];

      // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
      let found = false;
      let idx = -1;
      while (!found && ++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isMultiMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          found = true;
        }
      }

      if (found) {
        continue
      }

      // 2. Handle single query matches (i.e, once that are *not* quoted)
      idx = -1;
      while (++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isSingleMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          break
        }
      }
    }

    return results
  })
}

// These extended matchers can return an array of matches, as opposed
// to a singl match
const MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);

/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */
class ExtendedSearch {
  constructor(
    pattern,
    {
      isCaseSensitive = Config.isCaseSensitive,
      ignoreDiacritics = Config.ignoreDiacritics,
      includeMatches = Config.includeMatches,
      minMatchCharLength = Config.minMatchCharLength,
      ignoreLocation = Config.ignoreLocation,
      findAllMatches = Config.findAllMatches,
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance
    } = {}
  ) {
    this.query = null;
    this.options = {
      isCaseSensitive,
      ignoreDiacritics,
      includeMatches,
      minMatchCharLength,
      findAllMatches,
      ignoreLocation,
      location,
      threshold,
      distance
    };

    pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    pattern = ignoreDiacritics ? stripDiacritics(pattern) : pattern;
    this.pattern = pattern;
    this.query = parseQuery(this.pattern, this.options);
  }

  static condition(_, options) {
    return options.useExtendedSearch
  }

  searchIn(text) {
    const query = this.query;

    if (!query) {
      return {
        isMatch: false,
        score: 1
      }
    }

    const { includeMatches, isCaseSensitive, ignoreDiacritics } = this.options;

    text = isCaseSensitive ? text : text.toLowerCase();
    text = ignoreDiacritics ? stripDiacritics(text) : text;

    let numMatches = 0;
    let allIndices = [];
    let totalScore = 0;

    // ORs
    for (let i = 0, qLen = query.length; i < qLen; i += 1) {
      const searchers = query[i];

      // Reset indices
      allIndices.length = 0;
      numMatches = 0;

      // ANDs
      for (let j = 0, pLen = searchers.length; j < pLen; j += 1) {
        const searcher = searchers[j];
        const { isMatch, indices, score } = searcher.search(text);

        if (isMatch) {
          numMatches += 1;
          totalScore += score;
          if (includeMatches) {
            const type = searcher.constructor.type;
            if (MultiMatchSet.has(type)) {
              allIndices = [...allIndices, ...indices];
            } else {
              allIndices.push(indices);
            }
          }
        } else {
          totalScore = 0;
          numMatches = 0;
          allIndices.length = 0;
          break
        }
      }

      // OR condition, so if TRUE, return
      if (numMatches) {
        let result = {
          isMatch: true,
          score: totalScore / numMatches
        };

        if (includeMatches) {
          result.indices = allIndices;
        }

        return result
      }
    }

    // Nothing was matched
    return {
      isMatch: false,
      score: 1
    }
  }
}

const registeredSearchers = [];

function register(...args) {
  registeredSearchers.push(...args);
}

function createSearcher(pattern, options) {
  for (let i = 0, len = registeredSearchers.length; i < len; i += 1) {
    let searcherClass = registeredSearchers[i];
    if (searcherClass.condition(pattern, options)) {
      return new searcherClass(pattern, options)
    }
  }

  return new BitapSearch(pattern, options)
}

const LogicalOperator = {
  AND: '$and',
  OR: '$or'
};

const KeyType = {
  PATH: '$path',
  PATTERN: '$val'
};

const isExpression = (query) =>
  !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);

const isPath = (query) => !!query[KeyType.PATH];

const isLeaf = (query) =>
  !isArray(query) && isObject(query) && !isExpression(query);

const convertToExplicit = (query) => ({
  [LogicalOperator.AND]: Object.keys(query).map((key) => ({
    [key]: query[key]
  }))
});

// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function parse(query, options, { auto = true } = {}) {
  const next = (query) => {
    let keys = Object.keys(query);

    const isQueryPath = isPath(query);

    if (!isQueryPath && keys.length > 1 && !isExpression(query)) {
      return next(convertToExplicit(query))
    }

    if (isLeaf(query)) {
      const key = isQueryPath ? query[KeyType.PATH] : keys[0];

      const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];

      if (!isString(pattern)) {
        throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key))
      }

      const obj = {
        keyId: createKeyId(key),
        pattern
      };

      if (auto) {
        obj.searcher = createSearcher(pattern, options);
      }

      return obj
    }

    let node = {
      children: [],
      operator: keys[0]
    };

    keys.forEach((key) => {
      const value = query[key];

      if (isArray(value)) {
        value.forEach((item) => {
          node.children.push(next(item));
        });
      }
    });

    return node
  };

  if (!isExpression(query)) {
    query = convertToExplicit(query);
  }

  return next(query)
}

// Practical scoring function
function computeScore(
  results,
  { ignoreFieldNorm = Config.ignoreFieldNorm }
) {
  results.forEach((result) => {
    let totalScore = 1;

    result.matches.forEach(({ key, norm, score }) => {
      const weight = key ? key.weight : null;

      totalScore *= Math.pow(
        score === 0 && weight ? Number.EPSILON : score,
        (weight || 1) * (ignoreFieldNorm ? 1 : norm)
      );
    });

    result.score = totalScore;
  });
}

function transformMatches(result, data) {
  const matches = result.matches;
  data.matches = [];

  if (!isDefined(matches)) {
    return
  }

  matches.forEach((match) => {
    if (!isDefined(match.indices) || !match.indices.length) {
      return
    }

    const { indices, value } = match;

    let obj = {
      indices,
      value
    };

    if (match.key) {
      obj.key = match.key.src;
    }

    if (match.idx > -1) {
      obj.refIndex = match.idx;
    }

    data.matches.push(obj);
  });
}

function transformScore(result, data) {
  data.score = result.score;
}

function format(
  results,
  docs,
  {
    includeMatches = Config.includeMatches,
    includeScore = Config.includeScore
  } = {}
) {
  const transformers = [];

  if (includeMatches) transformers.push(transformMatches);
  if (includeScore) transformers.push(transformScore);

  return results.map((result) => {
    const { idx } = result;

    const data = {
      item: docs[idx],
      refIndex: idx
    };

    if (transformers.length) {
      transformers.forEach((transformer) => {
        transformer(result, data);
      });
    }

    return data
  })
}

class Fuse {
  constructor(docs, options = {}, index) {
    this.options = { ...Config, ...options };

    this._keyStore = new KeyStore(this.options.keys);

    this.setCollection(docs, index);
  }

  setCollection(docs, index) {
    this._docs = docs;

    if (index && !(index instanceof FuseIndex)) {
      throw new Error(INCORRECT_INDEX_TYPE)
    }

    this._myIndex =
      index ||
      createIndex(this.options.keys, this._docs, {
        getFn: this.options.getFn,
        fieldNormWeight: this.options.fieldNormWeight
      });
  }

  add(doc) {
    if (!isDefined(doc)) {
      return
    }

    this._docs.push(doc);
    this._myIndex.add(doc);
  }

  remove(predicate = (/* doc, idx */) => false) {
    const results = [];

    for (let i = 0, len = this._docs.length; i < len; i += 1) {
      const doc = this._docs[i];
      if (predicate(doc, i)) {
        this.removeAt(i);
        i -= 1;
        len -= 1;

        results.push(doc);
      }
    }

    return results
  }

  removeAt(idx) {
    this._docs.splice(idx, 1);
    this._myIndex.removeAt(idx);
  }

  getIndex() {
    return this._myIndex
  }

  search(query, { limit = -1 } = {}) {
    const {
      includeMatches,
      includeScore,
      shouldSort,
      sortFn,
      ignoreFieldNorm
    } = this.options;

    let results = isString(query)
      ? isString(this._docs[0])
        ? this._searchStringList(query)
        : this._searchObjectList(query)
      : this._searchLogical(query);

    computeScore(results, { ignoreFieldNorm });

    if (shouldSort) {
      results.sort(sortFn);
    }

    if (isNumber(limit) && limit > -1) {
      results = results.slice(0, limit);
    }

    return format(results, this._docs, {
      includeMatches,
      includeScore
    })
  }

  _searchStringList(query) {
    const searcher = createSearcher(query, this.options);
    const { records } = this._myIndex;
    const results = [];

    // Iterate over every string in the index
    records.forEach(({ v: text, i: idx, n: norm }) => {
      if (!isDefined(text)) {
        return
      }

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        results.push({
          item: text,
          idx,
          matches: [{ score, value: text, norm, indices }]
        });
      }
    });

    return results
  }

  _searchLogical(query) {

    const expression = parse(query, this.options);

    const evaluate = (node, item, idx) => {
      if (!node.children) {
        const { keyId, searcher } = node;

        const matches = this._findMatches({
          key: this._keyStore.get(keyId),
          value: this._myIndex.getValueForItemAtKeyId(item, keyId),
          searcher
        });

        if (matches && matches.length) {
          return [
            {
              idx,
              item,
              matches
            }
          ]
        }

        return []
      }

      const res = [];
      for (let i = 0, len = node.children.length; i < len; i += 1) {
        const child = node.children[i];
        const result = evaluate(child, item, idx);
        if (result.length) {
          res.push(...result);
        } else if (node.operator === LogicalOperator.AND) {
          return []
        }
      }
      return res
    };

    const records = this._myIndex.records;
    const resultMap = {};
    const results = [];

    records.forEach(({ $: item, i: idx }) => {
      if (isDefined(item)) {
        let expResults = evaluate(expression, item, idx);

        if (expResults.length) {
          // Dedupe when adding
          if (!resultMap[idx]) {
            resultMap[idx] = { idx, item, matches: [] };
            results.push(resultMap[idx]);
          }
          expResults.forEach(({ matches }) => {
            resultMap[idx].matches.push(...matches);
          });
        }
      }
    });

    return results
  }

  _searchObjectList(query) {
    const searcher = createSearcher(query, this.options);
    const { keys, records } = this._myIndex;
    const results = [];

    // List is Array<Object>
    records.forEach(({ $: item, i: idx }) => {
      if (!isDefined(item)) {
        return
      }

      let matches = [];

      // Iterate over every key (i.e, path), and fetch the value at that key
      keys.forEach((key, keyIndex) => {
        matches.push(
          ...this._findMatches({
            key,
            value: item[keyIndex],
            searcher
          })
        );
      });

      if (matches.length) {
        results.push({
          idx,
          item,
          matches
        });
      }
    });

    return results
  }
  _findMatches({ key, value, searcher }) {
    if (!isDefined(value)) {
      return []
    }

    let matches = [];

    if (isArray(value)) {
      value.forEach(({ v: text, i: idx, n: norm }) => {
        if (!isDefined(text)) {
          return
        }

        const { isMatch, score, indices } = searcher.searchIn(text);

        if (isMatch) {
          matches.push({
            score,
            key,
            value: text,
            idx,
            norm,
            indices
          });
        }
      });
    } else {
      const { v: text, n: norm } = value;

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        matches.push({ score, key, value: text, norm, indices });
      }
    }

    return matches
  }
}

Fuse.version = '7.1.0';
Fuse.createIndex = createIndex;
Fuse.parseIndex = parseIndex;
Fuse.config = Config;

{
  Fuse.parseQuery = parse;
}

{
  register(ExtendedSearch);
}

/**
 * Manages selection logic and value transformations for single and multi-select modes.
 */
const EMPTY_VALUE = '';
const EMPTY_VALUES = [];
/**
 * Normalizes values to the correct format for single or multi-select mode.
 * Converts between string and array types as needed for consistent handling.
 *
 * @param value - Input value that may be string, array, or undefined
 * @param isMultiple - Whether multi-select mode is enabled
 * @returns Normalized value: string for single-select, array for multi-select
 */
function normalizeValue(value, isMultiple) {
    if (value === undefined) {
        return isMultiple ? EMPTY_VALUES : EMPTY_VALUE;
    }
    if (isMultiple) {
        if (Array.isArray(value)) {
            return value;
        }
        return value === EMPTY_VALUE ? EMPTY_VALUES : [value];
    }
    return Array.isArray(value) ? value[0] || EMPTY_VALUE : value;
}
/**
 * Toggles a value in the selection, adding if not present, removing if present.
 * For single-select mode, always replaces the current selection.
 * For multi-select mode, adds to or removes from the selection array.
 *
 * @param clickedValue - Value to toggle in the selection
 * @param currentValue - Current selected value(s)
 * @param isMultiple - Whether multi-select mode is enabled
 * @returns Updated selection after toggling the value
 */
function toggleSelection(clickedValue, currentValue, isMultiple) {
    if (isMultiple) {
        const currentSelections = Array.isArray(currentValue) ? currentValue : [];
        const isAlreadySelected = currentSelections.includes(clickedValue);
        if (isAlreadySelected) {
            return currentSelections.filter((value) => value !== clickedValue);
        }
        return [...currentSelections, clickedValue];
    }
    return clickedValue;
}
/**
 * Resolves the initial selection value using prop value or DOM pre-selection.
 * Prioritizes explicit prop values over DOM selected attributes.
 * Falls back to empty values when no selection is specified.
 *
 * @param propValue - Value explicitly passed via component props
 * @param options - Array of available options to check for pre-selection
 * @param isMultiple - Whether multi-select mode is enabled
 * @returns Initial selection value(s) in correct format
 */
function getInitialValue(propValue, options, isMultiple) {
    const hasPropValue = propValue !== undefined && propValue !== EMPTY_VALUE;
    if (hasPropValue) {
        return normalizeValue(propValue, isMultiple);
    }
    if (!options || !Array.isArray(options)) {
        return isMultiple ? EMPTY_VALUES : EMPTY_VALUE;
    }
    const preselectedValues = options
        .filter((option) => option.selected && !option.disabled)
        .map((option) => option.value);
    if (isMultiple) {
        return preselectedValues;
    }
    return preselectedValues[0] || EMPTY_VALUE;
}
/**
 * Returns the appropriate empty value for single or multi-select mode.
 */
function getEmptyValue(isMultiple) {
    return isMultiple ? EMPTY_VALUES : EMPTY_VALUE;
}
/**
 * Checks if a specific value is included in the current selection.
 * Works for both single-select strings and multi-select arrays.
 *
 * @param valueToCheck - Value to test for selection
 * @param currentValue - Current selected value(s)
 * @param isMultiple - Whether multi-select mode is enabled
 * @returns True if the value is currently selected
 */
function isSelected(valueToCheck, currentValue, isMultiple) {
    if (!currentValue)
        return false;
    if (isMultiple) {
        const selectedValues = Array.isArray(currentValue) ? currentValue : [];
        return selectedValues.includes(valueToCheck);
    }
    return currentValue === valueToCheck;
}
/**
 * Converts current selection to array format regardless of mode.
 * Normalizes single-select strings and multi-select arrays to consistent array format.
 *
 * @param value - Current selection in any format
 * @param isMultiple - Whether multi-select mode is enabled
 * @returns Array of selected values, empty if none selected
 */
function getSelectedValues(value, isMultiple) {
    if (!value)
        return [];
    if (isMultiple) {
        return Array.isArray(value) ? value : [];
    }
    return value !== EMPTY_VALUE ? [value] : [];
}
/**
 * Determines if the dropdown should automatically close after making a selection.
 * Single-select closes immediately for better UX, multi-select stays open for additional selections.
 *
 * @param isMultiple - Whether multi-select mode is enabled
 * @returns True if dropdown should close, false if should remain open
 */
function shouldCloseAfterSelection(isMultiple) {
    if (!isMultiple)
        return true;
    return false;
}

const DEFAULT_CONFIG = {
    keys: ['label'],
    includeScore: true,
    threshold: 0.4,
    ignoreLocation: true,
};
/**
 * Creates a fuzzy search instance using Fuse.js with the given options.
 * Initializes with default search configuration optimized for option labels.
 *
 * @param options - Array of options to make searchable
 * @param config - Optional search configuration to override defaults
 * @returns New search instance ready for filtering operations
 */
function createSearch(options, config) {
    const fuseConfig = Object.assign(Object.assign({}, DEFAULT_CONFIG), config);
    const instance = {
        fuse: options.length > 0 ? new Fuse(options, fuseConfig) : null,
        options,
        filtered: options,
        term: EMPTY_VALUE,
    };
    return instance;
}
/**
 * Performs fuzzy search filtering on options using the configured Fuse.js instance.
 * Returns all options if no search term provided. Uses efficient label-based filtering
 * without creating intermediate collections.
 *
 * @param instance - The search instance to use
 * @param term - Search term to filter by, empty string shows all options
 * @returns Array of options matching the search term
 */
function search(instance, term) {
    instance.term = term;
    if (!term || !instance.fuse) {
        instance.filtered = instance.options;
        return instance.filtered;
    }
    const results = instance.fuse.search(term);
    instance.filtered = results.map((result) => result.item);
    return instance.filtered;
}
/**
 * Updates the searchable options collection and recreates the Fuse.js index.
 * Re-runs the current search term if one exists to maintain filtered state.
 *
 * @param instance - The search instance to update
 * @param options - New array of options to make searchable
 */
function updateSearchOptions(instance, options) {
    instance.options = options;
    const fuseConfig = Object.assign({}, DEFAULT_CONFIG);
    instance.fuse = options.length > 0 ? new Fuse(options, fuseConfig) : null;
    if (instance.term) {
        search(instance, instance.term);
    }
    else {
        instance.filtered = options;
    }
}
/**
 * Returns the current filtered search results.
 *
 * @param instance - The search instance to get results from
 * @returns Array of options that match the current search term
 */
function getFiltered(instance) {
    return instance.filtered;
}
/**
 * Clears the current search term and resets filtered results to show all options.
 *
 * @param instance - The search instance to clear
 */
function clearSearch(instance) {
    instance.term = EMPTY_VALUE;
    instance.filtered = instance.options;
}

/**
 * Orchestrates select component operations using the adapter pattern to coordinate
 * between specialized services and provide centralized data management.
 *
 * This adapter acts as a facade over multiple services (DOM, dropdown, validation,
 * keyboard, search, selection) and maintains option state with efficient lookups.
 */
/**
 * Central adapter for select component functionality, providing a unified interface
 * to coordinate between DOM manipulation, validation, keyboard navigation, search,
 * dropdown positioning, and selection logic services.
 */
class SelectAdapter {
    constructor(config) {
        this.typeahead = new TypeaheadBuffer();
        this.optionsByValue = new Map();
        this.optionsByElement = new Map();
        this.options = [];
        this.config = config;
        this.initializeValidation();
    }
    /**
     * Toggles the selection state of an option, handling both single and multi-select modes.
     *
     * @param value - The value of the option to toggle
     * @param currentValue - The current selected value(s)
     * @returns The new selection value(s) after toggling
     */
    toggleOption(value, currentValue) {
        const option = this.optionsByValue.get(value);
        if (!option || option.disabled) {
            return currentValue !== null && currentValue !== void 0 ? currentValue : getEmptyValue(this.config.multiple);
        }
        return toggleSelection(value, currentValue, this.config.multiple);
    }
    /**
     * Determines the initial selection value from props or DOM pre-selected options.
     *
     * @param propValue - The value passed via component props
     * @returns The normalized initial value for single or multi-select mode
     */
    getInitialValue(propValue) {
        return getInitialValue(propValue, this.options, this.config.multiple);
    }
    /**
     * Retrieves an option object by its value using O(1) Map lookup.
     *
     * @param value - The option value to search for
     * @returns The option object if found, undefined otherwise
     */
    getOptionByValue(value) {
        return this.optionsByValue.get(value);
    }
    /**
     * Gets the index of an option element using efficient Map lookup.
     *
     * @param element - The HTML element to find the index for
     * @returns The zero-based index of the option, -1 if not found
     */
    getOptionIndex(element) {
        if (!element) {
            return -1;
        }
        const option = this.optionsByElement.get(element);
        return option ? option.index : -1;
    }
    /**
     * Checks if a specific value is currently selected.
     *
     * @param valueToCheck - The value to check for selection
     * @param currentValue - The current selected value(s)
     * @returns True if the value is selected, false otherwise
     */
    isSelected(valueToCheck, currentValue) {
        return isSelected(valueToCheck, currentValue, this.config.multiple);
    }
    /**
     * Returns the appropriate empty value for the current selection mode.
     *
     * @returns Empty string for single-select, empty array for multi-select
     */
    getEmptyValue() {
        return getEmptyValue(this.config.multiple);
    }
    /**
     * Determines if the dropdown should close after making a selection.
     *
     * @returns True for single-select mode, false for multi-select mode
     */
    shouldCloseAfterSelection() {
        return shouldCloseAfterSelection(this.config.multiple);
    }
    /**
     * Converts selected values into option objects with full metadata.
     *
     * @param value - The selected value(s) to convert
     * @returns Array of option objects corresponding to selected values
     */
    getSelectedOptions(value) {
        const selectedValues = getSelectedValues(value, this.config.multiple);
        const selectedOptions = [];
        for (const val of selectedValues) {
            const option = this.optionsByValue.get(val);
            if (option) {
                selectedOptions.push(option);
            }
        }
        return selectedOptions;
    }
    /**
     * Finds the first enabled option from a list of selected options.
     *
     * @param selectedOptions - Array of selected option objects
     * @returns The first enabled option element, undefined if none found
     */
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    getFirstEnabledSelected(selectedOptions) {
        const firstEnabled = selectedOptions.find((opt) => !opt.disabled);
        return firstEnabled === null || firstEnabled === void 0 ? void 0 : firstEnabled.ref;
    }
    processTypeahead(key, currentIndex) {
        var _a;
        const searchTerm = this.typeahead.add(key);
        const currentLabel = ((_a = this.options[currentIndex]) === null || _a === void 0 ? void 0 : _a.label) || '';
        if (this.typeahead.shouldStayOnCurrent(currentLabel)) {
            return this.options[currentIndex];
        }
        const labels = this.options.map((opt) => opt.label);
        const skipCurrent = searchTerm.length === 1 && currentLabel.toLowerCase().startsWith(searchTerm.toLowerCase());
        const matchIndex = findTypeaheadMatch(labels, searchTerm, currentIndex, skipCurrent);
        if (matchIndex >= 0 &&
            searchTerm.length > 1 &&
            !labels[matchIndex].toLowerCase().startsWith(searchTerm.toLowerCase())) {
            this.typeahead.useLastChar();
        }
        return matchIndex >= 0 ? this.options[matchIndex] : undefined;
    }
    /**
     * Finds the index of the first selected option in a given options array.
     *
     * @param options - Array of options to search through
     * @returns Index of first selected option, undefined if none selected
     */
    findSelectedIndex(options) {
        const index = options.findIndex((opt) => this.isSelected(opt.value, this.config.getValue()));
        return index >= 0 ? index : undefined;
    }
    /**
     * Returns the appropriate options array based on search state.
     *
     * @param searchTerm - Current search term
     * @param filteredOptions - Pre-filtered options from search
     * @returns Filtered options if searching, all options otherwise
     */
    getVisibleOptions(searchTerm, filteredOptions) {
        return this.config.searchable && searchTerm ? filteredOptions : this.options;
    }
    /**
     * Processes keyboard input and returns navigation actions to perform.
     * Handles arrow keys, typeahead, selection, and dropdown control.
     *
     * @param key - The keyboard key that was pressed
     * @param modifiers - Object containing alt and ctrl key states
     * @param state - Current component state for navigation decisions
     * @returns Object describing actions to take (focus, select, open/close, etc.)
     */
    processKeyboardNavigation(key, modifiers, state) {
        var _a;
        const visibleOptions = this.getVisibleOptions(state.searchTerm, state.filteredOptions);
        let activeVisibleIndex;
        if (state.activeElement) {
            const index = visibleOptions.findIndex((opt) => opt.ref === state.activeElement);
            activeVisibleIndex = index >= 0 ? index : undefined;
        }
        const selectedIndex = this.findSelectedIndex(visibleOptions);
        const result = processKeyboardInput(key, modifiers, {
            isOpen: state.isOpen,
            isMultiple: this.config.multiple,
            isSearchable: this.config.searchable,
            isSearchInputFocused: state.isSearchInputFocused,
            activeIndex: activeVisibleIndex,
            optionCount: visibleOptions.length,
            selectedIndex,
        });
        if (!result) {
            return {};
        }
        if (result.typeaheadKey) {
            let actualCurrentIndex = -1;
            if (activeVisibleIndex !== undefined && activeVisibleIndex >= 0) {
                const activeOption = visibleOptions[activeVisibleIndex];
                actualCurrentIndex = this.options.findIndex((opt) => opt === activeOption);
            }
            const match = this.processTypeahead(result.typeaheadKey, actualCurrentIndex);
            if (!state.isKeyboardMode && state.isOpen) {
                return {
                    shouldPreventDefault: result.shouldPreventDefault,
                    shouldOpenDropdown: result.shouldOpenDropdown,
                };
            }
            return {
                targetElement: match === null || match === void 0 ? void 0 : match.ref,
                shouldPreventDefault: result.shouldPreventDefault,
                shouldOpenDropdown: result.shouldOpenDropdown,
            };
        }
        if (result.targetIndex !== undefined) {
            this.typeahead.clear();
        }
        return {
            targetElement: result.targetIndex !== undefined ? (_a = visibleOptions[result.targetIndex]) === null || _a === void 0 ? void 0 : _a.ref : undefined,
            shouldPreventDefault: result.shouldPreventDefault,
            shouldOpenDropdown: result.shouldOpenDropdown,
            shouldCloseDropdown: result.shouldCloseDropdown,
            shouldSelect: result.shouldSelect,
            shouldFocusSearch: result.shouldFocusSearch,
        };
    }
    /**
     * Queries all option elements within the given container.
     *
     * @param element - Container element to search within
     * @returns Array of option elements found
     */
    queryOptions(element) {
        return queryOptions(element);
    }
    /**
     * Queries all optgroup elements within the given container.
     *
     * @param element - Container element to search within
     * @returns Array of optgroup elements found
     */
    queryOptgroups(element) {
        return queryOptgroups(element);
    }
    /**
     * Updates accessibility and interaction attributes on an option element.
     *
     * @param optionRef - The option element to update
     * @param attributes - Object containing attributes to set
     */
    updateOptionAttributes(optionRef, attributes) {
        updateOptionAttributes(optionRef, attributes);
    }
    /**
     * Updates the visibility of an option element for search filtering.
     *
     * @param optionRef - The option element to update
     * @param isVisible - Whether the option should be visible
     * @returns True if the visibility state changed
     */
    updateOptionVisibility(optionRef, isVisible) {
        return updateOptionVisibility(optionRef, isVisible);
    }
    /**
     * Creates a display element for a single selected option.
     *
     * @param option - The selected option to create display for
     * @param appearance - The appearance theme (light/dark)
     * @returns Created element or null in SSR environment
     */
    createSingleSelectValue(option, appearance) {
        return createSingleSelectValue(option, appearance);
    }
    /**
     * Creates a display element for multiple selected options.
     *
     * @param options - Array of selected options to display
     * @param appearance - The appearance theme (light/dark)
     * @returns Created wrapper element or null in SSR environment
     */
    createMultiSelectValue(options, appearance) {
        return createMultiSelectValue(options, appearance);
    }
    /**
     * Removes a value display element from the DOM.
     *
     * @param element - The element to remove, safe to pass null
     */
    clearValueSlot(element) {
        clearValueSlot(element);
    }
    /**
     * Inserts a value display element into the select component.
     *
     * @param parentElement - The parent container
     * @param valueElement - The value element to insert
     */
    insertValueSlot(parentElement, valueElement) {
        insertValueSlot(parentElement, valueElement);
    }
    /**
     * Calculates how many selected values overflow the visible area.
     *
     * @param element - The select component element
     * @param isMultiple - Whether multi-select mode is enabled
     * @param hasSelections - Whether there are any selections
     * @returns Number of overflowing values to display as "+N"
     */
    calculateOverflowCount(element, isMultiple, hasSelections) {
        return calculateOverflowCount(element, isMultiple, hasSelections);
    }
    /**
     * Checks if the given element is the first autofocus element in the document.
     *
     * @param element - The element to check
     * @returns True if this is the first autofocus element
     */
    isFirstAutofocusElement(element) {
        return isFirstAutofocusElement(element);
    }
    /**
     * Extracts tag names from DOM mutation records for change detection.
     *
     * @param mutationList - Array of mutation records from MutationObserver
     * @returns Array of tag names that were added or removed
     */
    extractMutatedTagNames(mutationList) {
        return extractMutatedTagNames(mutationList);
    }
    /**
     * Initializes the dropdown positioning system with Tippy.js.
     *
     * @param trigger - Element that triggers the dropdown
     * @param container - Element containing the dropdown content
     */
    initDropdown(trigger, container) {
        if (isNodeEnvironment() || !trigger || !container) {
            return;
        }
        this.dropdown = createDropdown({
            trigger,
            container,
            placement: SelectAdapter.DEFAULT_DROPDOWN_PLACEMENT,
            offset: SelectAdapter.DEFAULT_DROPDOWN_OFFSET,
        });
        hideDropdown(this.dropdown);
    }
    /**
     * Shows the dropdown if initialized.
     */
    showDropdown() {
        if (!this.dropdown)
            return;
        showDropdown(this.dropdown);
    }
    /**
     * Hides the dropdown if initialized.
     */
    hideDropdown() {
        if (!this.dropdown)
            return;
        hideDropdown(this.dropdown);
    }
    /**
     * Destroys the dropdown instance and cleans up resources.
     */
    destroyDropdown() {
        if (!this.dropdown)
            return;
        destroyDropdown(this.dropdown);
        this.dropdown = undefined;
    }
    /**
     * Initializes the fuzzy search functionality if searchable mode is enabled.
     */
    initSearch() {
        if (!this.config.searchable)
            return;
        this.search = createSearch(this.options);
    }
    /**
     * Performs fuzzy search on options using the given term.
     *
     * @param term - Search term to match against option labels
     * @returns Array of options matching the search term
     */
    searchOptions(term) {
        return this.search ? search(this.search, term) : this.options;
    }
    /**
     * Returns the current search results. Guaranteed to return an array.
     *
     * @returns Array of options matching the current search, all options if no search
     */
    getSearchResults() {
        const result = this.search ? getFiltered(this.search) : this.options;
        return result || [];
    }
    /**
     * Clears the current search and shows all options.
     */
    clearSearch() {
        if (!this.search)
            return;
        clearSearch(this.search);
    }
    initializeValidation() {
        const validationConfig = {
            name: this.config.name,
            required: this.config.required,
            disabled: this.config.disabled,
            invalid: this.config.invalid,
            validationMessage: this.config.validationMessage,
            getValue: this.config.getValue,
            hasValue: this.config.hasValue,
            onInvalidChange: this.config.onInvalidChange,
            emitInvalidEvent: this.config.emitInvalidEvent,
        };
        this.validation = createValidation(validationConfig);
    }
    /**
     * Attaches form validation and submission handlers.
     *
     * @param form - The form element to attach to
     */
    attachForm(form) {
        if (!this.validation)
            return;
        this.validation.onReset = () => {
            if (this.config.onValueReset) {
                this.config.onValueReset();
            }
        };
        attachToForm(this.validation, form);
    }
    /**
     * Detaches from form validation system.
     */
    detachForm() {
        if (!this.validation)
            return;
        detachFromForm(this.validation);
    }
    /**
     * Validates the current selection according to form constraints.
     *
     * @returns True if valid, false if validation fails
     */
    checkValidity() {
        return this.validation ? validate(this.validation) : true;
    }
    /**
     * Validates selection and reports results to user if invalid.
     *
     * @returns True if valid, false if validation fails
     */
    reportValidity() {
        return this.validation ? reportValidity(this.validation) : true;
    }
    /**
     * Returns the current validation error message.
     *
     * @returns Validation message string, empty if valid
     */
    getValidationMessage() {
        return this.validation ? getMessage(this.validation) : '';
    }
    /**
     * Re-runs validation if the form was previously submitted.
     */
    revalidateIfSubmitted() {
        if (!this.validation)
            return;
        revalidateIfSubmitted(this.validation);
    }
    /**
     * Updates the validation configuration with new settings.
     *
     * @param config - Partial validation config to merge
     */
    updateValidationConfig(config) {
        if (!this.validation)
            return;
        updateConfig(this.validation, config);
    }
    /**
     * Populates the options collection from DOM elements, building lookup maps
     * for efficient access by value and element reference.
     *
     * @param optionElements - Array of option DOM elements to process
     */
    setOptionsFromDOM(optionElements) {
        var _a;
        this.options = [];
        this.optionsByValue.clear();
        for (let index = 0; index < optionElements.length; index++) {
            const optionElement = optionElements[index];
            const option = {
                index,
                label: ((_a = optionElement.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || '',
                ref: optionElement,
                value: optionElement.value,
                selected: optionElement.selected,
                disabled: optionElement.disabled,
                meta: optionElement.meta || undefined,
            };
            this.options.push(option);
            this.optionsByValue.set(option.value, option);
            this.optionsByElement.set(optionElement, option);
        }
        if (this.search) {
            updateSearchOptions(this.search, this.options);
        }
    }
    /**
     * Sets the options collection and rebuilds lookup maps for efficient access.
     *
     * @param options - Array of option objects to set
     */
    setOptions(options) {
        this.options = options;
        this.optionsByValue.clear();
        this.optionsByElement.clear();
        options.forEach((option) => {
            this.optionsByValue.set(option.value, option);
            this.optionsByElement.set(option.ref, option);
        });
        if (this.search) {
            updateSearchOptions(this.search, options);
        }
    }
    /**
     * Returns all available options. Guaranteed to return an array.
     *
     * @returns Array of all option objects, empty array if none
     */
    getOptions() {
        return this.options || [];
    }
    /**
     * Returns filtered options based on search term. Guaranteed to return an array.
     *
     * @param searchTerm - The search term to filter by
     * @returns Array of matching options, all options if no search term
     */
    getFilteredOptions(searchTerm) {
        const result = searchTerm && this.search ? this.searchOptions(searchTerm) : this.options;
        return result || [];
    }
    /**
     * Cleans up all resources, services, and event listeners.
     * Should be called when the component is unmounted.
     */
    destroy() {
        this.destroyDropdown();
        this.detachForm();
        this.typeahead.clear();
        this.options = [];
        this.optionsByValue.clear();
        this.optionsByElement.clear();
    }
}
SelectAdapter.DEFAULT_DROPDOWN_PLACEMENT = 'bottom';
SelectAdapter.DEFAULT_DROPDOWN_OFFSET = [0, 8];

const cosmosSelectCss = "@charset \"UTF-8\";.cosmos-form-field{display:flex;flex-direction:column}.cosmos-form-field__info-container{display:inline-block;margin-bottom:8px}.cosmos-form-field__info-container:not(.cosmos-form-field__info-container--has-label,.cosmos-form-field__info-container--has-help-text,.cosmos-form-field__info-container--has-required-optional-label){display:none}.cosmos-form-field__label-text,.cosmos-form-field__help-text,.cosmos-form-field__required-optional-label,.cosmos-form-field__validation-message{display:inline}.cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-select-label-color);--cosmos-text-font-family:var(--cosmos-select-label-font-family);--cosmos-text-font-size:var(--cosmos-select-label-font-size);--cosmos-text-font-style:var(--cosmos-select-label-font-style);--cosmos-text-font-weight:var(--cosmos-select-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-select-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-select-label-line-height);--cosmos-text-text-transform:var(--cosmos-select-label-text-transform)}.cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-select-help-text-color);--cosmos-text-font-family:var(--cosmos-select-help-text-font-family);--cosmos-text-font-size:var(--cosmos-select-help-text-font-size);--cosmos-text-font-style:var(--cosmos-select-help-text-font-style);--cosmos-text-font-weight:var(--cosmos-select-help-text-font-weight);--cosmos-text-letter-spacing:var(--cosmos-select-help-text-letter-spacing);--cosmos-text-line-height:var(--cosmos-select-help-text-line-height);--cosmos-text-text-transform:var(--cosmos-select-help-text-text-transform)}.cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-select-required-optional-label-color);--cosmos-text-font-family:var(--cosmos-select-required-optional-label-font-family);--cosmos-text-font-size:var(--cosmos-select-required-optional-label-font-size);--cosmos-text-font-style:var(--cosmos-select-required-optional-label-font-style);--cosmos-text-font-weight:var(--cosmos-select-required-optional-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-select-required-optional-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-select-required-optional-label-line-height);--cosmos-text-text-transform:var(--cosmos-select-required-optional-label-text-transform);display:inline-block;margin-inline-start:4px;white-space:nowrap}.cosmos-form-field__validation-message{display:flex;gap:4px;margin-top:8px}.cosmos-form-field__validation-message-text{--cosmos-text-font-family:var(--cosmos-select-validation-message-font-family);--cosmos-text-font-size:var(--cosmos-select-validation-message-font-size);--cosmos-text-font-style:var(--cosmos-select-validation-message-font-style);--cosmos-text-font-weight:var(--cosmos-select-validation-message-font-weight);--cosmos-text-letter-spacing:var(--cosmos-select-validation-message-letter-spacing);--cosmos-text-line-height:var(--cosmos-select-validation-message-line-height);--cosmos-text-text-transform:var(--cosmos-select-validation-message-text-transform)}.cosmos-form-field__validation-message-icon{--cosmos-icon-color:var(--cosmos-select-invalid-color, #E06600);--cosmos-icon-size:calc(16rem / var(--cosmos-base-font-size, 16));flex-shrink:0;padding:1.5px 0}.cosmos-form-field--invalid .cosmos-form-field__label-text,.cosmos-form-field--invalid .cosmos-form-field__validation-message{--cosmos-text-color:var(--cosmos-select-label-color)}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-select-label-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-select-help-text-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-select-required-optional-label-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-select-label-color, rgba(255, 255, 255, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-select-help-text-color, rgba(255, 255, 255, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-select-required-optional-label-color, rgba(0, 15, 30, 0.45))}:host{--cosmos-font-family-text:Bull Text, Helvetica, sans-serif}@supports (font-variation-settings: normal){:host{--cosmos-font-family-text:Bull VF, Helvetica, sans-serif}}:host(:lang(ja)){--cosmos-font-family-text:Noto Sans JP, Helvetica, sans-serif}:host(:lang(ar)){--cosmos-font-family-text:Noto Kufi Arabic, Helvetica, sans-serif}:host(:lang(ko)){--cosmos-font-family-text:Noto Sans KR, Helvetica, sans-serif}:host(:lang(hi)){--cosmos-font-family-text:Noto Sans, Helvetica, sans-serif}:host(:lang(he)){--cosmos-font-family-text:Noto Sans Hebrew, Helvetica, sans-serif}:host(:lang(ka)){--cosmos-font-family-text:Noto Sans Georgian, Helvetica, sans-serif}:host(:lang(th)){--cosmos-font-family-text:Noto Sans Thai, Helvetica, sans-serif}:host(:lang(zh)){--cosmos-font-family-text:Microsoft YaHei, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}:host(:lang(zh-Hant)){--cosmos-font-family-text:Microsoft JhengHei, Geneva CY, ヒラギノ角ゴ Pro W3, Hiragino Kaku Gothic Pro, Hiragino Kaku Gothic ProN W3, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, MS PGothic, Arial Unicode MS, Tahoma, Helvetica, sans-serif}:host{display:block;width:100%}.cosmos-select{position:relative}.cosmos-select__input{--cosmos-text-color:var(--cosmos-select-color);--cosmos-text-font-family:var(--cosmos-select-font-family);--cosmos-text-font-size:var(--cosmos-select-font-size);--cosmos-text-font-style:var(--cosmos-select-font-style);--cosmos-text-font-weight:var(--cosmos-select-font-weight);--cosmos-text-line-height:var(--cosmos-select-line-height, calc(38rem / var(--cosmos-base-font-size, 16)));align-items:center;border:solid var(--cosmos-select-border-width, 1px);border-radius:var(--cosmos-select-border-radius, 4px);box-sizing:border-box;display:flex;gap:8px;justify-content:space-between;letter-spacing:var(--cosmos-select-letter-spacing, normal);max-width:100%;padding:var(--cosmos-select-padding, 0 12px);position:relative;text-transform:var(--cosmos-select-text-transform, none);-webkit-user-select:none;user-select:none;width:100%}.cosmos-select__input--invalid:not(.cosmos-select__input--disabled){border-color:var(--cosmos-select-invalid-color, #E06600);box-shadow:inset 0 0 0 1px var(--cosmos-select-invalid-color, #E06600)}.cosmos-select__input--appearance-dark{background-color:var(--cosmos-select-background-color, #FFFFFF);border-color:var(--cosmos-select-border-color, rgba(0, 15, 30, 0.45));color:var(--cosmos-select-color, #000F1E)}.cosmos-select__input--appearance-dark.cosmos-select__input--placeholder{--cosmos-text-color:var(--cosmos-select-placeholder-color)}.cosmos-select__input--appearance-dark.cosmos-select__input--disabled{background:rgba(0, 15, 30, 0.05);border-color:transparent;color:var(--cosmos-select-color, rgba(0, 15, 30, 0.45))}.cosmos-select__input--appearance-dark.cosmos-select__input--disabled.cosmos-select__input--placeholder{--cosmos-text-color:custom-select-property(\"color\", $cosmos-color-surface-glass-dark-45)}.cosmos-select__input--appearance-dark:not(.cosmos-select__input--disabled) .cosmos-select__icon{color:var(--cosmos-select-arrow-color, #000F1E)}.cosmos-select__input--appearance-dark:hover:not(.cosmos-select__input--disabled):not(.cosmos-select__input--invalid){background-color:var(--cosmos-select-background-color-hover, #FFFFFF);border-color:var(--cosmos-select-border-color-hover, rgba(0, 15, 30, 0.6))}.cosmos-select__input--appearance-dark:hover:not(.cosmos-select__input--disabled):not(.cosmos-select__input--invalid):not(.cosmos-select__input--placeholder){color:var(--cosmos-select-color-hover, #000F1E)}.cosmos-select__input--appearance-light{background-color:var(--cosmos-select-background-color, rgba(255, 255, 255, 0.05));border-color:var(--cosmos-select-border-color, rgba(255, 255, 255, 0.45));color:var(--cosmos-select-color, #FFFFFF)}.cosmos-select__input--appearance-light.cosmos-select__input--placeholder{--cosmos-text-color:var(--cosmos-select-placeholder-color)}.cosmos-select__input--appearance-light.cosmos-select__input--disabled{background:rgba(255, 255, 255, 0.05);border-color:transparent;color:var(--cosmos-select-color, rgba(255, 255, 255, 0.45))}.cosmos-select__input--appearance-light.cosmos-select__input--disabled.cosmos-select__input--placeholder{--cosmos-text-color:custom-select-property(\"color\", $cosmos-color-surface-glass-light-45)}.cosmos-select__input--appearance-light:not(.cosmos-select__input--disabled) .cosmos-select__icon{color:var(--cosmos-select-arrow-color, #FFFFFF)}.cosmos-select__input--appearance-light:hover:not(.cosmos-select__input--disabled):not(.cosmos-select__input--invalid){background-color:var(--cosmos-select-background-color-hover, rgba(255, 255, 255, 0.05));border-color:var(--cosmos-select-border-color-hover, rgba(255, 255, 255, 0.6))}.cosmos-select__input--appearance-light:hover:not(.cosmos-select__input--disabled):not(.cosmos-select__input--invalid):not(.cosmos-select__input--placeholder){color:var(--cosmos-select-color-hover, #FFFFFF)}.cosmos-select__icon{color:var(--cosmos-select-arrow-color, currentColor);flex:0 0 auto}.cosmos-select__combobox{align-items:baseline;display:flex;flex:1 1 auto;height:calc(38rem / var(--cosmos-base-font-size, 16));overflow:hidden}.cosmos-select__combobox:focus,.cosmos-select__combobox:focus:not(:focus-visible){outline:none}.cosmos-select__combobox~.cosmos-select__focus-ring{display:none;pointer-events:none}.cosmos-select__combobox:focus~.cosmos-select__focus-ring{border-radius:calc(var(--cosmos-select-border-radius, 4px) * 1.5);bottom:calc((4px + 0px) * -1);box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + 0px) * -1);position:absolute;right:calc((4px + 0px) * -1);top:calc((4px + 0px) * -1);display:block}.cosmos-select__listbox-container{background-color:var(--cosmos-select-listbox-background-color, var(--cosmos-select-options-background-color, #FFFFFF));border-radius:var(--cosmos-select-listbox-border-radius, var(--cosmos-select-options-border-radius, 4px));box-shadow:0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431);box-sizing:border-box;overflow:hidden;pointer-events:none;position:absolute;right:0;top:100%;-webkit-user-select:none;user-select:none;visibility:hidden;width:100%;z-index:1}.cosmos-select__listbox-container:not(.cosmos-select__listbox-container--filtered) ::slotted([data-component-name=cosmos-optgroup]:last-of-type){--cosmos-optgroup-padding-bottom:4px}.cosmos-select__listbox-container--appearance-light{background-color:var(--cosmos-select-listbox-background-color, var(--cosmos-select-options-background-color, #00162B));border:1px solid rgba(255, 255, 255, 0.45)}.cosmos-select__listbox-container--appearance-light ::slotted([data-component-name=cosmos-optgroup]:nth-of-type(n+2)){border-top:1px solid rgba(255, 255, 255, 0.2);padding-top:4px}.cosmos-select__listbox-container--appearance-dark{border:1px solid rgba(0, 15, 30, 0.2)}.cosmos-select__listbox-container--appearance-dark ::slotted([data-component-name=cosmos-optgroup]:nth-of-type(n+2)){border-top:1px solid rgba(0, 15, 30, 0.1);--cosmos-optgroup-padding-top:4px}.cosmos-select__listbox-container--open{pointer-events:auto;visibility:visible}.cosmos-select__listbox-container--filtered{--cosmos-optgroup-display:none;--cosmos-optgroup-padding-bottom:0}.cosmos-select__listbox-container--filtered ::slotted([data-component-name=cosmos-optgroup]:nth-of-type(n+2)){border-top:0;--cosmos-optgroup-padding-top:0}.cosmos-select__listbox{display:flex;flex-direction:column;left:0;max-height:var(--cosmos-select-listbox-max-height, var(--cosmos-select-options-max-height, 320px));overflow:auto;padding:var(--cosmos-select-listbox-padding, var(--cosmos-select-options-padding, 4px))}.cosmos-select:not(.cosmos-select--filtered) .cosmos-select__listbox{gap:2px}.cosmos-select__clearable-button{--cosmos-button-icon-size:calc(10rem / var(--cosmos-base-font-size, 16))}.cosmos-select__clearable-button::part(base){height:calc(18rem / var(--cosmos-base-font-size, 16));min-width:calc(18rem / var(--cosmos-base-font-size, 16));width:calc(18rem / var(--cosmos-base-font-size, 16))}.cosmos-select__sr-value{border-width:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.cosmos-select ::slotted([slot=value]){flex:1 0 auto;min-width:0;width:100%}.cosmos-select__overflow-badge{margin-inline:4px}.cosmos-select__search-container{--cosmos-icon-color:var(--cosmos-select-search-color);--cosmos-input-background-color:transparent;--cosmos-input-background-color-hover:transparent;--cosmos-input-border-color:transparent;--cosmos-input-border-color-hover:transparent;--cosmos-input-color:var(--cosmos-select-search-color);--cosmos-input-font-family:var(--cosmos-select-search-font-family);--cosmos-input-font-size:var(--cosmos-select-search-font-size);--cosmos-input-font-style:var(--cosmos-select-search-font-style);--cosmos-input-font-weight:var(--cosmos-select-search-font-weight);--cosmos-input-letter-spacing:var(--cosmos-select-search-letter-spacing);--cosmos-input-placeholder-color:var(--cosmos-select-search-placeholder-color);--cosmos-input-text-transform:var(--cosmos-select-search-text-transform);background-color:var(--cosmos-select-search-background-color);padding:4px}.cosmos-form-field--appearance-light .cosmos-select__search-container{box-shadow:inset 0 -1px 0 rgba(255, 255, 255, 0.2)}.cosmos-form-field--appearance-dark .cosmos-select__search-container{box-shadow:inset 0 -1px 0 rgba(0, 15, 30, 0.1)}.cosmos-select__search-container:hover{--cosmos-input-color-hover:var(--cosmos-select-search-color-hover, var(--cosmos-select-search-color));--cosmos-icon-color:var(--cosmos-select-search-color-hover, var(--cosmos-select-search-color));background-color:var(--cosmos-select-search-background-color-hover, var(--cosmos-select-search-background-color))}.cosmos-form-field--appearance-light .cosmos-select__search-container:hover{box-shadow:inset 0 -1px 0 rgba(255, 255, 255, 0.45)}.cosmos-form-field--appearance-dark .cosmos-select__search-container:hover{box-shadow:inset 0 -1px 0 rgba(0, 15, 30, 0.2)}.cosmos-select__search{--focus-offset:-2px}.cosmos-select__no-filter-results{padding:10px 12px}";

const CosmosSelect$1 = /*@__PURE__*/ proxyCustomElement(class CosmosSelect extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inputchangeEvent = createEvent(this, "inputchange", 6);
        this.inputinvalidEvent = createEvent(this, "inputinvalid", 3);
        /**
         * Sets the Input into the invalid state.
         */
        this.invalid = false;
        /**
         * Enables selection of multiple options.
         */
        this.multiple = false;
        /**
         * Marks the Select as mandatory to be filled out in order to submit a form.
         */
        this.required = false;
        /**
         * Enables the search functionality within the Select component, allowing users to filter options.
         */
        this.searchable = false;
        /**
         * Displays a message when the search does not match any options.
         */
        this.searchEmptyResultsText = 'No results found';
        /**
         * Specifies the placeholder text displayed within the search input field.
         */
        this.searchPlaceholder = 'Search';
        this.computedAppearance = 'dark';
        this.filteredOptions = [];
        this.isInvalid = false;
        this.isKeyboardNavigated = false;
        this.isListBoxVisible = false;
        this.isSearchInputFocused = false;
        this.overflowCount = 0;
        this.searchTerm = EMPTY_VALUE;
        this.selectedOptions = [];
        this.generateClassNames = bem('cosmos-select');
        this.dependency = [h("cosmos-select-value", null)];
        this.selectValueRef = null;
        this.handleOutsideClick = () => {
            if (!this.isListBoxVisible)
                return;
            this.closeListBox(false);
        };
        this.handleSelectClick = async (event) => {
            var _a, _b;
            event.preventDefault();
            event.stopImmediatePropagation();
            if (this.disabled)
                return;
            if (this.isListBoxVisible) {
                this.closeListBox();
                return;
            }
            this.openListBox();
            if (this.searchable) {
                await nextTick();
                await ((_a = this.searchInputElement) === null || _a === void 0 ? void 0 : _a.inputFocus());
            }
            else {
                await nextTick();
                (_b = this.comboBoxElement) === null || _b === void 0 ? void 0 : _b.focus();
            }
        };
        this.handleListBoxClick = (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
        };
        this.handleClearableClick = async (event) => {
            if (this.disabled)
                return;
            event.preventDefault();
            event.stopPropagation();
            await this.clearSelect();
        };
        this.handleSelectKeyDown = async (event) => {
            var _a, _b, _c;
            if (this.disabled)
                return;
            const action = this.adapter.processKeyboardNavigation(event.key, { alt: event.altKey, ctrl: event.ctrlKey }, {
                isOpen: this.isListBoxVisible,
                activeElement: this.activeOptionElement,
                searchTerm: this.searchTerm,
                filteredOptions: this.filteredOptions,
                isSearchInputFocused: this.isSearchInputFocused,
                isKeyboardMode: this.isKeyboardNavigated,
            });
            if (action.shouldPreventDefault) {
                event.preventDefault();
            }
            if (action.shouldOpenDropdown && !this.isListBoxVisible) {
                this.openListBox(true);
                await nextTick();
            }
            if (action.shouldFocusSearch && this.searchable) {
                this.clearActiveOption();
                await nextTick();
                await ((_a = this.searchInputElement) === null || _a === void 0 ? void 0 : _a.inputFocus());
                return;
            }
            if (action.targetElement) {
                if (!this.isKeyboardNavigated) {
                    this.isKeyboardNavigated = true;
                }
                if (this.isSearchInputFocused) {
                    (_b = this.searchInputElement) === null || _b === void 0 ? void 0 : _b.inputBlur();
                }
                this.setActiveOption(action.targetElement);
            }
            if (action.shouldSelect) {
                if (!this.multiple && this.activeOptionElement && this.isListBoxVisible) {
                    const isAlreadySelected = this.adapter.isSelected(this.activeOptionElement.value, this.value);
                    if (isAlreadySelected && action.shouldCloseDropdown) {
                        await this.closeListBox();
                        return;
                    }
                }
                this.selectActiveOption();
            }
            if (action.shouldCloseDropdown) {
                const isDisabledOption = (_c = this.activeOptionElement) === null || _c === void 0 ? void 0 : _c.disabled;
                if (!isDisabledOption) {
                    await this.closeListBox();
                }
            }
        };
        this.handleClearableKeyDown = async (event) => {
            if (this.disabled)
                return;
            if (![' ', 'Enter'].includes(event.key))
                return;
            event.preventDefault();
            event.stopPropagation();
            await this.clearSelect();
        };
        this.setSelectValueSlot = () => {
            if (!this.adapter)
                return;
            this.adapter.clearValueSlot(this.selectValueRef);
            this.selectValueRef = null;
            if (!this.multiple && this.selectedOptions.length === 1) {
                this.selectValueRef = this.adapter.createSingleSelectValue(this.selectedOptions[0], this.computedAppearance);
            }
            else if (this.multiple && this.selectedOptions.length > 0) {
                this.selectValueRef = this.adapter.createMultiSelectValue(this.selectedOptions, this.computedAppearance);
            }
            if (this.selectValueRef) {
                this.adapter.insertValueSlot(this.element, this.selectValueRef);
            }
        };
        this.handleSearchInput = (event) => {
            this.searchTerm = event.detail.value;
        };
        this.handleSearchFocus = () => {
            this.isSearchInputFocused = true;
        };
        this.handleSearchBlur = () => {
            this.isSearchInputFocused = false;
        };
        /**
         * SSR workaround to ensure the select options appear in the correct appearance.
         * This is necessary because the select options are not reactive to changes in the
         * select appearance during re-hydration.
         */
        this.handleSlotChange = () => {
            var _a, _b;
            const options = (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.getOptions();
            if (!(options === null || options === void 0 ? void 0 : options.length) && !((_b = this.optgroups) === null || _b === void 0 ? void 0 : _b.length))
                return;
            const isAppearanceMismatch = options === null || options === void 0 ? void 0 : options.some((option) => option.ref.appearance !== this.computedAppearance);
            if (isAppearanceMismatch) {
                this.handleAppearanceChange(this.computedAppearance);
            }
        };
        /**
         * SSR workaround to ensure the select-value is always in sync with the selected options.
         * The select-value slot would always get removed during re-hydration.
         */
        this.handleValueSlotChange = () => {
            if (hasNamedSlot(this.element, 'value'))
                return;
            this.setSelectValueSlot();
        };
    }
    handleValueChange() {
        if (!this.adapter)
            return;
        this.setSelectedOptions();
        this.updateSlottedOptions();
        this.setSelectValueSlot();
    }
    handleAppearanceChange(appearance) {
        var _a, _b;
        this.computedAppearance = appearance;
        if (!this.adapter)
            return;
        const options = this.adapter.getOptions();
        if (options.length) {
            options.forEach((el) => (el.ref.appearance = this.computedAppearance));
        }
        (_a = this.optgroups) === null || _a === void 0 ? void 0 : _a.forEach((el) => (el.appearance = this.computedAppearance));
        (_b = this.selectValueRef) === null || _b === void 0 ? void 0 : _b.setAttribute('appearance', this.computedAppearance);
    }
    handleInvalidChange(newValue) {
        var _a;
        this.isInvalid = newValue;
        (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.updateValidationConfig({ invalid: newValue });
    }
    handleRequiredChange(newValue) {
        var _a;
        (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.updateValidationConfig({ required: newValue });
    }
    handleDisabledChange(newValue) {
        var _a;
        (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.updateValidationConfig({ disabled: newValue });
    }
    handleNameChange(newValue) {
        var _a;
        (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.updateValidationConfig({ name: newValue });
    }
    handleValidationMessageChange(newValue) {
        var _a;
        (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.updateValidationConfig({ validationMessage: newValue });
    }
    handleSearchTermChange() {
        if (!this.adapter || !this.searchable)
            return;
        this.filteredOptions = this.adapter.getFilteredOptions(this.searchTerm);
        this.updateSlottedOptions();
    }
    /**
     * Removes focus from the Input.
     */
    async inputBlur() {
        var _a;
        (_a = this.comboBoxElement) === null || _a === void 0 ? void 0 : _a.blur();
    }
    /**
     * Sets focus on the Input. This will scroll the element into the view and focus it.
     */
    async inputFocus() {
        var _a;
        (_a = this.comboBoxElement) === null || _a === void 0 ? void 0 : _a.focus();
    }
    /**
     * Returns the validity status of the Input.
     * Fires an `inputinvalid` event in the case of invalidity.
     */
    async inputCheckValidity() {
        var _a, _b;
        return (_b = (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.checkValidity()) !== null && _b !== void 0 ? _b : true;
    }
    /**
     * Performs the same validity checking steps as the inputCheckValidity methods.
     * Fires an `inputinvalid` event and reports the problem to the user in case of invalidity.
     */
    async inputReportValidity() {
        var _a, _b;
        return (_b = (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.reportValidity()) !== null && _b !== void 0 ? _b : true;
    }
    handleOptionSelect(event) {
        if (this.disabled || !this.adapter)
            return;
        const oldValue = this.value;
        const newValue = this.adapter.toggleOption(event.detail.value, this.value);
        if (oldValue !== newValue) {
            this.value = newValue;
            this.inputchangeEvent.emit({ value: this.value });
            this.adapter.revalidateIfSubmitted();
        }
        if (this.adapter.shouldCloseAfterSelection()) {
            this.closeListBox(true);
        }
    }
    handleKeyDown(event) {
        this.handleSelectKeyDown(event);
    }
    async handleFocusOut(event) {
        var _a;
        const relatedTarget = event.relatedTarget;
        if (!relatedTarget || this.element.contains(relatedTarget) || ((_a = this.listBoxElement) === null || _a === void 0 ? void 0 : _a.contains(relatedTarget))) {
            return;
        }
        await this.closeListBox(false);
    }
    openListBox(viaKeyboard = false) {
        var _a;
        if (this.isListBoxVisible)
            return;
        this.isListBoxVisible = true;
        this.isKeyboardNavigated = viaKeyboard;
        (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.showDropdown();
        global$1.window.addEventListener('click', this.handleOutsideClick);
    }
    async closeListBox(resetFocus = true) {
        var _a, _b;
        if (!this.isListBoxVisible)
            return;
        this.isListBoxVisible = false;
        this.isSearchInputFocused = false;
        this.clearActiveOption();
        (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.hideDropdown();
        global$1.window.removeEventListener('click', this.handleOutsideClick);
        if (this.searchable && this.adapter) {
            this.searchTerm = EMPTY_VALUE;
            this.adapter.clearSearch();
            this.filteredOptions = this.adapter.getOptions();
        }
        if (resetFocus) {
            await nextTick();
            (_b = this.comboBoxElement) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }
    setActiveOption(optionElement) {
        if (!optionElement)
            return;
        const index = this.adapter.getOptionIndex(optionElement);
        if (index === -1)
            return;
        this.activeOptionElement = optionElement;
        this.updateSlottedOptions();
    }
    clearActiveOption() {
        this.activeOptionElement = undefined;
    }
    selectActiveOption() {
        var _a;
        if (!this.activeOptionElement || this.activeOptionElement.disabled)
            return;
        const oldValue = this.value;
        const newValue = this.adapter.toggleOption(this.activeOptionElement.value, this.value);
        if (oldValue !== newValue) {
            this.value = newValue;
            this.inputchangeEvent.emit({ value: this.value });
            (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.revalidateIfSubmitted();
        }
    }
    getComboboxTabIndex() {
        const isDisabled = this.disabled;
        const isSearchInputActive = this.isListBoxVisible && this.searchable;
        const isOptionActive = this.isListBoxVisible && this.isKeyboardNavigated && this.activeOptionElement;
        return isDisabled || isSearchInputActive || isOptionActive ? -1 : 0;
    }
    async clearSelect() {
        var _a;
        this.clearActiveOption();
        this.value = this.adapter.getEmptyValue();
        this.inputchangeEvent.emit({ value: this.value });
        this.adapter.revalidateIfSubmitted();
        await nextTick();
        (_a = this.comboBoxElement) === null || _a === void 0 ? void 0 : _a.focus();
    }
    setSelectedOptions() {
        var _a;
        this.selectedOptions = ((_a = this.adapter) === null || _a === void 0 ? void 0 : _a.getSelectedOptions(this.value)) || [];
    }
    updateSlottedOptions() {
        var _a;
        const options = (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.getOptions();
        if (!this.adapter || !(options === null || options === void 0 ? void 0 : options.length))
            return;
        const isSearching = this.searchable && this.searchTerm !== EMPTY_VALUE;
        const visibleOptions = isSearching ? this.adapter.getSearchResults() : options;
        const setSizeStr = String(visibleOptions.length);
        const visibleSet = isSearching ? new Set(visibleOptions) : null;
        let positionInSet = 0;
        for (const option of options) {
            const optionRef = option.ref;
            const isVisible = !isSearching || visibleSet.has(option);
            if (!isVisible) {
                this.adapter.updateOptionVisibility(optionRef, false);
                continue;
            }
            this.adapter.updateOptionVisibility(optionRef, true);
            positionInSet++;
            const isActive = optionRef === this.activeOptionElement;
            const isSelected = this.adapter.isSelected(optionRef.value, this.value);
            const isDropdownClosed = !this.isListBoxVisible;
            const isActiveKeyboardOption = this.isKeyboardNavigated && isActive;
            const tabIndex = isDropdownClosed ? -1 : isActiveKeyboardOption ? 0 : -1;
            this.adapter.updateOptionAttributes(optionRef, {
                tabIndex,
                selected: isSelected,
                ariaPosinset: String(positionInSet),
                ariaSetsize: setSizeStr,
            });
            if (isActive && this.isListBoxVisible && this.isKeyboardNavigated) {
                optionRef.focus();
            }
        }
    }
    setOverflowCount() {
        var _a;
        this.overflowCount = (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.calculateOverflowCount(this.element, this.multiple, this.selectedOptions.length > 0);
    }
    async initAutofocus() {
        var _a;
        if ((_a = this.adapter) === null || _a === void 0 ? void 0 : _a.isFirstAutofocusElement(this.element)) {
            await nextTick();
            this.inputFocus();
        }
    }
    initOptions() {
        if (!this.element || !this.adapter)
            return; // In SSR mode, the element is not available yet
        const optionElements = this.adapter.queryOptions(this.element);
        if (!optionElements.length)
            return;
        this.optgroups = this.adapter.queryOptgroups(this.element);
        this.adapter.setOptionsFromDOM(optionElements);
        this.adapter.initSearch();
        const initialValue = this.adapter.getInitialValue(this.value);
        if (this.value !== initialValue) {
            this.value = initialValue;
        }
        else {
            this.setSelectedOptions();
            this.filteredOptions = this.adapter.getFilteredOptions(this.searchTerm);
            this.updateSlottedOptions();
            this.setSelectValueSlot();
        }
    }
    observeOptionChanges() {
        this.mutationObserver = new MutationObserver((mutationList) => {
            const mutatedElements = this.adapter.extractMutatedTagNames(mutationList);
            if (mutatedElements.includes(transformTagName('cosmos-option')) ||
                mutatedElements.includes(transformTagName('cosmos-optgroup'))) {
                this.initOptions();
            }
        });
        this.mutationObserver.observe(this.element, { childList: true });
    }
    connectedCallback() {
        if (!isNodeEnvironment()) {
            this.observeOptionChanges();
            this.resizeObserver = new ResizeObserver(() => this.setOverflowCount());
            this.resizeObserver.observe(this.element);
        }
    }
    componentWillLoad() {
        this.isInvalid = this.invalid;
        this.adapter = new SelectAdapter({
            element: this.element,
            multiple: this.multiple,
            searchable: this.searchable,
            required: this.required,
            disabled: this.disabled,
            invalid: this.invalid,
            name: this.name,
            validationMessage: this.validationMessage,
            getValue: () => this.value,
            hasValue: () => this.selectedOptions.length > 0,
            onInvalidChange: (invalid) => (this.isInvalid = invalid),
            emitInvalidEvent: () => this.inputinvalidEvent.emit(),
            onValueReset: () => {
                this.value = this.multiple ? EMPTY_VALUES : EMPTY_VALUE;
            },
        });
        resolveAppearance({
            // For SSR pre-rendering
            instance: this,
            modeToAppearanceMap: { dark: 'light', light: 'dark' },
            callback: this.handleAppearanceChange.bind(this),
        });
        this.initOptions();
    }
    componentDidLoad() {
        const form = this.element.closest('form');
        if (form && this.adapter) {
            this.adapter.attachForm(form);
        }
        resolveAppearance({
            instance: this,
            modeToAppearanceMap: { dark: 'light', light: 'dark' },
            callback: this.handleAppearanceChange.bind(this),
        });
        if (this.adapter && this.dropdownContainer && this.listBoxContainerElement) {
            this.adapter.initDropdown(this.dropdownContainer, this.listBoxContainerElement);
        }
        if (this.autofocus) {
            this.initAutofocus();
        }
    }
    componentDidRender() {
        this.setOverflowCount();
    }
    disconnectedCallback() {
        if (this.adapter) {
            this.adapter.destroy();
        }
        global$1.window.removeEventListener('click', this.handleOutsideClick);
        if (this.resizeObserver) {
            this.resizeObserver.unobserve(this.element);
            this.resizeObserver.disconnect();
            this.resizeObserver = undefined;
        }
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
            this.mutationObserver = undefined;
        }
    }
    render() {
        var _a, _b;
        const filtered = this.searchable && this.searchTerm !== EMPTY_VALUE;
        const hasMultipleSelections = this.multiple && this.selectedOptions.length > 1;
        return (h("div", { key: '8cc0493484291fe67ff4daf17d12fb5ff294dcc0', class: this.generateClassNames({
                multiple: hasMultipleSelections,
                filtered,
            }), part: "base" }, h(FormField, { key: '1bc954d4c1f4756ee45698386683f2db663d4a06', element: this.element, appearance: this.computedAppearance, label: this.label, helpText: this.helpText, optionalLabel: this.optionalLabel, requiredLabel: this.requiredLabel, disabled: this.disabled, invalid: this.isInvalid, validationMessage: (_b = (_a = this.adapter) === null || _a === void 0 ? void 0 : _a.getValidationMessage()) !== null && _b !== void 0 ? _b : '', labelForValue: "combobox", required: this.required }, h("div", { key: 'fedcd1618afcf6ba048ed4efdeb5619aed0d9e65', class: this.generateClassNames('input', {
                appearance: this.computedAppearance,
                placeholder: this.selectedOptions.length === 0,
                disabled: this.disabled,
                invalid: this.isInvalid,
            }), onClick: this.handleSelectClick, ref: (el) => {
                this.dropdownContainer = el;
            }, part: "select" }, h("div", { key: '3213af4fd8656fb6a8d797dadec45dccc35a8f4d', "aria-autocomplete": this.searchable ? 'list' : 'none', "aria-controls": "listbox", "aria-describedby": getAriaDescribedBy(this.isInvalid), "aria-disabled": getAriaDisabled(this.disabled), "aria-expanded": getAriaExpanded(this.isListBoxVisible), "aria-haspopup": "listbox", "aria-invalid": getAriaInvalid(this.isInvalid), "aria-labelledby": "label", "aria-required": getAriaRequired(this.required), class: this.generateClassNames('combobox'), id: "combobox", onMouseDown: (e) => this.disabled && e.preventDefault(), ref: (el) => {
                this.comboBoxElement = el;
            }, role: "combobox", tabIndex: this.getComboboxTabIndex() }, this.selectedOptions.length > 0 && (h("span", { key: 'cf26da4d2b07171d015185ae8b939d79464a1d9c', class: this.generateClassNames('sr-value') }, this.selectedOptions.map((opt) => opt.label).join(', '))), h("slot", { key: 'e6ca4692b5d000239722768176b40d06bd48c8a6', onSlotchange: this.handleValueSlotChange, name: "value", "aria-hidden": "true" }, h("cosmos-text", { key: '8b1976161729fb31178b45477349603b98556a57', appearance: this.computedAppearance, clamp: 1, class: this.generateClassNames('placeholder'), kind: "subtle", size: "small" }, this.placeholder))), h("div", { key: 'b10351a30f94222faa6269c805834642267c23b2', class: this.generateClassNames('focus-ring') }), this.overflowCount > 0 && (h("cosmos-badge", { key: 'b73b10de62b79f090ea16b2c69c16206fc1b5074', appearance: this.computedAppearance, class: this.generateClassNames('overflow-badge'), size: "small" }, "+", this.overflowCount)), this.clearable && this.selectedOptions.length > 0 && (h("cosmos-button", { key: '5c72c59623d9c516d3364a03a99be3f4fdcb44a9', "aria-label": this.clearAriaLabel, "aria-hidden": !this.clearAriaLabel, appearance: this.computedAppearance, class: this.generateClassNames('clearable-button'), kind: "tertiary", onClick: this.handleClearableClick, onKeyDown: this.handleClearableKeyDown, onMouseDown: (e) => e.preventDefault(), shape: "circle", size: "small" }, h("cosmos-icon-close", { key: 'ebed7481336843a4fb58ad4ead4f32a9a42b6eac', slot: "icon" }))), h("cosmos-icon-chevron-down", { key: '0e6e1fd83bedaf87adfa0b21ad498b253a3adfcd', class: this.generateClassNames('icon') })), h("div", { key: '793776c5fe2d04ab2c74c83f42905b7ba8f72af4', class: this.generateClassNames('listbox-container', {
                appearance: this.computedAppearance,
                open: this.isListBoxVisible,
                filtered,
            }), onClick: this.handleListBoxClick, ref: (el) => {
                this.listBoxContainerElement = el;
            } }, this.searchable && (h("div", { key: '5b340e929f657d137c0573175c5b41542ef1b1a6', class: this.generateClassNames('search-container') }, h("cosmos-input", { key: '011477fc1a3e940f3be49e43b5ea113ac5e9c025', class: this.generateClassNames('search'), clearable: true, onInputinput: this.handleSearchInput, onFocusin: this.handleSearchFocus, onFocusout: this.handleSearchBlur, placeholder: this.searchPlaceholder, ref: (el) => {
                this.searchInputElement = el;
            }, value: this.searchTerm, autocomplete: "off", appearance: this.computedAppearance }, h("cosmos-icon-search", { key: '8b2cafa1dd403bf68e44a3029b946509ca6b4b87', slot: "icon" })))), h("div", { key: 'e0a784fec418bbb8aafc6ea076a30e7a71a91739', "aria-multiselectable": this.multiple ? 'true' : null, class: this.generateClassNames('listbox'), id: "listbox", part: "options", role: "listbox", tabIndex: -1, ref: (el) => {
                this.listBoxElement = el;
            } }, h("slot", { key: '75591a971152c62c7524e588d9741eec9a95a3dc', onSlotchange: this.handleSlotChange }), this.searchable && this.adapter.getSearchResults().length === 0 && (h("cosmos-text", { key: '408c902fcbb5c6912eaefd5df9d91f323f62cce5', class: this.generateClassNames('no-filter-results'), kind: "subtle", size: "small" }, this.searchEmptyResultsText)))))));
    }
    get element() { return this; }
    static get watchers() { return {
        "value": ["handleValueChange"],
        "appearance": ["handleAppearanceChange"],
        "invalid": ["handleInvalidChange"],
        "required": ["handleRequiredChange"],
        "disabled": ["handleDisabledChange"],
        "name": ["handleNameChange"],
        "validationMessage": ["handleValidationMessageChange"],
        "searchTerm": ["handleSearchTermChange"]
    }; }
    static get style() { return cosmosSelectCss; }
}, [1, "cosmos-select", {
        "appearance": [513],
        "autofocus": [516],
        "clearable": [516],
        "clearAriaLabel": [513, "clear-aria-label"],
        "disabled": [516],
        "helpText": [513, "help-text"],
        "invalid": [516],
        "label": [513],
        "multiple": [516],
        "name": [513],
        "optionalLabel": [513, "optional-label"],
        "placeholder": [513],
        "required": [516],
        "requiredLabel": [513, "required-label"],
        "searchable": [516],
        "searchEmptyResultsText": [513, "search-empty-results-text"],
        "searchPlaceholder": [513, "search-placeholder"],
        "validationMessage": [513, "validation-message"],
        "value": [1025],
        "activeOptionElement": [32],
        "computedAppearance": [32],
        "filteredOptions": [32],
        "isInvalid": [32],
        "isKeyboardNavigated": [32],
        "isListBoxVisible": [32],
        "isSearchInputFocused": [32],
        "overflowCount": [32],
        "searchTerm": [32],
        "selectedOptions": [32],
        "inputBlur": [64],
        "inputFocus": [64],
        "inputCheckValidity": [64],
        "inputReportValidity": [64]
    }, [[0, "optionselect", "handleOptionSelect"], [0, "keydown", "handleKeyDown"], [0, "focusout", "handleFocusOut"]], {
        "value": ["handleValueChange"],
        "appearance": ["handleAppearanceChange"],
        "invalid": ["handleInvalidChange"],
        "required": ["handleRequiredChange"],
        "disabled": ["handleDisabledChange"],
        "name": ["handleNameChange"],
        "validationMessage": ["handleValidationMessageChange"],
        "searchTerm": ["handleSearchTermChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-select", "cosmos-badge", "cosmos-button", "cosmos-icon-chevron-down", "cosmos-icon-close", "cosmos-icon-search", "cosmos-icon-warning", "cosmos-input", "cosmos-select-value", "cosmos-spinner", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-select":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosSelect$1);
            }
            break;
        case "cosmos-badge":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "cosmos-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "cosmos-icon-chevron-down":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "cosmos-icon-close":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "cosmos-icon-search":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "cosmos-icon-warning":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "cosmos-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "cosmos-select-value":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "cosmos-spinner":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosSelect = CosmosSelect$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosSelect, defineCustomElement };
